"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sendspark API SDK
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.WorspaceResponseSchemaRoleEnum = exports.WorspaceResponseSchemaPlanEnum = exports.WorkspaceSubscriptionApplyDiscountResponseSchemaMessageEnum = exports.WorkspaceActivateEnterpriseFeaturesPayloadSchemaIntentEnum = exports.UserWorkspaceItemRoleEnum = exports.UserModifyPayloadLanguageCodeEnum = exports.UserLogoutPayloadSchemaDeviceEnum = exports.TranscriptPayloadSchemaLanguageEnum = exports.ThumbnailLogoShapeEnum = exports.ProspectDepurationConfigPayloadDepurationStrategyEnum = exports.PlayButtonTypeEnum = exports.PatchCampaignThumbnailSchemaLogoShapeEnum = exports.PatchCampaignThumbnailSchemaImageFormatEnum = exports.ModifyWebhookRequestPayloadSchemaModuleEnum = exports.Model88ProviderEnum = exports.Model82TypeEnum = exports.Model76TypeEnum = exports.Model3TypeEnum = exports.Model25RoleEnum = exports.Model24TypeEnum = exports.Model11TypeEnum = exports.LoggerRequestSchemaSeverityEnum = exports.DynamicsVideoCustomVariableNameEnum = exports.DefaultCampaignStylesCTAStyleEnum = exports.DefaultCampaignStylesCTATypeEnum = exports.DefaultCampaignStylesPlayButtonStyleEnum = exports.CreateWebhookRequestPayloadSchemaModuleEnum = exports.CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum = exports.CreateAiScriptsTemplatesSchemaLanguageCodeEnum = exports.CaptionLanguageCodeEnum = exports.CampaignSearchObjectResourceTypeEnum = exports.CampaignReactionPayloadTypeEnum = exports.CampaignMessageViewEnum = exports.CampaignMessageKindEnum = exports.AssetPatchUploadStatusPayloadSchemaUploadingStatusEnum = exports.AppSumoNotificationPayloadPlanIdEnum = exports.AppSumoNotificationPayloadActionEnum = exports.AiScriptGeneratorParamsSchemaNextToDoEnum = exports.AiScriptGeneratorParamsSchemaVideoForEnum = exports.AiScriptGeneratorParamsSchemaScriptTypeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var AiScriptGeneratorParamsSchemaScriptTypeEnum;
(function (AiScriptGeneratorParamsSchemaScriptTypeEnum) {
    AiScriptGeneratorParamsSchemaScriptTypeEnum["Video"] = "video";
    AiScriptGeneratorParamsSchemaScriptTypeEnum["Subject"] = "subject";
    AiScriptGeneratorParamsSchemaScriptTypeEnum["Content"] = "content";
    AiScriptGeneratorParamsSchemaScriptTypeEnum["Subjectcontent"] = "subject+content";
    AiScriptGeneratorParamsSchemaScriptTypeEnum["All"] = "all";
})(AiScriptGeneratorParamsSchemaScriptTypeEnum = exports.AiScriptGeneratorParamsSchemaScriptTypeEnum || (exports.AiScriptGeneratorParamsSchemaScriptTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AiScriptGeneratorParamsSchemaVideoForEnum;
(function (AiScriptGeneratorParamsSchemaVideoForEnum) {
    AiScriptGeneratorParamsSchemaVideoForEnum["LooksLikeAGoodFit"] = "Looks like a good fit";
    AiScriptGeneratorParamsSchemaVideoForEnum["UsesACompetitor"] = "Uses a competitor";
    AiScriptGeneratorParamsSchemaVideoForEnum["BookedADemoButDidntShow"] = "Booked a demo but didn't show";
    AiScriptGeneratorParamsSchemaVideoForEnum["AttendedAWebinar"] = "Attended a webinar";
    AiScriptGeneratorParamsSchemaVideoForEnum["EngagedWithARelevantLinkedInPost"] = "Engaged with a relevant LinkedIn post";
})(AiScriptGeneratorParamsSchemaVideoForEnum = exports.AiScriptGeneratorParamsSchemaVideoForEnum || (exports.AiScriptGeneratorParamsSchemaVideoForEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AiScriptGeneratorParamsSchemaNextToDoEnum;
(function (AiScriptGeneratorParamsSchemaNextToDoEnum) {
    AiScriptGeneratorParamsSchemaNextToDoEnum["ScheduleAMeeting"] = "Schedule a meeting";
    AiScriptGeneratorParamsSchemaNextToDoEnum["StartATrial"] = "Start a trial";
    AiScriptGeneratorParamsSchemaNextToDoEnum["VisitWebsite"] = "Visit website";
    AiScriptGeneratorParamsSchemaNextToDoEnum["TryItOut"] = "Try it out";
})(AiScriptGeneratorParamsSchemaNextToDoEnum = exports.AiScriptGeneratorParamsSchemaNextToDoEnum || (exports.AiScriptGeneratorParamsSchemaNextToDoEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AppSumoNotificationPayloadActionEnum;
(function (AppSumoNotificationPayloadActionEnum) {
    AppSumoNotificationPayloadActionEnum["Activate"] = "activate";
    AppSumoNotificationPayloadActionEnum["EnhanceTier"] = "enhance_tier";
    AppSumoNotificationPayloadActionEnum["ReduceTier"] = "reduce_tier";
    AppSumoNotificationPayloadActionEnum["Refund"] = "refund";
    AppSumoNotificationPayloadActionEnum["Update"] = "update";
})(AppSumoNotificationPayloadActionEnum = exports.AppSumoNotificationPayloadActionEnum || (exports.AppSumoNotificationPayloadActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AppSumoNotificationPayloadPlanIdEnum;
(function (AppSumoNotificationPayloadPlanIdEnum) {
    AppSumoNotificationPayloadPlanIdEnum["Tier1"] = "sendspark_tier1";
    AppSumoNotificationPayloadPlanIdEnum["Tier2"] = "sendspark_tier2";
    AppSumoNotificationPayloadPlanIdEnum["Tier3"] = "sendspark_tier3";
    AppSumoNotificationPayloadPlanIdEnum["Tier4"] = "sendspark_tier4";
    AppSumoNotificationPayloadPlanIdEnum["Tier5"] = "sendspark_tier5";
})(AppSumoNotificationPayloadPlanIdEnum = exports.AppSumoNotificationPayloadPlanIdEnum || (exports.AppSumoNotificationPayloadPlanIdEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AssetPatchUploadStatusPayloadSchemaUploadingStatusEnum;
(function (AssetPatchUploadStatusPayloadSchemaUploadingStatusEnum) {
    AssetPatchUploadStatusPayloadSchemaUploadingStatusEnum["Pending"] = "pending";
    AssetPatchUploadStatusPayloadSchemaUploadingStatusEnum["Uploading"] = "uploading";
    AssetPatchUploadStatusPayloadSchemaUploadingStatusEnum["Errored"] = "errored";
    AssetPatchUploadStatusPayloadSchemaUploadingStatusEnum["Completed"] = "completed";
})(AssetPatchUploadStatusPayloadSchemaUploadingStatusEnum = exports.AssetPatchUploadStatusPayloadSchemaUploadingStatusEnum || (exports.AssetPatchUploadStatusPayloadSchemaUploadingStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CampaignMessageKindEnum;
(function (CampaignMessageKindEnum) {
    CampaignMessageKindEnum["Text"] = "text";
    CampaignMessageKindEnum["Link"] = "link";
    CampaignMessageKindEnum["Button"] = "button";
    CampaignMessageKindEnum["Asset"] = "asset";
})(CampaignMessageKindEnum = exports.CampaignMessageKindEnum || (exports.CampaignMessageKindEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CampaignMessageViewEnum;
(function (CampaignMessageViewEnum) {
    CampaignMessageViewEnum["Rounded"] = "rounded";
    CampaignMessageViewEnum["Square"] = "square";
})(CampaignMessageViewEnum = exports.CampaignMessageViewEnum || (exports.CampaignMessageViewEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CampaignReactionPayloadTypeEnum;
(function (CampaignReactionPayloadTypeEnum) {
    CampaignReactionPayloadTypeEnum["ThumbsUp"] = "thumbsUp";
})(CampaignReactionPayloadTypeEnum = exports.CampaignReactionPayloadTypeEnum || (exports.CampaignReactionPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CampaignSearchObjectResourceTypeEnum;
(function (CampaignSearchObjectResourceTypeEnum) {
    CampaignSearchObjectResourceTypeEnum["Campaign"] = "campaign";
})(CampaignSearchObjectResourceTypeEnum = exports.CampaignSearchObjectResourceTypeEnum || (exports.CampaignSearchObjectResourceTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CaptionLanguageCodeEnum;
(function (CaptionLanguageCodeEnum) {
    CaptionLanguageCodeEnum["En"] = "en";
    CaptionLanguageCodeEnum["Es"] = "es";
    CaptionLanguageCodeEnum["De"] = "de";
    CaptionLanguageCodeEnum["Fr"] = "fr";
    CaptionLanguageCodeEnum["Pt"] = "pt";
})(CaptionLanguageCodeEnum = exports.CaptionLanguageCodeEnum || (exports.CaptionLanguageCodeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateAiScriptsTemplatesSchemaLanguageCodeEnum;
(function (CreateAiScriptsTemplatesSchemaLanguageCodeEnum) {
    CreateAiScriptsTemplatesSchemaLanguageCodeEnum["En"] = "en";
    CreateAiScriptsTemplatesSchemaLanguageCodeEnum["Es"] = "es";
    CreateAiScriptsTemplatesSchemaLanguageCodeEnum["De"] = "de";
    CreateAiScriptsTemplatesSchemaLanguageCodeEnum["Sv"] = "sv";
    CreateAiScriptsTemplatesSchemaLanguageCodeEnum["Fr"] = "fr";
    CreateAiScriptsTemplatesSchemaLanguageCodeEnum["Pt"] = "pt";
    CreateAiScriptsTemplatesSchemaLanguageCodeEnum["Nl"] = "nl";
})(CreateAiScriptsTemplatesSchemaLanguageCodeEnum = exports.CreateAiScriptsTemplatesSchemaLanguageCodeEnum || (exports.CreateAiScriptsTemplatesSchemaLanguageCodeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum;
(function (CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum) {
    CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum["En"] = "en";
    CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum["Es"] = "es";
    CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum["De"] = "de";
    CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum["Sv"] = "sv";
    CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum["Fr"] = "fr";
    CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum["Pt"] = "pt";
    CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum["Nl"] = "nl";
})(CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum = exports.CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum || (exports.CreateAiVideoScriptsTemplatesSchemaLanguageCodeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateWebhookRequestPayloadSchemaModuleEnum;
(function (CreateWebhookRequestPayloadSchemaModuleEnum) {
    CreateWebhookRequestPayloadSchemaModuleEnum["Global"] = "global";
    CreateWebhookRequestPayloadSchemaModuleEnum["Dynamics"] = "dynamics";
})(CreateWebhookRequestPayloadSchemaModuleEnum = exports.CreateWebhookRequestPayloadSchemaModuleEnum || (exports.CreateWebhookRequestPayloadSchemaModuleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DefaultCampaignStylesPlayButtonStyleEnum;
(function (DefaultCampaignStylesPlayButtonStyleEnum) {
    DefaultCampaignStylesPlayButtonStyleEnum["Solid"] = "solid";
    DefaultCampaignStylesPlayButtonStyleEnum["Outline"] = "outline";
})(DefaultCampaignStylesPlayButtonStyleEnum = exports.DefaultCampaignStylesPlayButtonStyleEnum || (exports.DefaultCampaignStylesPlayButtonStyleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DefaultCampaignStylesCTATypeEnum;
(function (DefaultCampaignStylesCTATypeEnum) {
    DefaultCampaignStylesCTATypeEnum["Rounded"] = "rounded";
    DefaultCampaignStylesCTATypeEnum["Square"] = "square";
})(DefaultCampaignStylesCTATypeEnum = exports.DefaultCampaignStylesCTATypeEnum || (exports.DefaultCampaignStylesCTATypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DefaultCampaignStylesCTAStyleEnum;
(function (DefaultCampaignStylesCTAStyleEnum) {
    DefaultCampaignStylesCTAStyleEnum["Solid"] = "solid";
    DefaultCampaignStylesCTAStyleEnum["Outline"] = "outline";
})(DefaultCampaignStylesCTAStyleEnum = exports.DefaultCampaignStylesCTAStyleEnum || (exports.DefaultCampaignStylesCTAStyleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DynamicsVideoCustomVariableNameEnum;
(function (DynamicsVideoCustomVariableNameEnum) {
    DynamicsVideoCustomVariableNameEnum["Companyname"] = "companyname";
    DynamicsVideoCustomVariableNameEnum["Firstname"] = "firstname";
    DynamicsVideoCustomVariableNameEnum["Jobtitle"] = "jobtitle";
})(DynamicsVideoCustomVariableNameEnum = exports.DynamicsVideoCustomVariableNameEnum || (exports.DynamicsVideoCustomVariableNameEnum = {}));
/**
    * @export
    * @enum {string}
    */
var LoggerRequestSchemaSeverityEnum;
(function (LoggerRequestSchemaSeverityEnum) {
    LoggerRequestSchemaSeverityEnum["DEFAULT"] = "DEFAULT";
    LoggerRequestSchemaSeverityEnum["DEBUG"] = "DEBUG";
    LoggerRequestSchemaSeverityEnum["INFO"] = "INFO";
    LoggerRequestSchemaSeverityEnum["NOTICE"] = "NOTICE";
    LoggerRequestSchemaSeverityEnum["WARNING"] = "WARNING";
    LoggerRequestSchemaSeverityEnum["ERROR"] = "ERROR";
    LoggerRequestSchemaSeverityEnum["CRITICAL"] = "CRITICAL";
    LoggerRequestSchemaSeverityEnum["ALERT"] = "ALERT";
    LoggerRequestSchemaSeverityEnum["EMERGENCY"] = "EMERGENCY";
})(LoggerRequestSchemaSeverityEnum = exports.LoggerRequestSchemaSeverityEnum || (exports.LoggerRequestSchemaSeverityEnum = {}));
/**
    * @export
    * @enum {string}
    */
var Model11TypeEnum;
(function (Model11TypeEnum) {
    Model11TypeEnum["CodeSnippets"] = "crm-code-snippets";
    Model11TypeEnum["DynamicVariables"] = "crm-dynamic-variables";
})(Model11TypeEnum = exports.Model11TypeEnum || (exports.Model11TypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var Model24TypeEnum;
(function (Model24TypeEnum) {
    Model24TypeEnum["EmbedCalendar"] = "embed-calendar";
})(Model24TypeEnum = exports.Model24TypeEnum || (exports.Model24TypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var Model25RoleEnum;
(function (Model25RoleEnum) {
    Model25RoleEnum["Owner"] = "owner";
    Model25RoleEnum["Member"] = "member";
    Model25RoleEnum["Admin"] = "admin";
})(Model25RoleEnum = exports.Model25RoleEnum || (exports.Model25RoleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var Model3TypeEnum;
(function (Model3TypeEnum) {
    Model3TypeEnum["CrmDynamicVariables"] = "crm-dynamic-variables";
})(Model3TypeEnum = exports.Model3TypeEnum || (exports.Model3TypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var Model76TypeEnum;
(function (Model76TypeEnum) {
    Model76TypeEnum["InstantIntegrations"] = "instant-integrations";
})(Model76TypeEnum = exports.Model76TypeEnum || (exports.Model76TypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var Model82TypeEnum;
(function (Model82TypeEnum) {
    Model82TypeEnum["None"] = "none";
    Model82TypeEnum["Solid"] = "solid";
    Model82TypeEnum["Outline"] = "outline";
    Model82TypeEnum["Basic"] = "basic";
})(Model82TypeEnum = exports.Model82TypeEnum || (exports.Model82TypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var Model88ProviderEnum;
(function (Model88ProviderEnum) {
    Model88ProviderEnum["Sendspark"] = "sendspark";
    Model88ProviderEnum["Custom"] = "custom";
})(Model88ProviderEnum = exports.Model88ProviderEnum || (exports.Model88ProviderEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ModifyWebhookRequestPayloadSchemaModuleEnum;
(function (ModifyWebhookRequestPayloadSchemaModuleEnum) {
    ModifyWebhookRequestPayloadSchemaModuleEnum["Global"] = "global";
    ModifyWebhookRequestPayloadSchemaModuleEnum["Dynamics"] = "dynamics";
})(ModifyWebhookRequestPayloadSchemaModuleEnum = exports.ModifyWebhookRequestPayloadSchemaModuleEnum || (exports.ModifyWebhookRequestPayloadSchemaModuleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PatchCampaignThumbnailSchemaImageFormatEnum;
(function (PatchCampaignThumbnailSchemaImageFormatEnum) {
    PatchCampaignThumbnailSchemaImageFormatEnum["Animated"] = "animated";
    PatchCampaignThumbnailSchemaImageFormatEnum["Static"] = "static";
})(PatchCampaignThumbnailSchemaImageFormatEnum = exports.PatchCampaignThumbnailSchemaImageFormatEnum || (exports.PatchCampaignThumbnailSchemaImageFormatEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PatchCampaignThumbnailSchemaLogoShapeEnum;
(function (PatchCampaignThumbnailSchemaLogoShapeEnum) {
    PatchCampaignThumbnailSchemaLogoShapeEnum["Square"] = "square";
    PatchCampaignThumbnailSchemaLogoShapeEnum["SquareRounded"] = "square rounded";
    PatchCampaignThumbnailSchemaLogoShapeEnum["Circle"] = "circle";
})(PatchCampaignThumbnailSchemaLogoShapeEnum = exports.PatchCampaignThumbnailSchemaLogoShapeEnum || (exports.PatchCampaignThumbnailSchemaLogoShapeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PlayButtonTypeEnum;
(function (PlayButtonTypeEnum) {
    PlayButtonTypeEnum["None"] = "none";
    PlayButtonTypeEnum["Solid"] = "solid";
    PlayButtonTypeEnum["Outline"] = "outline";
    PlayButtonTypeEnum["Basic"] = "basic";
})(PlayButtonTypeEnum = exports.PlayButtonTypeEnum || (exports.PlayButtonTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ProspectDepurationConfigPayloadDepurationStrategyEnum;
(function (ProspectDepurationConfigPayloadDepurationStrategyEnum) {
    ProspectDepurationConfigPayloadDepurationStrategyEnum["FirstValid"] = "keep-first-valid";
    ProspectDepurationConfigPayloadDepurationStrategyEnum["LastValid"] = "keep-last-valid";
})(ProspectDepurationConfigPayloadDepurationStrategyEnum = exports.ProspectDepurationConfigPayloadDepurationStrategyEnum || (exports.ProspectDepurationConfigPayloadDepurationStrategyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ThumbnailLogoShapeEnum;
(function (ThumbnailLogoShapeEnum) {
    ThumbnailLogoShapeEnum["Square"] = "square";
    ThumbnailLogoShapeEnum["SquareRounded"] = "square rounded";
    ThumbnailLogoShapeEnum["Circle"] = "circle";
})(ThumbnailLogoShapeEnum = exports.ThumbnailLogoShapeEnum || (exports.ThumbnailLogoShapeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TranscriptPayloadSchemaLanguageEnum;
(function (TranscriptPayloadSchemaLanguageEnum) {
    TranscriptPayloadSchemaLanguageEnum["En"] = "en";
})(TranscriptPayloadSchemaLanguageEnum = exports.TranscriptPayloadSchemaLanguageEnum || (exports.TranscriptPayloadSchemaLanguageEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserLogoutPayloadSchemaDeviceEnum;
(function (UserLogoutPayloadSchemaDeviceEnum) {
    UserLogoutPayloadSchemaDeviceEnum["Mobile"] = "mobile";
    UserLogoutPayloadSchemaDeviceEnum["Desktop"] = "desktop";
})(UserLogoutPayloadSchemaDeviceEnum = exports.UserLogoutPayloadSchemaDeviceEnum || (exports.UserLogoutPayloadSchemaDeviceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserModifyPayloadLanguageCodeEnum;
(function (UserModifyPayloadLanguageCodeEnum) {
    UserModifyPayloadLanguageCodeEnum["En"] = "en";
    UserModifyPayloadLanguageCodeEnum["Es"] = "es";
    UserModifyPayloadLanguageCodeEnum["De"] = "de";
    UserModifyPayloadLanguageCodeEnum["Fr"] = "fr";
    UserModifyPayloadLanguageCodeEnum["Pt"] = "pt";
})(UserModifyPayloadLanguageCodeEnum = exports.UserModifyPayloadLanguageCodeEnum || (exports.UserModifyPayloadLanguageCodeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserWorkspaceItemRoleEnum;
(function (UserWorkspaceItemRoleEnum) {
    UserWorkspaceItemRoleEnum["Owner"] = "owner";
    UserWorkspaceItemRoleEnum["Admin"] = "admin";
    UserWorkspaceItemRoleEnum["Member"] = "member";
    UserWorkspaceItemRoleEnum["User"] = "user";
})(UserWorkspaceItemRoleEnum = exports.UserWorkspaceItemRoleEnum || (exports.UserWorkspaceItemRoleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WorkspaceActivateEnterpriseFeaturesPayloadSchemaIntentEnum;
(function (WorkspaceActivateEnterpriseFeaturesPayloadSchemaIntentEnum) {
    WorkspaceActivateEnterpriseFeaturesPayloadSchemaIntentEnum["AuditLogs"] = "audit_logs";
    WorkspaceActivateEnterpriseFeaturesPayloadSchemaIntentEnum["DomainVerification"] = "domain_verification";
    WorkspaceActivateEnterpriseFeaturesPayloadSchemaIntentEnum["Dsync"] = "dsync";
    WorkspaceActivateEnterpriseFeaturesPayloadSchemaIntentEnum["LogStreams"] = "log_streams";
    WorkspaceActivateEnterpriseFeaturesPayloadSchemaIntentEnum["Sso"] = "sso";
})(WorkspaceActivateEnterpriseFeaturesPayloadSchemaIntentEnum = exports.WorkspaceActivateEnterpriseFeaturesPayloadSchemaIntentEnum || (exports.WorkspaceActivateEnterpriseFeaturesPayloadSchemaIntentEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WorkspaceSubscriptionApplyDiscountResponseSchemaMessageEnum;
(function (WorkspaceSubscriptionApplyDiscountResponseSchemaMessageEnum) {
    WorkspaceSubscriptionApplyDiscountResponseSchemaMessageEnum["DiscountApplied"] = "Discount applied";
})(WorkspaceSubscriptionApplyDiscountResponseSchemaMessageEnum = exports.WorkspaceSubscriptionApplyDiscountResponseSchemaMessageEnum || (exports.WorkspaceSubscriptionApplyDiscountResponseSchemaMessageEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WorspaceResponseSchemaPlanEnum;
(function (WorspaceResponseSchemaPlanEnum) {
    WorspaceResponseSchemaPlanEnum["Free"] = "free";
    WorspaceResponseSchemaPlanEnum["Pro"] = "pro";
    WorspaceResponseSchemaPlanEnum["Starter"] = "starter";
    WorspaceResponseSchemaPlanEnum["Rapid"] = "rapid";
    WorspaceResponseSchemaPlanEnum["Custom"] = "custom";
    WorspaceResponseSchemaPlanEnum["Business"] = "business";
    WorspaceResponseSchemaPlanEnum["Scale"] = "scale";
    WorspaceResponseSchemaPlanEnum["SendsparkTier1"] = "sendspark_tier1";
    WorspaceResponseSchemaPlanEnum["SendsparkTier2"] = "sendspark_tier2";
    WorspaceResponseSchemaPlanEnum["SendsparkTier3"] = "sendspark_tier3";
    WorspaceResponseSchemaPlanEnum["SendsparkTier4"] = "sendspark_tier4";
    WorspaceResponseSchemaPlanEnum["SendsparkTier5"] = "sendspark_tier5";
})(WorspaceResponseSchemaPlanEnum = exports.WorspaceResponseSchemaPlanEnum || (exports.WorspaceResponseSchemaPlanEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WorspaceResponseSchemaRoleEnum;
(function (WorspaceResponseSchemaRoleEnum) {
    WorspaceResponseSchemaRoleEnum["Owner"] = "owner";
    WorspaceResponseSchemaRoleEnum["Admin"] = "admin";
    WorspaceResponseSchemaRoleEnum["Member"] = "member";
    WorspaceResponseSchemaRoleEnum["User"] = "user";
})(WorspaceResponseSchemaRoleEnum = exports.WorspaceResponseSchemaRoleEnum || (exports.WorspaceResponseSchemaRoleEnum = {}));
/**
 * DefaultApi - axios parameter creator
 * @export
 */
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Activate enterprise features for workspace
         * @summary Activate enterprise features for workspace
         * @param {string} workspaceId
         * @param {WorkspaceActivateEnterpriseFeaturesPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateWorkspaceEnterpriseFeatures: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling activateWorkspaceEnterpriseFeatures.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/enterprise-features/activate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add password to campaign.access
         * @param {string} campaignId
         * @param {PayloadCampaignPassword} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCampaignPassword: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling addCampaignPassword.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/access"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid automated workflow user to be created first. Protected route.
         * @summary Performs a connection between an automated workflows user and our Sendspark app in the automated workflow provider.
         * @param {string} xAwToken A custom header for authentication purposes
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConnectionUserAutomatedWorkflow: function (xAwToken, workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'xAwToken' is not null or undefined
                            if (xAwToken === null || xAwToken === undefined) {
                                throw new base_1.RequiredError('xAwToken', 'Required parameter xAwToken was null or undefined when calling addConnectionUserAutomatedWorkflow.');
                            }
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling addConnectionUserAutomatedWorkflow.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/automated-workflows/connections"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (xAwToken !== undefined && xAwToken !== null) {
                                localVarHeaderParameter['x-aw-token'] = String(xAwToken);
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * The amount of transactions (count) must be a mutiple of 100
         * @summary Add extra transaction to a user in albato
         * @param {string} workspaceId
         * @param {AddTransactionToBillingPlanSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransactionToBillingPlan: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling addTransactionToBillingPlan.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/automated-workflows/billing/add-transaction"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Requires authentication. Protected route.
         * @summary Assign billing plans to the user for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {AutomatedWorkflowsPlanAssignmentBodyPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignAutomatedWorkflowBillingPlans: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling assignAutomatedWorkflowBillingPlans.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/automated-workflows/billing"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth callback route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authCallback: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/auth/callback";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth login resolve route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginResolve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/auth/resolve/login";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth signup resolve route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSignupResolve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/auth/resolve/signup";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Do not support video update
         * @summary Use this route to update an campaign meta text data
         * @param {string} campaignId
         * @param {CampaignMetaPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignMetaUpdate: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling campaignMetaUpdate.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/meta"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generates email, landing page and video scripts for users based on base templates.
         * @summary AI Scripts templates generator.
         * @param {CreateAiScriptsTemplatesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiScriptsTemplates: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/ai/create-ai-scripts-templates";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generates a video script to be used in a teleprompter generated by AI
         * @summary AI Video script templates generator
         * @param {CreateAiVideoScriptsTemplatesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiVideoScriptsTemplate: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/ai/video-script-template-generator";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to Create API Key for workspace.
         * @summary Create Public API key for workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeys: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling createApiKeys.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/apikeys"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a Gif for a campaign based on video
         * @summary Create a Gif for a campaign based on video
         * @param {string} assetId
         * @param {any} file
         * @param {number} [start]
         * @param {number} [end]
         * @param {string} [width]
         * @param {string} [height]
         * @param {string} [fps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaignIdGif: function (assetId, file, start, end, width, height, fps, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'assetId' is not null or undefined
                            if (assetId === null || assetId === undefined) {
                                throw new base_1.RequiredError('assetId', 'Required parameter assetId was null or undefined when calling createCampaignIdGif.');
                            }
                            // verify required parameter 'file' is not null or undefined
                            if (file === null || file === undefined) {
                                throw new base_1.RequiredError('file', 'Required parameter file was null or undefined when calling createCampaignIdGif.');
                            }
                            localVarPath = "/v1/assets/{assetId}/gif"
                                .replace("{".concat("assetId", "}"), encodeURIComponent(String(assetId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new FormData();
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (start !== undefined) {
                                localVarQueryParameter['start'] = start;
                            }
                            if (end !== undefined) {
                                localVarQueryParameter['end'] = end;
                            }
                            if (width !== undefined) {
                                localVarQueryParameter['width'] = width;
                            }
                            if (height !== undefined) {
                                localVarQueryParameter['height'] = height;
                            }
                            if (fps !== undefined) {
                                localVarQueryParameter['fps'] = fps;
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to Create Secret for API Key.
         * @summary Create Secret for API key.
         * @param {string} workspaceId
         * @param {string} apikeyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecretFromApiKeys: function (workspaceId, apikeyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling createSecretFromApiKeys.');
                            }
                            // verify required parameter 'apikeyId' is not null or undefined
                            if (apikeyId === null || apikeyId === undefined) {
                                throw new base_1.RequiredError('apikeyId', 'Required parameter apikeyId was null or undefined when calling createSecretFromApiKeys.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/apikeys/{apikeyId}/secrets"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("apikeyId", "}"), encodeURIComponent(String(apikeyId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create Asset for video request
         * @summary Create Asset for video request
         * @param {string} requestId
         * @param {VideoRequestAssetCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoRequestAssetByRequestId: function (requestId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'requestId' is not null or undefined
                            if (requestId === null || requestId === undefined) {
                                throw new base_1.RequiredError('requestId', 'Required parameter requestId was null or undefined when calling createVideoRequestAssetByRequestId.');
                            }
                            localVarPath = "/v1/video-request/{requestId}/asset"
                                .replace("{".concat("requestId", "}"), encodeURIComponent(String(requestId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create voice cloning for Dynamics Campaign in folder
         * @summary Create voice cloning for Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadCreateDynamicsVoiceCloningSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoiceCloningForDynamicsCampaign: function (workspaceId, dynamicId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling createVoiceCloningForDynamicsCampaign.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling createVoiceCloningForDynamicsCampaign.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicId}/clone-voice"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deactivate enterprise features for workspace
         * @summary Deactivate enterprise features for workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWorkspaceEnterpriseFeatures: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deactivateWorkspaceEnterpriseFeatures.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/enterprise-features/deactivate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to delete Apikey for workspace.
         * @summary Delete Apikey for workspace
         * @param {string} workspaceId
         * @param {string} apikeyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApikey: function (workspaceId, apikeyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteApikey.');
                            }
                            // verify required parameter 'apikeyId' is not null or undefined
                            if (apikeyId === null || apikeyId === undefined) {
                                throw new base_1.RequiredError('apikeyId', 'Required parameter apikeyId was null or undefined when calling deleteApikey.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/apikeys/{apikeyId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("apikeyId", "}"), encodeURIComponent(String(apikeyId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete assets by ID
         * @summary Delete assets Route
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetsId: function (assetId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'assetId' is not null or undefined
                            if (assetId === null || assetId === undefined) {
                                throw new base_1.RequiredError('assetId', 'Required parameter assetId was null or undefined when calling deleteAssetsId.');
                            }
                            localVarPath = "/v1/assets/{assetId}"
                                .replace("{".concat("assetId", "}"), encodeURIComponent(String(assetId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to Delete their workspace-leve auth connections route.
         * @summary Delete workspace auth connections Route
         * @param {string} workspaceId
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuthConnections: function (workspaceId, integrationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteAuthConnections.');
                            }
                            // verify required parameter 'integrationId' is not null or undefined
                            if (integrationId === null || integrationId === undefined) {
                                throw new base_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling deleteAuthConnections.');
                            }
                            localVarPath = "/v1/integrations/{workspaceId}/auth-connections/{integrationId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("integrationId", "}"), encodeURIComponent(String(integrationId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a Gif for a campaign based on video
         * @summary Delete a Gif for a campaign based on video
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignIdGif: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling deleteCampaignIdGif.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/gif"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete password from campaign.access
         * @param {string} campaignId
         * @param {string} passwordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignPassword: function (campaignId, passwordId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling deleteCampaignPassword.');
                            }
                            // verify required parameter 'passwordId' is not null or undefined
                            if (passwordId === null || passwordId === undefined) {
                                throw new base_1.RequiredError('passwordId', 'Required parameter passwordId was null or undefined when calling deleteCampaignPassword.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/access/{passwordId}"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)))
                                .replace("{".concat("passwordId", "}"), encodeURIComponent(String(passwordId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete the Campaign by the campaignId
         * @summary Delete Campaign By Id Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignsId: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling deleteCampaignsId.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete the custom domain by the workspaceId
         * @summary Delete custom domain by workspace id route
         * @param {string} workspaceId
         * @param {string} domainName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomDomainByWorkspaceId: function (workspaceId, domainName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteCustomDomainByWorkspaceId.');
                            }
                            // verify required parameter 'domainName' is not null or undefined
                            if (domainName === null || domainName === undefined) {
                                throw new base_1.RequiredError('domainName', 'Required parameter domainName was null or undefined when calling deleteCustomDomainByWorkspaceId.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/custom-domain/{domainName}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("domainName", "}"), encodeURIComponent(String(domainName)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete Dynamics Campaign and folder
         * @summary Delete Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {boolean} [force]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamics: function (workspaceId, dynamicsId, force, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteDynamics.');
                            }
                            // verify required parameter 'dynamicsId' is not null or undefined
                            if (dynamicsId === null || dynamicsId === undefined) {
                                throw new base_1.RequiredError('dynamicsId', 'Required parameter dynamicsId was null or undefined when calling deleteDynamics.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicsId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicsId", "}"), encodeURIComponent(String(dynamicsId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (force !== undefined) {
                                localVarQueryParameter['force'] = force;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete folder by id
         * @summary Folder Delete Route
         * @param {string} folderId
         * @param {RequestPayloadDeleteFolderSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFoldersFolderid: function (folderId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling deleteFoldersFolderid.');
                            }
                            localVarPath = "/v1/folders/{folderId}"
                                .replace("{".concat("folderId", "}"), encodeURIComponent(String(folderId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete animated and static thumbnails generated by the share faster feature
         * @summary Delete custom thumbnails for an assetId
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGifByAssetId: function (assetId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'assetId' is not null or undefined
                            if (assetId === null || assetId === undefined) {
                                throw new base_1.RequiredError('assetId', 'Required parameter assetId was null or undefined when calling deleteGifByAssetId.');
                            }
                            localVarPath = "/v1/assets/{assetId}/gif"
                                .replace("{".concat("assetId", "}"), encodeURIComponent(String(assetId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete the Campaigns by the campaignId. Requires folderId to validate user ownership
         * @summary Delete Multiple Campaigns by Id Route
         * @param {string} folderId
         * @param {RequestPayloadDeleteCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMultipleCampaignsById: function (folderId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling deleteMultipleCampaignsById.');
                            }
                            localVarPath = "/v1/folders/{folderId}/campaigns"
                                .replace("{".concat("folderId", "}"), encodeURIComponent(String(folderId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete prospect from dynamic video
         * @summary Delete prospect from dynamic video
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {boolean} [deleteAll]
         * @param {DynamicDeleteProspectPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProspectDynamics: function (workspaceId, dynamicsId, deleteAll, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteProspectDynamics.');
                            }
                            // verify required parameter 'dynamicsId' is not null or undefined
                            if (dynamicsId === null || dynamicsId === undefined) {
                                throw new base_1.RequiredError('dynamicsId', 'Required parameter dynamicsId was null or undefined when calling deleteProspectDynamics.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicsId}/prospects"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicsId", "}"), encodeURIComponent(String(dynamicsId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (deleteAll !== undefined) {
                                localVarQueryParameter['deleteAll'] = deleteAll;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete Reaction by ID
         * @summary Delete Reaction Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReactionsId: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteReactionsId.');
                            }
                            localVarPath = "/v1/reactions/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to delete Secret Token for API key.
         * @summary Delete Secret Token for API key.
         * @param {string} workspaceId
         * @param {string} apikeyId
         * @param {string} secretId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecretFromApikey: function (workspaceId, apikeyId, secretId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteSecretFromApikey.');
                            }
                            // verify required parameter 'apikeyId' is not null or undefined
                            if (apikeyId === null || apikeyId === undefined) {
                                throw new base_1.RequiredError('apikeyId', 'Required parameter apikeyId was null or undefined when calling deleteSecretFromApikey.');
                            }
                            // verify required parameter 'secretId' is not null or undefined
                            if (secretId === null || secretId === undefined) {
                                throw new base_1.RequiredError('secretId', 'Required parameter secretId was null or undefined when calling deleteSecretFromApikey.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/apikeys/{apikeyId}/secrets/{secretId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("apikeyId", "}"), encodeURIComponent(String(apikeyId)))
                                .replace("{".concat("secretId", "}"), encodeURIComponent(String(secretId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Deletes an user for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAutomatedWorkflow: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteUserAutomatedWorkflow.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/automated-workflows/auth"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to Delete their private site connections route.
         * @summary Delete user private site connections Route
         * @param {string} userId
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserSiteConnections: function (userId, integrationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            if (userId === null || userId === undefined) {
                                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling deleteUserSiteConnections.');
                            }
                            // verify required parameter 'integrationId' is not null or undefined
                            if (integrationId === null || integrationId === undefined) {
                                throw new base_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling deleteUserSiteConnections.');
                            }
                            localVarPath = "/v1/users/{userId}/site-connections/{integrationId}"
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                                .replace("{".concat("integrationId", "}"), encodeURIComponent(String(integrationId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1GoogleLogin: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/google/login";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete Webhook by ID
         * @summary Delete Webhook by ID
         * @param {string} workspaceId
         * @param {string} webhookId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebhookById: function (workspaceId, webhookId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteWebhookById.');
                            }
                            // verify required parameter 'webhookId' is not null or undefined
                            if (webhookId === null || webhookId === undefined) {
                                throw new base_1.RequiredError('webhookId', 'Required parameter webhookId was null or undefined when calling deleteWebhookById.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/webhooks/{webhookId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("webhookId", "}"), encodeURIComponent(String(webhookId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Workspace Integration by integration id
         * @param {string} workspaceId
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspaceIntegrations: function (workspaceId, integrationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteWorkspaceIntegrations.');
                            }
                            // verify required parameter 'integrationId' is not null or undefined
                            if (integrationId === null || integrationId === undefined) {
                                throw new base_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling deleteWorkspaceIntegrations.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/integrations/{integrationId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("integrationId", "}"), encodeURIComponent(String(integrationId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete workspace template
         * @summary Delete workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspaceTemplate: function (workspaceId, templateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteWorkspaceTemplate.');
                            }
                            // verify required parameter 'templateId' is not null or undefined
                            if (templateId === null || templateId === undefined) {
                                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling deleteWorkspaceTemplate.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/templates/{templateId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("templateId", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete workspace by id
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspacesWorkspaceid: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteWorkspacesWorkspaceid.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Remove an invited member from the workspace.
         * @summary Remove an invited member from the workspace.
         * @param {string} workspaceId
         * @param {string} invitedUserId
         * @param {RequestWorkspaceMembersDeletePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspacesWorkspaceidMembersInviteduserid: function (workspaceId, invitedUserId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling deleteWorkspacesWorkspaceidMembersInviteduserid.');
                            }
                            // verify required parameter 'invitedUserId' is not null or undefined
                            if (invitedUserId === null || invitedUserId === undefined) {
                                throw new base_1.RequiredError('invitedUserId', 'Required parameter invitedUserId was null or undefined when calling deleteWorkspacesWorkspaceidMembersInviteduserid.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/members/{invitedUserId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("invitedUserId", "}"), encodeURIComponent(String(invitedUserId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Duplicate workspace template
         * @summary Duplicate workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateWorkspaceTemplate: function (workspaceId, templateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling duplicateWorkspaceTemplate.');
                            }
                            // verify required parameter 'templateId' is not null or undefined
                            if (templateId === null || templateId === undefined) {
                                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling duplicateWorkspaceTemplate.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/templates/{templateId}/duplicate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("templateId", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Campaign identifier needs to be the share id of the campaign.
         * @summary Route to generate JWT token based on the password input to access a protected campaign
         * @param {string} shareId
         * @param {PayloadCampaignPassword} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuthTokenForCampaignAccess: function (shareId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'shareId' is not null or undefined
                            if (shareId === null || shareId === undefined) {
                                throw new base_1.RequiredError('shareId', 'Required parameter shareId was null or undefined when calling generateAuthTokenForCampaignAccess.');
                            }
                            localVarPath = "/v1/campaigns/{shareId}/access/generate"
                                .replace("{".concat("shareId", "}"), encodeURIComponent(String(shareId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to get all API keys for a workspace.
         * @summary Get all API keys for a workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeys: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getApiKeys.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/apikeys"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Gets Auth URL.
         * @summary Get Auth URL Route
         * @param {'sign-in' | 'sign-up'} screenHint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthURL: function (screenHint, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'screenHint' is not null or undefined
                            if (screenHint === null || screenHint === undefined) {
                                throw new base_1.RequiredError('screenHint', 'Required parameter screenHint was null or undefined when calling getAuthURL.');
                            }
                            localVarPath = "/v1/auth";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (screenHint !== undefined) {
                                localVarQueryParameter['screenHint'] = screenHint;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Requires authentication. Protected route.
         * @summary Get billing plans for the Automated Workflows provider. Returns a list of available plans assignable to users.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutomatedWorkflowBillingPlans: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getAutomatedWorkflowBillingPlans.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/automated-workflows/billing"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Used for development purposes
         * @summary Get billing provider route
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingUuid: function (uuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'uuid' is not null or undefined
                            if (uuid === null || uuid === undefined) {
                                throw new base_1.RequiredError('uuid', 'Required parameter uuid was null or undefined when calling getBillingUuid.');
                            }
                            localVarPath = "/v1/billing/{uuid}"
                                .replace("{".concat("uuid", "}"), encodeURIComponent(String(uuid)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get brand persona for a specific workspace
         * @summary Get brand persona for a specific workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandPersona: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getBrandPersona.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/brand-persona"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get campaign.access
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignAccess: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getCampaignAccess.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/access"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Check if its possible create a campaign
         * @summary Campaign checkpoint
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignCheckpoint: function (folderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling getCampaignCheckpoint.');
                            }
                            localVarPath = "/v1/campaigns/{folderId}/checkpoint"
                                .replace("{".concat("folderId", "}"), encodeURIComponent(String(folderId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a Gif for a campaign
         * @summary Get a Gif for a campaign
         * @param {string} campaignId
         * @param {number} [start]
         * @param {number} [end]
         * @param {string} [width]
         * @param {string} [height]
         * @param {string} [fps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignIdGif: function (campaignId, start, end, width, height, fps, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getCampaignIdGif.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/gif"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (start !== undefined) {
                                localVarQueryParameter['start'] = start;
                            }
                            if (end !== undefined) {
                                localVarQueryParameter['end'] = end;
                            }
                            if (width !== undefined) {
                                localVarQueryParameter['width'] = width;
                            }
                            if (height !== undefined) {
                                localVarQueryParameter['height'] = height;
                            }
                            if (fps !== undefined) {
                                localVarQueryParameter['fps'] = fps;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Used for previews on Dynamic Edit page
         * @summary Get campaign preview for dynamic campaign.
         * @param {string} campaignId
         * @param {string} dynamicId
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignPreviewForDv: function (campaignId, dynamicId, workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getCampaignPreviewForDv.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling getCampaignPreviewForDv.');
                            }
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getCampaignPreviewForDv.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicId}/campaign-preview/{campaignId}"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)))
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Campaign stats
         * @summary Get Campaign stats
         * @param {string} campaignId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignStats: function (campaignId, limit, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getCampaignStats.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/stats"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Campaign stats in CSV file
         * @summary Get Campaign stats in CSV file
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignStatsCsv: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getCampaignStatsCsv.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/stats/csv"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign thumbnail by the campaignId
         * @summary Campaign thumbnail by campaign id
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignThumbnail: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getCampaignThumbnail.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/thumbnail"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign thumbnail urls by the campaignId
         * @summary Campaign thumbnail urls by campaign id
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignThumbnailsUrls: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getCampaignThumbnailsUrls.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/thumbnails-urls"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the Reactions for a campaign
         * @summary Campaign Reactions Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsCampaignidReactions: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getCampaignsCampaignidReactions.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/reactions"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} campaignId
         * @param {boolean} [useProtectedThumbnail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsId: function (campaignId, useProtectedThumbnail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getCampaignsId.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (useProtectedThumbnail !== undefined) {
                                localVarQueryParameter['useProtectedThumbnail'] = useProtectedThumbnail;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign public information by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} id
         * @param {boolean} [sendsparkAppRendering]
         * @param {string} [host]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsIdPublic: function (id, sendsparkAppRendering, host, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getCampaignsIdPublic.');
                            }
                            localVarPath = "/v1/campaigns/{id}/public"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (sendsparkAppRendering !== undefined) {
                                localVarQueryParameter['sendsparkAppRendering'] = sendsparkAppRendering;
                            }
                            if (host !== undefined) {
                                localVarQueryParameter['host'] = host;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a oembed json
         * @summary Generate Oembed Service
         * @param {string} url
         * @param {string} [queryParam]
         * @param {number} [maxheight]
         * @param {string} [companyname]
         * @param {string} [firstname]
         * @param {string} [jobtitle]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsOembed: function (url, queryParam, maxheight, companyname, firstname, jobtitle, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'url' is not null or undefined
                            if (url === null || url === undefined) {
                                throw new base_1.RequiredError('url', 'Required parameter url was null or undefined when calling getCampaignsOembed.');
                            }
                            localVarPath = "/v1/campaigns/oembed";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (url !== undefined) {
                                localVarQueryParameter['url'] = url;
                            }
                            if (queryParam !== undefined) {
                                localVarQueryParameter['queryParam'] = queryParam;
                            }
                            if (maxheight !== undefined) {
                                localVarQueryParameter['maxheight'] = maxheight;
                            }
                            if (companyname !== undefined) {
                                localVarQueryParameter['companyname'] = companyname;
                            }
                            if (firstname !== undefined) {
                                localVarQueryParameter['firstname'] = firstname;
                            }
                            if (jobtitle !== undefined) {
                                localVarQueryParameter['jobtitle'] = jobtitle;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all campaign templates by a folder id
         * @summary Campaigns Templates Route
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsTemplates: function (offset, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/campaigns/templates";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get captions availables
         * @summary Get captions availables
         * @param {string} [assetId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaptionsAvailables: function (assetId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/captions";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (assetId !== undefined) {
                                localVarQueryParameter['assetId'] = assetId;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid automated workflow user to be created first. Protected route.
         * @summary Get all connections from an user in the automated workflow provider.
         * @param {string} xAwToken A custom header for authentication purposes
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionUserAutomatedWorkflow: function (xAwToken, workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'xAwToken' is not null or undefined
                            if (xAwToken === null || xAwToken === undefined) {
                                throw new base_1.RequiredError('xAwToken', 'Required parameter xAwToken was null or undefined when calling getConnectionUserAutomatedWorkflow.');
                            }
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getConnectionUserAutomatedWorkflow.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/automated-workflows/connections"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (xAwToken !== undefined && xAwToken !== null) {
                                localVarHeaderParameter['x-aw-token'] = String(xAwToken);
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get available CRM dynamic variables
         * @summary Get available CRM dynamic variables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrmDynamicVariables: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/integrations/crm-dynamic-variables";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get crm shortcuts list, only current selected by user
         * @summary Get crm shortcuts list, only current selected by user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrmShortcutsSelectedUserId: function (userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            if (userId === null || userId === undefined) {
                                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getCrmShortcutsSelectedUserId.');
                            }
                            localVarPath = "/v1/users/{userId}/crm-shortcuts"
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign thumbnail information by the campaignId
         * @summary Campaign Thumbnail Info Get Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDvv2V1CampaignsCampaignidThumbnailinfo: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling getDvv2V1CampaignsCampaignidThumbnailinfo.');
                            }
                            localVarPath = "/dv-v2/v1/campaigns/{campaignId}/thumbnail-info"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Dynamic Campaign stats
         * @summary Get Dynamic Campaign stats
         * @param {string} dynamicId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicCampaignStats: function (dynamicId, limit, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling getDynamicCampaignStats.');
                            }
                            localVarPath = "/v1/dynamics/{dynamicId}/stats"
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Dynamic Campaign stats in CSV file
         * @summary Get Dynamic Campaign stats in CSV file
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicCampaignStatsCsv: function (dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling getDynamicCampaignStatsCsv.');
                            }
                            localVarPath = "/v1/dynamics/{dynamicId}/stats/csv"
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Dynamic Campaign stats summary
         * @summary Get Dynamic Campaign stats summary
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicCampaignStatsSummary: function (dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling getDynamicCampaignStatsSummary.');
                            }
                            localVarPath = "/v1/dynamics/{dynamicId}/stats/summary"
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of Dynamic Campaigns by workspace
         * @summary Get the list of Dynamic Campaigns by workspace
         * @param {string} workspaceId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsList: function (workspaceId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getDynamicsList.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (dropdownRendering !== undefined) {
                                localVarQueryParameter['dropdownRendering'] = dropdownRendering;
                            }
                            if (projectionType !== undefined) {
                                localVarQueryParameter['projectionType'] = projectionType;
                            }
                            if (sortOrder !== undefined) {
                                localVarQueryParameter['sortOrder'] = sortOrder;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get dynamics settings
         * @summary Get dynamics settings
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsSettings: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getDynamicsSettings.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/settings"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of videos from Dynamic Campaigns by campaignId
         * @summary Get the list of videos from Dynamic Campaigns by campaignId
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsVideosList: function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getDynamicsVideosList.');
                            }
                            // verify required parameter 'dynamicsId' is not null or undefined
                            if (dynamicsId === null || dynamicsId === undefined) {
                                throw new base_1.RequiredError('dynamicsId', 'Required parameter dynamicsId was null or undefined when calling getDynamicsVideosList.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicsId}/videos"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicsId", "}"), encodeURIComponent(String(dynamicsId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (dropdownRendering !== undefined) {
                                localVarQueryParameter['dropdownRendering'] = dropdownRendering;
                            }
                            if (projectionType !== undefined) {
                                localVarQueryParameter['projectionType'] = projectionType;
                            }
                            if (sortOrder !== undefined) {
                                localVarQueryParameter['sortOrder'] = sortOrder;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of prospects from Dynamic Campaigns by campaignId
         * @summary Get the list of prospects from Dynamic Campaigns by campaignId
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsVideosListV3: function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getDynamicsVideosListV3.');
                            }
                            // verify required parameter 'dynamicsId' is not null or undefined
                            if (dynamicsId === null || dynamicsId === undefined) {
                                throw new base_1.RequiredError('dynamicsId', 'Required parameter dynamicsId was null or undefined when calling getDynamicsVideosListV3.');
                            }
                            localVarPath = "/v3/workspaces/{workspaceId}/dynamics/{dynamicsId}/videos"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicsId", "}"), encodeURIComponent(String(dynamicsId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (dropdownRendering !== undefined) {
                                localVarQueryParameter['dropdownRendering'] = dropdownRendering;
                            }
                            if (projectionType !== undefined) {
                                localVarQueryParameter['projectionType'] = projectionType;
                            }
                            if (sortOrder !== undefined) {
                                localVarQueryParameter['sortOrder'] = sortOrder;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of prospects from Dynamic Campaigns in CSV file by campaignId
         * @summary Get the list of prospects from Dynamic Campaigns in CSV file by campaignId
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsVideosListV3CSV: function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getDynamicsVideosListV3CSV.');
                            }
                            // verify required parameter 'dynamicsId' is not null or undefined
                            if (dynamicsId === null || dynamicsId === undefined) {
                                throw new base_1.RequiredError('dynamicsId', 'Required parameter dynamicsId was null or undefined when calling getDynamicsVideosListV3CSV.');
                            }
                            localVarPath = "/v3/workspaces/{workspaceId}/dynamics/{dynamicsId}/videos/csv"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicsId", "}"), encodeURIComponent(String(dynamicsId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (dropdownRendering !== undefined) {
                                localVarQueryParameter['dropdownRendering'] = dropdownRendering;
                            }
                            if (projectionType !== undefined) {
                                localVarQueryParameter['projectionType'] = projectionType;
                            }
                            if (sortOrder !== undefined) {
                                localVarQueryParameter['sortOrder'] = sortOrder;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get available embed calendars integrations
         * @summary Get available embed calendars integrations
         * @param {string} workspaceId
         * @param {string} [provider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedCalendars: function (workspaceId, provider, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getEmbedCalendars.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/integrations/embed-calendars"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (provider !== undefined) {
                                localVarQueryParameter['provider'] = provider;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of campaigns by folder id
         * @summary Folders Route
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {'createdAt' | 'createdAtAscendant' | 'alphabetical'} [orderby]
         * @param {string} [filter]
         * @param {string} [creators]
         * @param {boolean} [ignoreEmptyVideo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderCampaignList: function (workspaceId, folderId, offset, limit, orderby, filter, creators, ignoreEmptyVideo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getFolderCampaignList.');
                            }
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling getFolderCampaignList.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/folders/{folderId}/campaigns"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("folderId", "}"), encodeURIComponent(String(folderId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (orderby !== undefined) {
                                localVarQueryParameter['orderby'] = orderby;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (creators !== undefined) {
                                localVarQueryParameter['creators'] = creators;
                            }
                            if (ignoreEmptyVideo !== undefined) {
                                localVarQueryParameter['ignoreEmptyVideo'] = ignoreEmptyVideo;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the creators from a folder
         * @summary Creators Folders Route
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderCreators: function (workspaceId, folderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getFolderCreators.');
                            }
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling getFolderCreators.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/folders/{folderId}/creators"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("folderId", "}"), encodeURIComponent(String(folderId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the campaigns by a folder id
         * @summary Folders Route
         * @param {string} folderId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersFolderidCampaigns: function (folderId, offset, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling getFoldersFolderidCampaigns.');
                            }
                            localVarPath = "/v1/folders/{folderId}/campaigns"
                                .replace("{".concat("folderId", "}"), encodeURIComponent(String(folderId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the folders belongs to a user - deprecated dasboard v1
         * @summary Legacy Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersWorkspaceid: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getFoldersWorkspaceid.');
                            }
                            localVarPath = "/v1/folders/{workspaceId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a health message
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/health";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns Hubspot Sendspark APP OAuth URL.
         * @summary Returns Hubspot Sendspark APP OAuth URL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHubspotOauthUrl: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/hubspot/auth/oauth";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * GET current workspace integrations
         * @summary Get your current workspace integrations
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsWorkspaceid: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getIntegrationsWorkspaceid.');
                            }
                            localVarPath = "/v1/integrations/{workspaceId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get key value from caches
         * @summary Get key value from caches
         * @param {string} key
         * @param {string} segment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeyFromCache: function (key, segment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key_1, key_2, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'key' is not null or undefined
                            if (key === null || key === undefined) {
                                throw new base_1.RequiredError('key', 'Required parameter key was null or undefined when calling getKeyFromCache.');
                            }
                            // verify required parameter 'segment' is not null or undefined
                            if (segment === null || segment === undefined) {
                                throw new base_1.RequiredError('segment', 'Required parameter segment was null or undefined when calling getKeyFromCache.');
                            }
                            localVarPath = "/v1/caches/get-key";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (key !== undefined) {
                                localVarQueryParameter['key'] = key;
                            }
                            if (segment !== undefined) {
                                localVarQueryParameter['segment'] = segment;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key_1 in localVarQueryParameter) {
                                query.set(key_1, localVarQueryParameter[key_1]);
                            }
                            for (key_2 in options.query) {
                                query.set(key_2, options.query[key_2]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This route delete the cookie for the users session
         * @summary Logout Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogout: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/logout";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Onboarding checklist
         * @summary Get Onboarding checklist
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingChecklist: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getOnboardingChecklist.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/onboardings"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get prospect data from prospect email
         * @summary Get prospect data from prospect email
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {string} contactEmail
         * @param {string} [include] Comma-separated list of additional fields to include in the response (emailEmbedHTML, fields)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProspectDynamicsVideos: function (workspaceId, dynamicId, contactEmail, include, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getProspectDynamicsVideos.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling getProspectDynamicsVideos.');
                            }
                            // verify required parameter 'contactEmail' is not null or undefined
                            if (contactEmail === null || contactEmail === undefined) {
                                throw new base_1.RequiredError('contactEmail', 'Required parameter contactEmail was null or undefined when calling getProspectDynamicsVideos.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicId}/prospects/{contactEmail}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)))
                                .replace("{".concat("contactEmail", "}"), encodeURIComponent(String(contactEmail)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (include !== undefined) {
                                localVarQueryParameter['include'] = include;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get public template info
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicTemplate: function (workspaceId, templateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getPublicTemplate.');
                            }
                            // verify required parameter 'templateId' is not null or undefined
                            if (templateId === null || templateId === undefined) {
                                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling getPublicTemplate.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/templates/public/{templateId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("templateId", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the Reactions
         * @summary Reactions Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReactionsId: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getReactionsId.');
                            }
                            localVarPath = "/v1/reactions/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get public share preview
         * @param {string} workspaceId
         * @param {'template' | 'dynamic-video' | 'campaign' | 'workspace'} previewType
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharePreview: function (workspaceId, previewType, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getSharePreview.');
                            }
                            // verify required parameter 'previewType' is not null or undefined
                            if (previewType === null || previewType === undefined) {
                                throw new base_1.RequiredError('previewType', 'Required parameter previewType was null or undefined when calling getSharePreview.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/share-preview"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (previewType !== undefined) {
                                localVarQueryParameter['previewType'] = previewType;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get available subscription churn reason codes route
         * @summary Get available subscription churn reason codes route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionCancellationReasons: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/subscriptions/cancellation-reasons";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Do not use this endpoint to get normal subscription previews, just for trial previews
         * @summary Get subscription for trial previews only
         * @param {string} workspaceId
         * @param {SubscriptionPreviewTrialPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionsPreviewTrial: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getSubscriptionsPreviewTrial.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/subscription/preview-trial"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get subscription previews route
         * @summary Get subscription previews route
         * @param {string} workspaceId
         * @param {SubscriptionPreviewsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionsPreviews: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getSubscriptionsPreviews.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/subscription/preview"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get available subscriptions types list route
         * @summary Get available subscriptions types list route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionsTypesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/subscriptions/types";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace usage transactions balance
         * @summary Get workspace usage transactions balance
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsBalance: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getTransactionsBalance.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/transactions-balance"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get share url from dynamic video prospect email
         * @summary Get share url from dynamic video prospect email
         * @param {string} xApiKey
         * @param {string} prospectEmail
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrlProspectDynamics: function (xApiKey, prospectEmail, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'xApiKey' is not null or undefined
                            if (xApiKey === null || xApiKey === undefined) {
                                throw new base_1.RequiredError('xApiKey', 'Required parameter xApiKey was null or undefined when calling getUrlProspectDynamics.');
                            }
                            // verify required parameter 'prospectEmail' is not null or undefined
                            if (prospectEmail === null || prospectEmail === undefined) {
                                throw new base_1.RequiredError('prospectEmail', 'Required parameter prospectEmail was null or undefined when calling getUrlProspectDynamics.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling getUrlProspectDynamics.');
                            }
                            localVarPath = "/v1/dynamics/{dynamicId}/prospects/{prospectEmail}"
                                .replace("{".concat("prospectEmail", "}"), encodeURIComponent(String(prospectEmail)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (xApiKey !== undefined && xApiKey !== null) {
                                localVarHeaderParameter['x-api-key'] = String(xApiKey);
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Get an user to the Automated Workflows provider. Returns a valid user object for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAutomatedWorkflow: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getUserAutomatedWorkflow.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/automated-workflows/auth"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get site connections list, only current selected by user
         * @summary Get site connections list available by user Route.
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSiteConnectionsList: function (userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            if (userId === null || userId === undefined) {
                                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserSiteConnectionsList.');
                            }
                            localVarPath = "/v1/users/{userId}/site-connections"
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * GET current user route
         * @summary Get your current user route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/users";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Webhook called when transcription process is complete
         * @summary Webhook called when transcription process is complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1AiTranscriptionWebhookUpdate: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/ai/transcription/webhook/update";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1GoogleLogin: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/google/login";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the requestId
         * @summary Get Campaign By request id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoRequestByRequestId: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getVideoRequestByRequestId.');
                            }
                            localVarPath = "/v1/video-request/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Webhook by ID
         * @summary Get Webhook by ID
         * @param {string} workspaceId
         * @param {string} webhookId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookById: function (workspaceId, webhookId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWebhookById.');
                            }
                            // verify required parameter 'webhookId' is not null or undefined
                            if (webhookId === null || webhookId === undefined) {
                                throw new base_1.RequiredError('webhookId', 'Required parameter webhookId was null or undefined when calling getWebhookById.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/webhooks/{webhookId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("webhookId", "}"), encodeURIComponent(String(webhookId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Webhook list by workspace ID
         * @summary Get Webhook list by workspace ID
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookListByWorkspaceId: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWebhookListByWorkspaceId.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/webhooks"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace id by api key
         * @summary Get workspace id by api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceByApiKey: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/workspaces/identifier";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspce custom domain
         * @summary Get workspce custom domain
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceCustomDomain: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspaceCustomDomain.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/custom-domain"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace dynamic campaign
         * @summary Get workspace dynamic campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceDynamics: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspaceDynamics.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling getWorkspaceDynamics.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get creators from workspace dynamic campaign
         * @summary Get creators from workspace dynamic campaign
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceDynamicsCreators: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspaceDynamicsCreators.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/creators"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace global styles route by workspace id.
         * @summary Get workspace global styles route.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceGlobalStyles: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspaceGlobalStyles.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/styles"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Search for campaigns inside a workspace
         * @summary Workspace Campaign Search Route
         * @param {string} workspaceId
         * @param {string} search
         * @param {boolean} [skipRequestCampaigns]
         * @param {boolean} [skipCustomIntroCampaigns]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceSearch: function (workspaceId, search, skipRequestCampaigns, skipCustomIntroCampaigns, offset, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspaceSearch.');
                            }
                            // verify required parameter 'search' is not null or undefined
                            if (search === null || search === undefined) {
                                throw new base_1.RequiredError('search', 'Required parameter search was null or undefined when calling getWorkspaceSearch.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/search"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (skipRequestCampaigns !== undefined) {
                                localVarQueryParameter['skipRequestCampaigns'] = skipRequestCampaigns;
                            }
                            if (skipCustomIntroCampaigns !== undefined) {
                                localVarQueryParameter['skipCustomIntroCampaigns'] = skipCustomIntroCampaigns;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {boolean} [legacy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceStats: function (workspaceId, legacy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspaceStats.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/stats"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (legacy !== undefined) {
                                localVarQueryParameter['legacy'] = legacy;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace subscription
         * @summary Get workspace subscription
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceSubscription: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspaceSubscription.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/subscription"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace template
         * @summary Get workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceTemplate: function (workspaceId, templateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspaceTemplate.');
                            }
                            // verify required parameter 'templateId' is not null or undefined
                            if (templateId === null || templateId === undefined) {
                                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling getWorkspaceTemplate.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/templates/{templateId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("templateId", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace templates by workspace id
         * @summary Get workspace templates by workspace id
         * @param {string} workspaceId
         * @param {string} [name]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [appLatest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceTemplates: function (workspaceId, name, offset, limit, appLatest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspaceTemplates.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/templates"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (appLatest !== undefined) {
                                localVarQueryParameter['appLatest'] = appLatest;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of the current users workspaces
         * @summary Get the list of the current users workspaces
         * @param {boolean} [dropdownRendering]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaces: function (dropdownRendering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/workspaces";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (dropdownRendering !== undefined) {
                                localVarQueryParameter['dropdownRendering'] = dropdownRendering;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace by id
         * @summary Get workspace by id
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesId: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspacesId.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser V1
         * @summary Get the current users workspace settings. V1
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesSettings: function (userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/workspaces/settings";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (userId !== undefined) {
                                localVarQueryParameter['userId'] = userId;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the legacy current users workspace usage.
         * @param {'all' | 'videos' | 'users'} usageType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesUsage: function (usageType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'usageType' is not null or undefined
                            if (usageType === null || usageType === undefined) {
                                throw new base_1.RequiredError('usageType', 'Required parameter usageType was null or undefined when calling getWorkspacesUsage.');
                            }
                            localVarPath = "/v1/workspaces/usage";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (usageType !== undefined) {
                                localVarQueryParameter['usageType'] = usageType;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of the assets
         * @summary Get the list of the assets
         * @param {string} workspaceId
         * @param {string} [folder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidAssets: function (workspaceId, folder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspacesWorkspaceidAssets.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/assets"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (folder !== undefined) {
                                localVarQueryParameter['folder'] = folder;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns stats of the workspace
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideos: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspacesWorkspaceidCreatedvideos.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/created-videos"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns stats of the workspace
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideosv2: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspacesWorkspaceidCreatedvideosv2.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/created-videos-v2"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the workspace folders that the user has access
         * @summary Workspace Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidFolders: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspacesWorkspaceidFolders.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/folders"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the workspace main folders that the user has access
         * @summary Workspace Main Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidFoldersMain: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspacesWorkspaceidFoldersMain.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/folders/main"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {number} usersNumber
         * @param {boolean} [legacy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidTopvideosUsersnumber: function (workspaceId, usersNumber, legacy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling getWorkspacesWorkspaceidTopvideosUsersnumber.');
                            }
                            // verify required parameter 'usersNumber' is not null or undefined
                            if (usersNumber === null || usersNumber === undefined) {
                                throw new base_1.RequiredError('usersNumber', 'Required parameter usersNumber was null or undefined when calling getWorkspacesWorkspaceidTopvideosUsersnumber.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/top-videos/{usersNumber}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("usersNumber", "}"), encodeURIComponent(String(usersNumber)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (legacy !== undefined) {
                                localVarQueryParameter['legacy'] = legacy;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a health message
         * @summary Health Check. Requires authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckProtected: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/auth/health";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saves Hubspot oauth tokens and returns 200
         * @summary Hubspot oauth callback endpoint. Saves Hubspot oauth tokens and returns 200.
         * @param {string} [code]
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hubspotOauthCallback: function (code, state, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/hubspot/auth/oauth-callback";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            if (state !== undefined) {
                                localVarQueryParameter['state'] = state;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns an array of objects with all the templates available for generating AI Script templates.
         * @summary List AI Script Templates Options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiTemplatesOptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/ai/templates-options";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Logout user route
         * @summary Logout current user from all tabs
         * @param {UserLogoutPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutUser: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/users/logout";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Only support name change and language code change.
         * @summary Use this route to update an asset information.
         * @param {string} assetId
         * @param {AssetPatchPatamsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAsset: function (assetId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'assetId' is not null or undefined
                            if (assetId === null || assetId === undefined) {
                                throw new base_1.RequiredError('assetId', 'Required parameter assetId was null or undefined when calling patchAsset.');
                            }
                            localVarPath = "/v1/assets/{assetId}/"
                                .replace("{".concat("assetId", "}"), encodeURIComponent(String(assetId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update the brand persona details for the specified workspace
         * @summary Update brand persona for a specific workspace
         * @param {string} workspaceId
         * @param {BrandPersona} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBrandPersona: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchBrandPersona.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/brand-persona"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Send an array with a valid asset id to create a Custom Intro campaign for it, or send and empty array to remove it.
         * @summary Used for custom Intros feature
         * @param {string} campaignId
         * @param {CampaignPatchAssetsPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssets: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling patchCampaignAssets.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/assets"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Campaign assets restore
         * @summary Campaign assets restore
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssetsRestore: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling patchCampaignAssetsRestore.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/assets-restore"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Campaign assets trim
         * @summary Campaign assets trim
         * @param {string} campaignId
         * @param {RequestPayloadCampaignAssetsTrimSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssetsTrim: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling patchCampaignAssetsTrim.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/assets-trim"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *            Use for patch campaign assets                      If you need remove all additional assets, you need to send one asset at least (position 0 asset)
         * @summary Campaign assets add
         * @param {string} campaignId
         * @param {RequestCampaignPatchAssetsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssetsV2: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling patchCampaignAssetsV2.');
                            }
                            localVarPath = "/v2/campaigns/{campaignId}/assets"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Move campaigns within a folder
         * @summary Move Campaigns action
         * @param {string} folderId
         * @param {RequestPayloadDeleteCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignMove: function (folderId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling patchCampaignMove.');
                            }
                            localVarPath = "/v1/folders/{folderId}/move-campaign"
                                .replace("{".concat("folderId", "}"), encodeURIComponent(String(folderId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign settings by Id Route
         * @param {string} campaignId
         * @param {Model81} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignSettingsId: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling patchCampaignSettingsId.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/settings"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Use this route to apply a given template to the campaign
         * @summary Apply template fields to a campaign
         * @param {string} campaignId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignTemplateApply: function (campaignId, templateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling patchCampaignTemplateApply.');
                            }
                            // verify required parameter 'templateId' is not null or undefined
                            if (templateId === null || templateId === undefined) {
                                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling patchCampaignTemplateApply.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/template/{templateId}/apply"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)))
                                .replace("{".concat("templateId", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update campaign thumbnail by the campaign id
         * @summary Update campaign thumbnail by campaign id
         * @param {string} campaignId
         * @param {PatchPayloadCampaignThumbnailsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignThumbnail: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling patchCampaignThumbnail.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/thumbnail"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign By Id Route
         * @param {string} campaignId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignsId: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling patchCampaignsId.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Insert or update prospect in Dynamics Campaign
         * @summary Insert or update prospect in Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadDynamicModifyProspectSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicModifyProspect: function (workspaceId, dynamicId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchDynamicModifyProspect.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling patchDynamicModifyProspect.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicId}/prospect"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update settings in Dynamics Campaign
         * @summary Update settings in Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadDynamicModifySettingsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicModifySettings: function (workspaceId, dynamicId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchDynamicModifySettings.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling patchDynamicModifySettings.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicId}/settings"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Modify Dynamics Campaign in folder
         * @summary Modify Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadModifyDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicsModify: function (workspaceId, dynamicsId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchDynamicsModify.');
                            }
                            // verify required parameter 'dynamicsId' is not null or undefined
                            if (dynamicsId === null || dynamicsId === undefined) {
                                throw new base_1.RequiredError('dynamicsId', 'Required parameter dynamicsId was null or undefined when calling patchDynamicsModify.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicsId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicsId", "}"), encodeURIComponent(String(dynamicsId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Persisting Prospect Lists
         * @summary Persisting Prospect Lists
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {Model93} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicsModifyV2: function (workspaceId, dynamicsId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchDynamicsModifyV2.');
                            }
                            // verify required parameter 'dynamicsId' is not null or undefined
                            if (dynamicsId === null || dynamicsId === undefined) {
                                throw new base_1.RequiredError('dynamicsId', 'Required parameter dynamicsId was null or undefined when calling patchDynamicsModifyV2.');
                            }
                            localVarPath = "/v2/workspaces/{workspaceId}/dynamics/{dynamicsId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicsId", "}"), encodeURIComponent(String(dynamicsId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint is used to bulk update prospect background URLs based on email domains.
         * @summary Bulk update prospect background URLs based on email domains.
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadBulkUpdateProspectsUrlSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicsProspectsUrlsBulkUpdate: function (workspaceId, dynamicsId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchDynamicsProspectsUrlsBulkUpdate.');
                            }
                            // verify required parameter 'dynamicsId' is not null or undefined
                            if (dynamicsId === null || dynamicsId === undefined) {
                                throw new base_1.RequiredError('dynamicsId', 'Required parameter dynamicsId was null or undefined when calling patchDynamicsProspectsUrlsBulkUpdate.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicsId}/prospects/urls/bulk"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicsId", "}"), encodeURIComponent(String(dynamicsId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Modify a folder name, more in the future.
         * @summary Folder Modify Route
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {FolderModifyRequestpayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFoldersModify: function (workspaceId, folderId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchFoldersModify.');
                            }
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling patchFoldersModify.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/folders/{folderId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("folderId", "}"), encodeURIComponent(String(folderId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Move a folder within a workspace
         * @summary Move Folder action
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {FolderMoveRequestPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFoldersMove: function (workspaceId, folderId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchFoldersMove.');
                            }
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling patchFoldersMove.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/folders/{folderId}/move"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("folderId", "}"), encodeURIComponent(String(folderId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Modify Webhook
         * @summary Modify Webhook
         * @param {string} workspaceId
         * @param {string} webhookId
         * @param {ModifyWebhookRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchModifyWebhook: function (workspaceId, webhookId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchModifyWebhook.');
                            }
                            // verify required parameter 'webhookId' is not null or undefined
                            if (webhookId === null || webhookId === undefined) {
                                throw new base_1.RequiredError('webhookId', 'Required parameter webhookId was null or undefined when calling patchModifyWebhook.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/webhooks/{webhookId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("webhookId", "}"), encodeURIComponent(String(webhookId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update user or workspace onboarding checklist
         * @summary Update user or workspace onboarding checklist
         * @param {string} workspaceId
         * @param {ResponseOnboardingUpdatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOnboardingChecklist: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchOnboardingChecklist.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/onboardings"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Only support uploading status change.
         * @summary Use this route to update the uploadingStatus of the asset.
         * @param {string} assetId
         * @param {AssetPatchUploadStatusPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUploadStatusAsset: function (assetId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'assetId' is not null or undefined
                            if (assetId === null || assetId === undefined) {
                                throw new base_1.RequiredError('assetId', 'Required parameter assetId was null or undefined when calling patchUploadStatusAsset.');
                            }
                            localVarPath = "/v1/assets/{assetId}/upload-status"
                                .replace("{".concat("assetId", "}"), encodeURIComponent(String(assetId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update user crm shortcuts selected
         * @summary Update user crm shortcuts selected
         * @param {string} userId
         * @param {CrmShortcutsModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserCrmShortcuts: function (userId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            if (userId === null || userId === undefined) {
                                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling patchUserCrmShortcuts.');
                            }
                            localVarPath = "/v1/users/{userId}/crm-shortcuts"
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update instant integrations from user
         * @summary Update instant integrations from user
         * @param {InstantIntegrationModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserInstantIntegrations: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/integrations/instant-integrations";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to modify their private site credentials route.
         * @summary Modify user private site credentials Route
         * @param {string} userId
         * @param {string} integrationId
         * @param {ModifyUserSiteConnectionsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserSiteConnections: function (userId, integrationId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            if (userId === null || userId === undefined) {
                                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling patchUserSiteConnections.');
                            }
                            // verify required parameter 'integrationId' is not null or undefined
                            if (integrationId === null || integrationId === undefined) {
                                throw new base_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling patchUserSiteConnections.');
                            }
                            localVarPath = "/v1/users/{userId}/site-connections/{integrationId}"
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                                .replace("{".concat("integrationId", "}"), encodeURIComponent(String(integrationId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchV1GoogleLogin: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/google/login";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Modify workspace global styles route by workspace id.
         * @summary Modify workspace global styles route.
         * @param {string} workspaceId
         * @param {WorkspaceStylesModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceGlobalStyles: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchWorkspaceGlobalStyles.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/styles"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a workspace integration
         * @summary Update a workspace integration
         * @param {string} workspaceId
         * @param {string} integrationId
         * @param {Values} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceIntegrations: function (workspaceId, integrationId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchWorkspaceIntegrations.');
                            }
                            // verify required parameter 'integrationId' is not null or undefined
                            if (integrationId === null || integrationId === undefined) {
                                throw new base_1.RequiredError('integrationId', 'Required parameter integrationId was null or undefined when calling patchWorkspaceIntegrations.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/integrations/{integrationId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("integrationId", "}"), encodeURIComponent(String(integrationId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Cancel a workspace subscription at the end of period
         * @summary Cancel a workspace subscription at the end of period
         * @param {string} workspaceId
         * @param {SubscriptionCancelPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceSubscriptionCancel: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchWorkspaceSubscriptionCancel.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/subscription/cancel"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Reactivate a workspace subscription canceled or pending cancellation status
         * @summary Reactivate a workspace subscription canceled or pending cancellation status
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceSubscriptionReactivate: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchWorkspaceSubscriptionReactivate.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/subscription/reactivate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Modify workspace template
         * @summary Modify workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {WorkspaceTemplatesModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceTemplates: function (workspaceId, templateId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchWorkspaceTemplates.');
                            }
                            // verify required parameter 'templateId' is not null or undefined
                            if (templateId === null || templateId === undefined) {
                                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling patchWorkspaceTemplates.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/templates/{templateId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("templateId", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add additional features to workspace by owners
         * @param {'storage' | 'workspaces' | 'videos' | 'creators'} feature
         * @param {'double'} value
         * @param {WorkspaceAdditionalFeaturesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesAdditionalfeatures: function (feature, value, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'feature' is not null or undefined
                            if (feature === null || feature === undefined) {
                                throw new base_1.RequiredError('feature', 'Required parameter feature was null or undefined when calling patchWorkspacesAdditionalfeatures.');
                            }
                            // verify required parameter 'value' is not null or undefined
                            if (value === null || value === undefined) {
                                throw new base_1.RequiredError('value', 'Required parameter value was null or undefined when calling patchWorkspacesAdditionalfeatures.');
                            }
                            localVarPath = "/v1/workspaces/additional-features";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (feature !== undefined) {
                                localVarQueryParameter['feature'] = feature;
                            }
                            if (value !== undefined) {
                                localVarQueryParameter['value'] = value;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace by id
         * @summary Get workspace by id
         * @param {string} workspaceId
         * @param {RequestWorkspacesModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesId: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchWorkspacesId.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Replace the current users last visited workspace with the id provided.
         * @summary Replace the current users last visited workspace with the id provided.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesIdChange: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling patchWorkspacesIdChange.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/change"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get scripts improvement
         * @summary Get scripts improvement
         * @param {AiScriptGeneratorParamsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiScriptsGenerator: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/ai/scripts-generator";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Start process to transcript a video
         * @summary Start process to transcript a video
         * @param {string} assetId
         * @param {TranscriptPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiTranscriptionCreate: function (assetId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'assetId' is not null or undefined
                            if (assetId === null || assetId === undefined) {
                                throw new base_1.RequiredError('assetId', 'Required parameter assetId was null or undefined when calling postAiTranscriptionCreate.');
                            }
                            localVarPath = "/v1/assets/{assetId}/transcription"
                                .replace("{".concat("assetId", "}"), encodeURIComponent(String(assetId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate a valid JWT for our AppSumo intergration
         * @summary Returns a valid JWT for AppSumo intergration
         * @param {AppSumoLoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoAuthLogin: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/appsumo/auth/login";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * When a Sumo-ling buys interacts with our license, we get a notification
         * @summary AppSumo notifications
         * @param {AppSumoNotificationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoWebhookNotification: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/appsumo/webhook/notification";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create assets
         * @summary Create assets Route
         * @param {CreateAssetPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssets: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/assets";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Forgot Password Route
         * @param {ForgotPasswordPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthForgotpassword: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/auth/forgot-password";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Authorize Device for user
         * @summary Authorize Device
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthorizeDevice: function (deviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'deviceId' is not null or undefined
                            if (deviceId === null || deviceId === undefined) {
                                throw new base_1.RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling postAuthorizeDevice.');
                            }
                            localVarPath = "/v1/devices/{deviceId}/authorize"
                                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create Campaign in folder
         * @summary Create Campaign
         * @param {string} folderId
         * @param {RequestPayloadCreateCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaign: function (folderId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling postCampaign.');
                            }
                            localVarPath = "/v1/campaigns/{folderId}"
                                .replace("{".concat("folderId", "}"), encodeURIComponent(String(folderId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a new Reaction to a Campaign Video
         * @summary Create a new Reaction
         * @param {string} campaignId
         * @param {CampaignReactionPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsCampaignidReactions: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling postCampaignsCampaignidReactions.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/reactions"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Duplicate Campaign
         * @param {string} campaignId
         * @param {RequestPayloadDuplicateCreateCampaignSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsDuplicate: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling postCampaignsDuplicate.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/duplicate"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates/create the Campaign thumbnails by asset
         * @summary Load Campaign Thumbnails
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsLoadThumbnails: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling postCampaignsLoadThumbnails.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/load-thumbnails"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a new Campaign based on a Template
         * @summary Create a new Campaign based on a Template
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsUseTemplate: function (campaignId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling postCampaignsUseTemplate.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/use-template"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Being used for update changes in subscriptions (database).
         * @summary Webhook to get an event when an subscription change.
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChargifyWebhooksSubscriptionsToken: function (token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            if (token === null || token === undefined) {
                                throw new base_1.RequiredError('token', 'Required parameter token was null or undefined when calling postChargifyWebhooksSubscriptionsToken.');
                            }
                            localVarPath = "/v1/chargify/webhooks/subscriptions/{token}"
                                .replace("{".concat("token", "}"), encodeURIComponent(String(token)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Clear key cache
         * @summary Clear key cache
         * @param {string} key
         * @param {string} segment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClearKeyCache: function (key, segment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key_3, key_4, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'key' is not null or undefined
                            if (key === null || key === undefined) {
                                throw new base_1.RequiredError('key', 'Required parameter key was null or undefined when calling postClearKeyCache.');
                            }
                            // verify required parameter 'segment' is not null or undefined
                            if (segment === null || segment === undefined) {
                                throw new base_1.RequiredError('segment', 'Required parameter segment was null or undefined when calling postClearKeyCache.');
                            }
                            localVarPath = "/v1/caches/clear-key";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (key !== undefined) {
                                localVarQueryParameter['key'] = key;
                            }
                            if (segment !== undefined) {
                                localVarQueryParameter['segment'] = segment;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key_3 in localVarQueryParameter) {
                                query.set(key_3, localVarQueryParameter[key_3]);
                            }
                            for (key_4 in options.query) {
                                query.set(key_4, options.query[key_4]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create new Webhook
         * @summary Create new Webhook
         * @param {string} workspaceId
         * @param {CreateWebhookRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCreateWebhook: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postCreateWebhook.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/webhooks"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create Dynamics Campaign in folder
         * @summary Create Dynamics Campaign
         * @param {string} workspaceId
         * @param {RequestParamsCreateDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamics: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamics.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Duplicate Dynamic Campaign by the dynamicsId
         * @summary Duplicate Dynamic Campaign
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsDuplicate: function (dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsDuplicate.');
                            }
                            localVarPath = "/v1/dynamics/{dynamicId}/duplicate"
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Listed in API Gateway only.
         * @summary Bulk add and process prospects to a dynamics campaign.
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadBulkProspectsDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsProspectsBulkModify: function (workspaceId, dynamicsId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsProspectsBulkModify.');
                            }
                            // verify required parameter 'dynamicsId' is not null or undefined
                            if (dynamicsId === null || dynamicsId === undefined) {
                                throw new base_1.RequiredError('dynamicsId', 'Required parameter dynamicsId was null or undefined when calling postDynamicsProspectsBulkModify.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicsId}/prospects/bulk"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicsId", "}"), encodeURIComponent(String(dynamicsId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create Dynamics Campaign in folder for the DV by steps UI
         * @summary Create Dynamics Campaign for the DV by steps UI
         * @param {string} workspaceId
         * @param {Model67} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsV2: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsV2.');
                            }
                            localVarPath = "/v2/workspaces/{workspaceId}/dynamics"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add dynamic video to Dynamics Campaign in folder
         * @summary Add dynamic video to Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestParamsDynamicsVideoAddSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideoAdd: function (workspaceId, dynamicId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideoAdd.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideoAdd.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicId}/video"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate videos for Dynamics Campaign prospect list
         * @summary Generate videos for Dynamics Campaign prospect list
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideoBulk: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideoBulk.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideoBulk.');
                            }
                            localVarPath = "/dv-v2/workspaces/{workspaceId}/dynamics/{dynamicId}/bulk"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create new campaigns for Dynamics Video prospect list
         * @summary Create new campaigns for Dynamics Video prospect list
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosCreateCampaign: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideosCreateCampaign.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosCreateCampaign.');
                            }
                            localVarPath = "/dv-v2/workspaces/{workspaceId}/dynamics/{dynamicId}/campaigns"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get screenshot by web site url
         * @summary Get screenshot by web site url
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosCreateScreenshot: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideosCreateScreenshot.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosCreateScreenshot.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicId}/screenshots"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get screenshot by web site url v2
         * @summary Get screenshot by web site url v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosCreateScreenshotV2: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideosCreateScreenshotV2.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosCreateScreenshotV2.');
                            }
                            localVarPath = "/dv-v2/workspaces/{workspaceId}/dynamics/{dynamicId}/screenshot/generate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate audio cloned from prospect
         * @summary Generate audio cloned from prospect
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateAudioRouteV2: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideosGenerateAudioRouteV2.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosGenerateAudioRouteV2.');
                            }
                            localVarPath = "/dv-v2/workspaces/{workspaceId}/dynamics/{dynamicId}/audio/generate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate campaign by dynamics videos v2
         * @summary Generate campaign by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateCampaignV2: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideosGenerateCampaignV2.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosGenerateCampaignV2.');
                            }
                            localVarPath = "/dv-v2/workspaces/{workspaceId}/dynamics/{dynamicId}/campaign/generate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate lipsync by dynamics videos v2
         * @summary Generate lipsync by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateLipsyncV2: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideosGenerateLipsyncV2.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosGenerateLipsyncV2.');
                            }
                            localVarPath = "/dv-v2/workspaces/{workspaceId}/dynamics/{dynamicId}/lipsync/generate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate resources for dynamics campaign
         * @summary Generate resources for dynamics campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadGenerateDynamicsResourceSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateResourcesV2: function (workspaceId, dynamicId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideosGenerateResourcesV2.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosGenerateResourcesV2.');
                            }
                            localVarPath = "/v2/workspaces/{workspaceId}/dynamics/{dynamicId}/resources/generate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get transcription by dynamics videos v2
         * @summary Get transcription by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateTranscriptionV2: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideosGenerateTranscriptionV2.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosGenerateTranscriptionV2.');
                            }
                            localVarPath = "/dv-v2/workspaces/{workspaceId}/dynamics/{dynamicId}/transcription/generate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate trim video from prospect
         * @summary Generate trim video from prospect
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateTrimVideoRouteV2: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideosGenerateTrimVideoRouteV2.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosGenerateTrimVideoRouteV2.');
                            }
                            localVarPath = "/dv-v2/workspaces/{workspaceId}/dynamics/{dynamicId}/trim/generate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate video by dynamics videos v2
         * @summary Generate video by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateVideoV2: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideosGenerateVideoV2.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosGenerateVideoV2.');
                            }
                            localVarPath = "/dv-v2/workspaces/{workspaceId}/dynamics/{dynamicId}/video/generate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate voice cloned from dynamics
         * @summary Generate voice cloned from dynamics
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateVoiceV2: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postDynamicsVideosGenerateVoiceV2.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosGenerateVoiceV2.');
                            }
                            localVarPath = "/dv-v2/workspaces/{workspaceId}/dynamics/{dynamicId}/voice/generate"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Guardian by Dynamics Videos
         * @summary Guardian by Dynamics Videos
         * @param {DynamicsVideosGuardianPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGuardian: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/dynamics/guardian";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This route is used to migrate the prospectList property from the Dynamics collection to the Prospects collection.
         * @summary Migration of prospectList property from Dynamics collection to Prospects collection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosProspectsMigration: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/prospects/migrate";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Queues recovery by Dynamics Videos
         * @summary Queues recovery by Dynamics Videos
         * @param {string} dynamicId
         * @param {DynamicsVideosRecoveryPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosQueuesRecovery: function (dynamicId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postDynamicsVideosQueuesRecovery.');
                            }
                            localVarPath = "/v1/dynamics/{dynamicId}/recovery"
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This receive an open object that containts the data we have to track
         * @summary Sendspark event to track user activity
         * @param {EventPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEvents: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/events";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a folder inside a workspace
         * @summary Folder Create Route
         * @param {string} workspaceId
         * @param {FolderCreateRequestPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFoldersCreate: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postFoldersCreate.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/folder"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Move multiple folders to another folder
         * @summary Move multiple folders to another folder
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {RequestFolderMoveMultiplePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFoldersMoveMultiple: function (workspaceId, folderId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postFoldersMoveMultiple.');
                            }
                            // verify required parameter 'folderId' is not null or undefined
                            if (folderId === null || folderId === undefined) {
                                throw new base_1.RequiredError('folderId', 'Required parameter folderId was null or undefined when calling postFoldersMoveMultiple.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/folders/{folderId}/move-multiple"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("folderId", "}"), encodeURIComponent(String(folderId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Load Thumbnails legacy from API v1
         * @summary Load Thumbnails legacy from API v1
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLoadThumbnailsLegacy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling postLoadThumbnailsLegacy.');
                            }
                            localVarPath = "/v1/legacy/load-thumbnails";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Register new logger event
         * @summary Register new logger event
         * @param {LoggerRequestSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogger: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/logger";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * User Login Route that returns a valid JTW
         * @summary Login Route
         * @param {LoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogin: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/login";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Logout Desktop App for user
         * @summary Logout Device
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogoutDevice: function (deviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'deviceId' is not null or undefined
                            if (deviceId === null || deviceId === undefined) {
                                throw new base_1.RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling postLogoutDevice.');
                            }
                            localVarPath = "/v1/devices/{deviceId}/logout"
                                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Being used for websockets to push events to the frontend.
         * @summary Webhook to get an event when an the asset is ready.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMuxWebhookVideoready: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/mux/webhook/video-ready";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Request a new Video Campaign for the workspace passed as parameter
         * @summary Request Video Campaign
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestCampaign: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postRequestCampaign.');
                            }
                            localVarPath = "/v1/campaigns/{workspaceId}/request-video"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace additional usage transactions purchase preview
         * @summary Get workspace additional usage transactions purchase preview
         * @param {string} workspaceId
         * @param {boolean} [generateFirstVideos]
         * @param {TransactionsPreviewPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransactionsPreview: function (workspaceId, generateFirstVideos, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postTransactionsPreview.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/transactions-preview"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            if (generateFirstVideos !== undefined) {
                                localVarQueryParameter['generateFirstVideos'] = generateFirstVideos;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace additional usage transactions purchase
         * @summary Make workspace additional usage transactions purchase
         * @param {string} workspaceId
         * @param {TransactionsPurchasePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransactionsPurchase: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postTransactionsPurchase.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/transactions-purchase"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create new Upload Url
         * @summary Create new Upload Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadUrl: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/upload-url";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Clean Upload Urls expired
         * @summary Clean Upload Urls expired
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadUrlCleanExpired: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/upload-url/clean-expired";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to store their private site credentials route.
         * @summary Create user private site credentials Route.
         * @param {string} userId
         * @param {CreateUserSiteConnectionsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserSiteConnections: function (userId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            if (userId === null || userId === undefined) {
                                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling postUserSiteConnections.');
                            }
                            localVarPath = "/v1/users/{userId}/site-connections"
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add meeting links for the user passed as parameter
         * @summary Create meeting links for user
         * @param {string} userId
         * @param {UsersMeetingLinksPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUsersMeetingLinks: function (userId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            if (userId === null || userId === undefined) {
                                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling postUsersMeetingLinks.');
                            }
                            localVarPath = "/v1/users/{userId}/meeting-links"
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Brand Persona test
         * @summary Brand Persona test
         * @param {Model53} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiBrandpersonagenerator: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/ai/brand-persona-generator";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a customized email template using AI by processing a previously generated video script template
         * @summary Generates an email template based on a video script template
         * @param {Model54} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiEmailtemplategenerator: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/ai/email-template-generator";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Takes an AI-generated email template and creates a matching landing page template maintaining consistent messaging and branding
         * @summary Generates a landing page template based on an existing email template
         * @param {Model55} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiLandingpagetemplategenerator: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/ai/landing-page-template-generator";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Webhook called when transcription process is complete
         * @summary Webhook called when transcription process is complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiTranscriptionWebhookUpdate: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/ai/transcription/webhook/update";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1GoogleLogin: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/google/login";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate videos for Dynamics Campaign prospect list
         * @summary Generate videos for Dynamics Campaign prospect list
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1WorkspacesWorkspaceidDynamicsDynamicidBulk: function (workspaceId, dynamicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postV1WorkspacesWorkspaceidDynamicsDynamicidBulk.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling postV1WorkspacesWorkspaceidDynamicsDynamicidBulk.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicId}/bulk"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * API Gateway only.
         * @summary Add prospect to Dynamics Campaign and process video.
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadAddProspectsDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1WorkspacesWorkspaceidDynamicsDynamicsidProspect: function (workspaceId, dynamicsId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postV1WorkspacesWorkspaceidDynamicsDynamicsidProspect.');
                            }
                            // verify required parameter 'dynamicsId' is not null or undefined
                            if (dynamicsId === null || dynamicsId === undefined) {
                                throw new base_1.RequiredError('dynamicsId', 'Required parameter dynamicsId was null or undefined when calling postV1WorkspacesWorkspaceidDynamicsDynamicsidProspect.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/dynamics/{dynamicsId}/prospect"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)))
                                .replace("{".concat("dynamicsId", "}"), encodeURIComponent(String(dynamicsId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new workspace integration
         * @param {string} workspaceId
         * @param {WorkspaceIntegrationsCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceIntegrations: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postWorkspaceIntegrations.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/integrations"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create or switch workspace subscription
         * @summary Create or switch workspace subscription
         * @param {string} workspaceId
         * @param {WorkspaceSubscriptionCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceSubscription: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postWorkspaceSubscription.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/subscription"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Apply discount on subscription
         * @summary Apply discount on subscription
         * @param {string} workspaceId
         * @param {WorkspaceSubscriptionApplyDiscountRequestSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceSubscriptionApplyDiscount: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postWorkspaceSubscriptionApplyDiscount.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/subscription/apply-discount"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Apply discount on onboarding process
         * @summary Apply discount on onboarding process
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceSubscriptionApplyOnboardingDiscount: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postWorkspaceSubscriptionApplyOnboardingDiscount.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/subscription/apply-onboarding-discount"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a new workspace template
         * @summary Create a new workspace template
         * @param {string} workspaceId
         * @param {WorkspaceTemplatesCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceTemplates: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postWorkspaceTemplates.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/templates"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser
         * @summary Create a new workspace
         * @param {CreateWorkspaceResponseSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaces: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/workspaces";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace by id
         * @summary Create custom domain to workspace
         * @param {string} workspaceId
         * @param {WorkspaceCustomDomainCreatePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspacesWorkspaceidCustomdomain: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postWorkspacesWorkspaceidCustomdomain.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/custom-domain"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * We need pass the emails to invite to this route
         * @summary Workspace invite route
         * @param {string} workspaceId
         * @param {WorkspaceInvitePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspacesWorkspaceidInvite: function (workspaceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling postWorkspacesWorkspaceidInvite.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/invite"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Queues recovery by prospectId
         * @summary Queues to check if prospect is healthy
         * @param {string} prospectId Prospect ID
         * @param {string} dynamicId
         * @param {Model73} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prospectsHealthyQueues: function (prospectId, dynamicId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'prospectId' is not null or undefined
                            if (prospectId === null || prospectId === undefined) {
                                throw new base_1.RequiredError('prospectId', 'Required parameter prospectId was null or undefined when calling prospectsHealthyQueues.');
                            }
                            // verify required parameter 'dynamicId' is not null or undefined
                            if (dynamicId === null || dynamicId === undefined) {
                                throw new base_1.RequiredError('dynamicId', 'Required parameter dynamicId was null or undefined when calling prospectsHealthyQueues.');
                            }
                            localVarPath = "/v2/dynamics/{dynamicId}/prospects/{prospectId}/healthy"
                                .replace("{".concat("prospectId", "}"), encodeURIComponent(String(prospectId)))
                                .replace("{".concat("dynamicId", "}"), encodeURIComponent(String(dynamicId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Completes the activation for appsumo packages.
         * @param {AppSumoActivationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAppsumoActivation: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/appsumo/activation";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update asset mime type
         * @summary Update mime type for an asset
         * @param {string} assetId
         * @param {UpdateAssetPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAssetsIdMime: function (assetId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'assetId' is not null or undefined
                            if (assetId === null || assetId === undefined) {
                                throw new base_1.RequiredError('assetId', 'Required parameter assetId was null or undefined when calling putAssetsIdMime.');
                            }
                            localVarPath = "/v1/assets/{assetId}/mime"
                                .replace("{".concat("assetId", "}"), encodeURIComponent(String(assetId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putV1GoogleLogin: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/google/login";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign By Request Id Route
         * @param {string} requestId
         * @param {VideoRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVideoRequestById: function (requestId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'requestId' is not null or undefined
                            if (requestId === null || requestId === undefined) {
                                throw new base_1.RequiredError('requestId', 'Required parameter requestId was null or undefined when calling putVideoRequestById.');
                            }
                            localVarPath = "/v1/video-request/{requestId}"
                                .replace("{".concat("requestId", "}"), encodeURIComponent(String(requestId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Get an user refresh token for the Automated Workflows provider. Returns a valid user session token for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokenUserAutomatedWorkflow: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling refreshTokenUserAutomatedWorkflow.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/automated-workflows/auth/refresh-token"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Register an user to the Automated Workflows provider. Returns a valid user object for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUserAutomatedWorkflow: function (workspaceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'workspaceId' is not null or undefined
                            if (workspaceId === null || workspaceId === undefined) {
                                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling registerUserAutomatedWorkflow.');
                            }
                            localVarPath = "/v1/workspaces/{workspaceId}/automated-workflows/auth"
                                .replace("{".concat("workspaceId", "}"), encodeURIComponent(String(workspaceId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get total videos by workspace
         * @summary Get total videos by workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTotalVideosByWorkspace: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/reports/total-videos-by-workspace";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Validate access to reports
         * @summary Validate access to reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportValidateAccess: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/reports/validate-access";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Patch Campaign Summary Views
         * @summary Patch Campaign Summary Views
         * @param {string} campaignId
         * @param {Model83} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaignSummaryViews: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling updateCampaignSummaryViews.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/stats/sync-views"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign video Id by campaign Id Route
         * @param {string} campaignId
         * @param {PayloadCampaignVideo} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaignVideoId: function (campaignId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'campaignId' is not null or undefined
                            if (campaignId === null || campaignId === undefined) {
                                throw new base_1.RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling updateCampaignVideoId.');
                            }
                            localVarPath = "/v1/campaigns/{campaignId}/video"
                                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * PATCH current user route
         * @summary Modify current user logged in route
         * @param {UserModifyPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentUser: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/users/current";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary WorkOs Webhook Listener route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workosEventsListener: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarApiKeyValue, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/v1/workos/events";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.apiKey)) return [3 /*break*/, 5];
                            if (!(typeof configuration.apiKey === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.apiKey("Authorization")];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.apiKey];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            localVarApiKeyValue = _a;
                            localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
var DefaultApiFp = function (configuration) {
    return {
        /**
         * Activate enterprise features for workspace
         * @summary Activate enterprise features for workspace
         * @param {string} workspaceId
         * @param {WorkspaceActivateEnterpriseFeaturesPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateWorkspaceEnterpriseFeatures: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).activateWorkspaceEnterpriseFeatures(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add password to campaign.access
         * @param {string} campaignId
         * @param {PayloadCampaignPassword} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCampaignPassword: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).addCampaignPassword(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid automated workflow user to be created first. Protected route.
         * @summary Performs a connection between an automated workflows user and our Sendspark app in the automated workflow provider.
         * @param {string} xAwToken A custom header for authentication purposes
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConnectionUserAutomatedWorkflow: function (xAwToken, workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).addConnectionUserAutomatedWorkflow(xAwToken, workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * The amount of transactions (count) must be a mutiple of 100
         * @summary Add extra transaction to a user in albato
         * @param {string} workspaceId
         * @param {AddTransactionToBillingPlanSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransactionToBillingPlan: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).addTransactionToBillingPlan(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Requires authentication. Protected route.
         * @summary Assign billing plans to the user for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {AutomatedWorkflowsPlanAssignmentBodyPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignAutomatedWorkflowBillingPlans: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).assignAutomatedWorkflowBillingPlans(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth callback route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authCallback: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).authCallback(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth login resolve route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginResolve: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).authLoginResolve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Auth signup resolve route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSignupResolve: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).authSignupResolve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Do not support video update
         * @summary Use this route to update an campaign meta text data
         * @param {string} campaignId
         * @param {CampaignMetaPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignMetaUpdate: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).campaignMetaUpdate(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generates email, landing page and video scripts for users based on base templates.
         * @summary AI Scripts templates generator.
         * @param {CreateAiScriptsTemplatesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiScriptsTemplates: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).createAiScriptsTemplates(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generates a video script to be used in a teleprompter generated by AI
         * @summary AI Video script templates generator
         * @param {CreateAiVideoScriptsTemplatesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiVideoScriptsTemplate: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).createAiVideoScriptsTemplate(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to Create API Key for workspace.
         * @summary Create Public API key for workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeys: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).createApiKeys(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create a Gif for a campaign based on video
         * @summary Create a Gif for a campaign based on video
         * @param {string} assetId
         * @param {any} file
         * @param {number} [start]
         * @param {number} [end]
         * @param {string} [width]
         * @param {string} [height]
         * @param {string} [fps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaignIdGif: function (assetId, file, start, end, width, height, fps, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).createCampaignIdGif(assetId, file, start, end, width, height, fps, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to Create Secret for API Key.
         * @summary Create Secret for API key.
         * @param {string} workspaceId
         * @param {string} apikeyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecretFromApiKeys: function (workspaceId, apikeyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).createSecretFromApiKeys(workspaceId, apikeyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create Asset for video request
         * @summary Create Asset for video request
         * @param {string} requestId
         * @param {VideoRequestAssetCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoRequestAssetByRequestId: function (requestId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).createVideoRequestAssetByRequestId(requestId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create voice cloning for Dynamics Campaign in folder
         * @summary Create voice cloning for Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadCreateDynamicsVoiceCloningSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoiceCloningForDynamicsCampaign: function (workspaceId, dynamicId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).createVoiceCloningForDynamicsCampaign(workspaceId, dynamicId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Deactivate enterprise features for workspace
         * @summary Deactivate enterprise features for workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWorkspaceEnterpriseFeatures: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deactivateWorkspaceEnterpriseFeatures(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to delete Apikey for workspace.
         * @summary Delete Apikey for workspace
         * @param {string} workspaceId
         * @param {string} apikeyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApikey: function (workspaceId, apikeyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteApikey(workspaceId, apikeyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete assets by ID
         * @summary Delete assets Route
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetsId: function (assetId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteAssetsId(assetId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to Delete their workspace-leve auth connections route.
         * @summary Delete workspace auth connections Route
         * @param {string} workspaceId
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuthConnections: function (workspaceId, integrationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteAuthConnections(workspaceId, integrationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete a Gif for a campaign based on video
         * @summary Delete a Gif for a campaign based on video
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignIdGif: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteCampaignIdGif(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete password from campaign.access
         * @param {string} campaignId
         * @param {string} passwordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignPassword: function (campaignId, passwordId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteCampaignPassword(campaignId, passwordId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete the Campaign by the campaignId
         * @summary Delete Campaign By Id Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignsId: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteCampaignsId(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete the custom domain by the workspaceId
         * @summary Delete custom domain by workspace id route
         * @param {string} workspaceId
         * @param {string} domainName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomDomainByWorkspaceId: function (workspaceId, domainName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteCustomDomainByWorkspaceId(workspaceId, domainName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete Dynamics Campaign and folder
         * @summary Delete Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {boolean} [force]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamics: function (workspaceId, dynamicsId, force, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteDynamics(workspaceId, dynamicsId, force, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete folder by id
         * @summary Folder Delete Route
         * @param {string} folderId
         * @param {RequestPayloadDeleteFolderSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFoldersFolderid: function (folderId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteFoldersFolderid(folderId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete animated and static thumbnails generated by the share faster feature
         * @summary Delete custom thumbnails for an assetId
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGifByAssetId: function (assetId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteGifByAssetId(assetId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete the Campaigns by the campaignId. Requires folderId to validate user ownership
         * @summary Delete Multiple Campaigns by Id Route
         * @param {string} folderId
         * @param {RequestPayloadDeleteCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMultipleCampaignsById: function (folderId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteMultipleCampaignsById(folderId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete prospect from dynamic video
         * @summary Delete prospect from dynamic video
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {boolean} [deleteAll]
         * @param {DynamicDeleteProspectPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProspectDynamics: function (workspaceId, dynamicsId, deleteAll, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteProspectDynamics(workspaceId, dynamicsId, deleteAll, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete Reaction by ID
         * @summary Delete Reaction Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReactionsId: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteReactionsId(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to delete Secret Token for API key.
         * @summary Delete Secret Token for API key.
         * @param {string} workspaceId
         * @param {string} apikeyId
         * @param {string} secretId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecretFromApikey: function (workspaceId, apikeyId, secretId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteSecretFromApikey(workspaceId, apikeyId, secretId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Deletes an user for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAutomatedWorkflow: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteUserAutomatedWorkflow(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to Delete their private site connections route.
         * @summary Delete user private site connections Route
         * @param {string} userId
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserSiteConnections: function (userId, integrationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteUserSiteConnections(userId, integrationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1GoogleLogin: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteV1GoogleLogin(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete Webhook by ID
         * @summary Delete Webhook by ID
         * @param {string} workspaceId
         * @param {string} webhookId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebhookById: function (workspaceId, webhookId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteWebhookById(workspaceId, webhookId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Workspace Integration by integration id
         * @param {string} workspaceId
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspaceIntegrations: function (workspaceId, integrationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteWorkspaceIntegrations(workspaceId, integrationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Delete workspace template
         * @summary Delete workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspaceTemplate: function (workspaceId, templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteWorkspaceTemplate(workspaceId, templateId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete workspace by id
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspacesWorkspaceid: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteWorkspacesWorkspaceid(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Remove an invited member from the workspace.
         * @summary Remove an invited member from the workspace.
         * @param {string} workspaceId
         * @param {string} invitedUserId
         * @param {RequestWorkspaceMembersDeletePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspacesWorkspaceidMembersInviteduserid: function (workspaceId, invitedUserId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).deleteWorkspacesWorkspaceidMembersInviteduserid(workspaceId, invitedUserId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Duplicate workspace template
         * @summary Duplicate workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateWorkspaceTemplate: function (workspaceId, templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).duplicateWorkspaceTemplate(workspaceId, templateId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Campaign identifier needs to be the share id of the campaign.
         * @summary Route to generate JWT token based on the password input to access a protected campaign
         * @param {string} shareId
         * @param {PayloadCampaignPassword} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuthTokenForCampaignAccess: function (shareId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).generateAuthTokenForCampaignAccess(shareId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to get all API keys for a workspace.
         * @summary Get all API keys for a workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeys: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getApiKeys(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Gets Auth URL.
         * @summary Get Auth URL Route
         * @param {'sign-in' | 'sign-up'} screenHint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthURL: function (screenHint, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getAuthURL(screenHint, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Requires authentication. Protected route.
         * @summary Get billing plans for the Automated Workflows provider. Returns a list of available plans assignable to users.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutomatedWorkflowBillingPlans: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getAutomatedWorkflowBillingPlans(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Used for development purposes
         * @summary Get billing provider route
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingUuid: function (uuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getBillingUuid(uuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get brand persona for a specific workspace
         * @summary Get brand persona for a specific workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandPersona: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getBrandPersona(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get campaign.access
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignAccess: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignAccess(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Check if its possible create a campaign
         * @summary Campaign checkpoint
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignCheckpoint: function (folderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignCheckpoint(folderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get a Gif for a campaign
         * @summary Get a Gif for a campaign
         * @param {string} campaignId
         * @param {number} [start]
         * @param {number} [end]
         * @param {string} [width]
         * @param {string} [height]
         * @param {string} [fps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignIdGif: function (campaignId, start, end, width, height, fps, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignIdGif(campaignId, start, end, width, height, fps, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Used for previews on Dynamic Edit page
         * @summary Get campaign preview for dynamic campaign.
         * @param {string} campaignId
         * @param {string} dynamicId
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignPreviewForDv: function (campaignId, dynamicId, workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignPreviewForDv(campaignId, dynamicId, workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get Campaign stats
         * @summary Get Campaign stats
         * @param {string} campaignId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignStats: function (campaignId, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignStats(campaignId, limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get Campaign stats in CSV file
         * @summary Get Campaign stats in CSV file
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignStatsCsv: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignStatsCsv(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign thumbnail by the campaignId
         * @summary Campaign thumbnail by campaign id
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignThumbnail: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignThumbnail(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign thumbnail urls by the campaignId
         * @summary Campaign thumbnail urls by campaign id
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignThumbnailsUrls: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignThumbnailsUrls(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the Reactions for a campaign
         * @summary Campaign Reactions Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsCampaignidReactions: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignsCampaignidReactions(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} campaignId
         * @param {boolean} [useProtectedThumbnail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsId: function (campaignId, useProtectedThumbnail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignsId(campaignId, useProtectedThumbnail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign public information by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} id
         * @param {boolean} [sendsparkAppRendering]
         * @param {string} [host]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsIdPublic: function (id, sendsparkAppRendering, host, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignsIdPublic(id, sendsparkAppRendering, host, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns a oembed json
         * @summary Generate Oembed Service
         * @param {string} url
         * @param {string} [queryParam]
         * @param {number} [maxheight]
         * @param {string} [companyname]
         * @param {string} [firstname]
         * @param {string} [jobtitle]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsOembed: function (url, queryParam, maxheight, companyname, firstname, jobtitle, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignsOembed(url, queryParam, maxheight, companyname, firstname, jobtitle, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get all campaign templates by a folder id
         * @summary Campaigns Templates Route
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsTemplates: function (offset, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCampaignsTemplates(offset, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get captions availables
         * @summary Get captions availables
         * @param {string} [assetId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaptionsAvailables: function (assetId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCaptionsAvailables(assetId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid automated workflow user to be created first. Protected route.
         * @summary Get all connections from an user in the automated workflow provider.
         * @param {string} xAwToken A custom header for authentication purposes
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionUserAutomatedWorkflow: function (xAwToken, workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getConnectionUserAutomatedWorkflow(xAwToken, workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get available CRM dynamic variables
         * @summary Get available CRM dynamic variables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrmDynamicVariables: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCrmDynamicVariables(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get crm shortcuts list, only current selected by user
         * @summary Get crm shortcuts list, only current selected by user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrmShortcutsSelectedUserId: function (userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getCrmShortcutsSelectedUserId(userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign thumbnail information by the campaignId
         * @summary Campaign Thumbnail Info Get Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDvv2V1CampaignsCampaignidThumbnailinfo: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getDvv2V1CampaignsCampaignidThumbnailinfo(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get Dynamic Campaign stats
         * @summary Get Dynamic Campaign stats
         * @param {string} dynamicId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicCampaignStats: function (dynamicId, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getDynamicCampaignStats(dynamicId, limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get Dynamic Campaign stats in CSV file
         * @summary Get Dynamic Campaign stats in CSV file
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicCampaignStatsCsv: function (dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getDynamicCampaignStatsCsv(dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get Dynamic Campaign stats summary
         * @summary Get Dynamic Campaign stats summary
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicCampaignStatsSummary: function (dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getDynamicCampaignStatsSummary(dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of Dynamic Campaigns by workspace
         * @summary Get the list of Dynamic Campaigns by workspace
         * @param {string} workspaceId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsList: function (workspaceId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getDynamicsList(workspaceId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get dynamics settings
         * @summary Get dynamics settings
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsSettings: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getDynamicsSettings(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of videos from Dynamic Campaigns by campaignId
         * @summary Get the list of videos from Dynamic Campaigns by campaignId
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsVideosList: function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getDynamicsVideosList(workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of prospects from Dynamic Campaigns by campaignId
         * @summary Get the list of prospects from Dynamic Campaigns by campaignId
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsVideosListV3: function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getDynamicsVideosListV3(workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of prospects from Dynamic Campaigns in CSV file by campaignId
         * @summary Get the list of prospects from Dynamic Campaigns in CSV file by campaignId
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsVideosListV3CSV: function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getDynamicsVideosListV3CSV(workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get available embed calendars integrations
         * @summary Get available embed calendars integrations
         * @param {string} workspaceId
         * @param {string} [provider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedCalendars: function (workspaceId, provider, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getEmbedCalendars(workspaceId, provider, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of campaigns by folder id
         * @summary Folders Route
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {'createdAt' | 'createdAtAscendant' | 'alphabetical'} [orderby]
         * @param {string} [filter]
         * @param {string} [creators]
         * @param {boolean} [ignoreEmptyVideo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderCampaignList: function (workspaceId, folderId, offset, limit, orderby, filter, creators, ignoreEmptyVideo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getFolderCampaignList(workspaceId, folderId, offset, limit, orderby, filter, creators, ignoreEmptyVideo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the creators from a folder
         * @summary Creators Folders Route
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderCreators: function (workspaceId, folderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getFolderCreators(workspaceId, folderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the campaigns by a folder id
         * @summary Folders Route
         * @param {string} folderId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersFolderidCampaigns: function (folderId, offset, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getFoldersFolderidCampaigns(folderId, offset, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the folders belongs to a user - deprecated dasboard v1
         * @summary Legacy Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersWorkspaceid: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getFoldersWorkspaceid(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns a health message
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getHealth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns Hubspot Sendspark APP OAuth URL.
         * @summary Returns Hubspot Sendspark APP OAuth URL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHubspotOauthUrl: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getHubspotOauthUrl(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * GET current workspace integrations
         * @summary Get your current workspace integrations
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsWorkspaceid: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getIntegrationsWorkspaceid(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get key value from caches
         * @summary Get key value from caches
         * @param {string} key
         * @param {string} segment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeyFromCache: function (key, segment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getKeyFromCache(key, segment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * This route delete the cookie for the users session
         * @summary Logout Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogout: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getLogout(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get Onboarding checklist
         * @summary Get Onboarding checklist
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingChecklist: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getOnboardingChecklist(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get prospect data from prospect email
         * @summary Get prospect data from prospect email
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {string} contactEmail
         * @param {string} [include] Comma-separated list of additional fields to include in the response (emailEmbedHTML, fields)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProspectDynamicsVideos: function (workspaceId, dynamicId, contactEmail, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getProspectDynamicsVideos(workspaceId, dynamicId, contactEmail, include, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get public template info
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicTemplate: function (workspaceId, templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getPublicTemplate(workspaceId, templateId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get all of the Reactions
         * @summary Reactions Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReactionsId: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getReactionsId(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get public share preview
         * @param {string} workspaceId
         * @param {'template' | 'dynamic-video' | 'campaign' | 'workspace'} previewType
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharePreview: function (workspaceId, previewType, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getSharePreview(workspaceId, previewType, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get available subscription churn reason codes route
         * @summary Get available subscription churn reason codes route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionCancellationReasons: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getSubscriptionCancellationReasons(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Do not use this endpoint to get normal subscription previews, just for trial previews
         * @summary Get subscription for trial previews only
         * @param {string} workspaceId
         * @param {SubscriptionPreviewTrialPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionsPreviewTrial: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getSubscriptionsPreviewTrial(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get subscription previews route
         * @summary Get subscription previews route
         * @param {string} workspaceId
         * @param {SubscriptionPreviewsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionsPreviews: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getSubscriptionsPreviews(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get available subscriptions types list route
         * @summary Get available subscriptions types list route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionsTypesList: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getSubscriptionsTypesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace usage transactions balance
         * @summary Get workspace usage transactions balance
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsBalance: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getTransactionsBalance(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get share url from dynamic video prospect email
         * @summary Get share url from dynamic video prospect email
         * @param {string} xApiKey
         * @param {string} prospectEmail
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrlProspectDynamics: function (xApiKey, prospectEmail, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getUrlProspectDynamics(xApiKey, prospectEmail, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Get an user to the Automated Workflows provider. Returns a valid user object for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAutomatedWorkflow: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getUserAutomatedWorkflow(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get site connections list, only current selected by user
         * @summary Get site connections list available by user Route.
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSiteConnectionsList: function (userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getUserSiteConnectionsList(userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * GET current user route
         * @summary Get your current user route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getUsers(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Webhook called when transcription process is complete
         * @summary Webhook called when transcription process is complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1AiTranscriptionWebhookUpdate: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getV1AiTranscriptionWebhookUpdate(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1GoogleLogin: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getV1GoogleLogin(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the requestId
         * @summary Get Campaign By request id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoRequestByRequestId: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getVideoRequestByRequestId(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get Webhook by ID
         * @summary Get Webhook by ID
         * @param {string} workspaceId
         * @param {string} webhookId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookById: function (workspaceId, webhookId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWebhookById(workspaceId, webhookId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get Webhook list by workspace ID
         * @summary Get Webhook list by workspace ID
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookListByWorkspaceId: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWebhookListByWorkspaceId(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace id by api key
         * @summary Get workspace id by api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceByApiKey: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspaceByApiKey(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspce custom domain
         * @summary Get workspce custom domain
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceCustomDomain: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspaceCustomDomain(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace dynamic campaign
         * @summary Get workspace dynamic campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceDynamics: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspaceDynamics(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get creators from workspace dynamic campaign
         * @summary Get creators from workspace dynamic campaign
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceDynamicsCreators: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspaceDynamicsCreators(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace global styles route by workspace id.
         * @summary Get workspace global styles route.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceGlobalStyles: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspaceGlobalStyles(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Search for campaigns inside a workspace
         * @summary Workspace Campaign Search Route
         * @param {string} workspaceId
         * @param {string} search
         * @param {boolean} [skipRequestCampaigns]
         * @param {boolean} [skipCustomIntroCampaigns]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceSearch: function (workspaceId, search, skipRequestCampaigns, skipCustomIntroCampaigns, offset, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspaceSearch(workspaceId, search, skipRequestCampaigns, skipCustomIntroCampaigns, offset, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {boolean} [legacy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceStats: function (workspaceId, legacy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspaceStats(workspaceId, legacy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace subscription
         * @summary Get workspace subscription
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceSubscription: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspaceSubscription(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace template
         * @summary Get workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceTemplate: function (workspaceId, templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspaceTemplate(workspaceId, templateId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace templates by workspace id
         * @summary Get workspace templates by workspace id
         * @param {string} workspaceId
         * @param {string} [name]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [appLatest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceTemplates: function (workspaceId, name, offset, limit, appLatest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspaceTemplates(workspaceId, name, offset, limit, appLatest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of the current users workspaces
         * @summary Get the list of the current users workspaces
         * @param {boolean} [dropdownRendering]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaces: function (dropdownRendering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspaces(dropdownRendering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace by id
         * @summary Get workspace by id
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesId: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspacesId(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser V1
         * @summary Get the current users workspace settings. V1
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesSettings: function (userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspacesSettings(userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the legacy current users workspace usage.
         * @param {'all' | 'videos' | 'users'} usageType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesUsage: function (usageType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspacesUsage(usageType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the list of the assets
         * @summary Get the list of the assets
         * @param {string} workspaceId
         * @param {string} [folder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidAssets: function (workspaceId, folder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspacesWorkspaceidAssets(workspaceId, folder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns stats of the workspace
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideos: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspacesWorkspaceidCreatedvideos(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns stats of the workspace
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideosv2: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspacesWorkspaceidCreatedvideosv2(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the workspace folders that the user has access
         * @summary Workspace Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidFolders: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspacesWorkspaceidFolders(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the workspace main folders that the user has access
         * @summary Workspace Main Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidFoldersMain: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspacesWorkspaceidFoldersMain(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {number} usersNumber
         * @param {boolean} [legacy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidTopvideosUsersnumber: function (workspaceId, usersNumber, legacy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).getWorkspacesWorkspaceidTopvideosUsersnumber(workspaceId, usersNumber, legacy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns a health message
         * @summary Health Check. Requires authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckProtected: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).healthCheckProtected(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Saves Hubspot oauth tokens and returns 200
         * @summary Hubspot oauth callback endpoint. Saves Hubspot oauth tokens and returns 200.
         * @param {string} [code]
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hubspotOauthCallback: function (code, state, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).hubspotOauthCallback(code, state, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns an array of objects with all the templates available for generating AI Script templates.
         * @summary List AI Script Templates Options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiTemplatesOptions: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).listAiTemplatesOptions(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Logout user route
         * @summary Logout current user from all tabs
         * @param {UserLogoutPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutUser: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).logoutUser(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Only support name change and language code change.
         * @summary Use this route to update an asset information.
         * @param {string} assetId
         * @param {AssetPatchPatamsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAsset: function (assetId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchAsset(assetId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Update the brand persona details for the specified workspace
         * @summary Update brand persona for a specific workspace
         * @param {string} workspaceId
         * @param {BrandPersona} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBrandPersona: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchBrandPersona(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Send an array with a valid asset id to create a Custom Intro campaign for it, or send and empty array to remove it.
         * @summary Used for custom Intros feature
         * @param {string} campaignId
         * @param {CampaignPatchAssetsPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssets: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchCampaignAssets(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Campaign assets restore
         * @summary Campaign assets restore
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssetsRestore: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchCampaignAssetsRestore(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Campaign assets trim
         * @summary Campaign assets trim
         * @param {string} campaignId
         * @param {RequestPayloadCampaignAssetsTrimSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssetsTrim: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchCampaignAssetsTrim(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *            Use for patch campaign assets                      If you need remove all additional assets, you need to send one asset at least (position 0 asset)
         * @summary Campaign assets add
         * @param {string} campaignId
         * @param {RequestCampaignPatchAssetsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssetsV2: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchCampaignAssetsV2(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Move campaigns within a folder
         * @summary Move Campaigns action
         * @param {string} folderId
         * @param {RequestPayloadDeleteCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignMove: function (folderId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchCampaignMove(folderId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign settings by Id Route
         * @param {string} campaignId
         * @param {Model81} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignSettingsId: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchCampaignSettingsId(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Use this route to apply a given template to the campaign
         * @summary Apply template fields to a campaign
         * @param {string} campaignId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignTemplateApply: function (campaignId, templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchCampaignTemplateApply(campaignId, templateId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Update campaign thumbnail by the campaign id
         * @summary Update campaign thumbnail by campaign id
         * @param {string} campaignId
         * @param {PatchPayloadCampaignThumbnailsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignThumbnail: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchCampaignThumbnail(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign By Id Route
         * @param {string} campaignId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignsId: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchCampaignsId(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Insert or update prospect in Dynamics Campaign
         * @summary Insert or update prospect in Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadDynamicModifyProspectSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicModifyProspect: function (workspaceId, dynamicId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchDynamicModifyProspect(workspaceId, dynamicId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Update settings in Dynamics Campaign
         * @summary Update settings in Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadDynamicModifySettingsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicModifySettings: function (workspaceId, dynamicId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchDynamicModifySettings(workspaceId, dynamicId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Modify Dynamics Campaign in folder
         * @summary Modify Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadModifyDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicsModify: function (workspaceId, dynamicsId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchDynamicsModify(workspaceId, dynamicsId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Persisting Prospect Lists
         * @summary Persisting Prospect Lists
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {Model93} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicsModifyV2: function (workspaceId, dynamicsId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchDynamicsModifyV2(workspaceId, dynamicsId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint is used to bulk update prospect background URLs based on email domains.
         * @summary Bulk update prospect background URLs based on email domains.
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadBulkUpdateProspectsUrlSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicsProspectsUrlsBulkUpdate: function (workspaceId, dynamicsId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchDynamicsProspectsUrlsBulkUpdate(workspaceId, dynamicsId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Modify a folder name, more in the future.
         * @summary Folder Modify Route
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {FolderModifyRequestpayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFoldersModify: function (workspaceId, folderId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchFoldersModify(workspaceId, folderId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Move a folder within a workspace
         * @summary Move Folder action
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {FolderMoveRequestPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFoldersMove: function (workspaceId, folderId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchFoldersMove(workspaceId, folderId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Modify Webhook
         * @summary Modify Webhook
         * @param {string} workspaceId
         * @param {string} webhookId
         * @param {ModifyWebhookRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchModifyWebhook: function (workspaceId, webhookId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchModifyWebhook(workspaceId, webhookId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Update user or workspace onboarding checklist
         * @summary Update user or workspace onboarding checklist
         * @param {string} workspaceId
         * @param {ResponseOnboardingUpdatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOnboardingChecklist: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchOnboardingChecklist(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Only support uploading status change.
         * @summary Use this route to update the uploadingStatus of the asset.
         * @param {string} assetId
         * @param {AssetPatchUploadStatusPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUploadStatusAsset: function (assetId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchUploadStatusAsset(assetId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Update user crm shortcuts selected
         * @summary Update user crm shortcuts selected
         * @param {string} userId
         * @param {CrmShortcutsModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserCrmShortcuts: function (userId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchUserCrmShortcuts(userId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Update instant integrations from user
         * @summary Update instant integrations from user
         * @param {InstantIntegrationModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserInstantIntegrations: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchUserInstantIntegrations(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to modify their private site credentials route.
         * @summary Modify user private site credentials Route
         * @param {string} userId
         * @param {string} integrationId
         * @param {ModifyUserSiteConnectionsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserSiteConnections: function (userId, integrationId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchUserSiteConnections(userId, integrationId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchV1GoogleLogin: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchV1GoogleLogin(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Modify workspace global styles route by workspace id.
         * @summary Modify workspace global styles route.
         * @param {string} workspaceId
         * @param {WorkspaceStylesModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceGlobalStyles: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchWorkspaceGlobalStyles(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Update a workspace integration
         * @summary Update a workspace integration
         * @param {string} workspaceId
         * @param {string} integrationId
         * @param {Values} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceIntegrations: function (workspaceId, integrationId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchWorkspaceIntegrations(workspaceId, integrationId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Cancel a workspace subscription at the end of period
         * @summary Cancel a workspace subscription at the end of period
         * @param {string} workspaceId
         * @param {SubscriptionCancelPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceSubscriptionCancel: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchWorkspaceSubscriptionCancel(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Reactivate a workspace subscription canceled or pending cancellation status
         * @summary Reactivate a workspace subscription canceled or pending cancellation status
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceSubscriptionReactivate: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchWorkspaceSubscriptionReactivate(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Modify workspace template
         * @summary Modify workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {WorkspaceTemplatesModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceTemplates: function (workspaceId, templateId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchWorkspaceTemplates(workspaceId, templateId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add additional features to workspace by owners
         * @param {'storage' | 'workspaces' | 'videos' | 'creators'} feature
         * @param {'double'} value
         * @param {WorkspaceAdditionalFeaturesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesAdditionalfeatures: function (feature, value, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchWorkspacesAdditionalfeatures(feature, value, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace by id
         * @summary Get workspace by id
         * @param {string} workspaceId
         * @param {RequestWorkspacesModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesId: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchWorkspacesId(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Replace the current users last visited workspace with the id provided.
         * @summary Replace the current users last visited workspace with the id provided.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesIdChange: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).patchWorkspacesIdChange(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get scripts improvement
         * @summary Get scripts improvement
         * @param {AiScriptGeneratorParamsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiScriptsGenerator: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postAiScriptsGenerator(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Start process to transcript a video
         * @summary Start process to transcript a video
         * @param {string} assetId
         * @param {TranscriptPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiTranscriptionCreate: function (assetId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postAiTranscriptionCreate(assetId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generate a valid JWT for our AppSumo intergration
         * @summary Returns a valid JWT for AppSumo intergration
         * @param {AppSumoLoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoAuthLogin: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postAppsumoAuthLogin(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * When a Sumo-ling buys interacts with our license, we get a notification
         * @summary AppSumo notifications
         * @param {AppSumoNotificationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoWebhookNotification: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postAppsumoWebhookNotification(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create assets
         * @summary Create assets Route
         * @param {CreateAssetPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssets: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postAssets(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Forgot Password Route
         * @param {ForgotPasswordPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthForgotpassword: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postAuthForgotpassword(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Authorize Device for user
         * @summary Authorize Device
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthorizeDevice: function (deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postAuthorizeDevice(deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create Campaign in folder
         * @summary Create Campaign
         * @param {string} folderId
         * @param {RequestPayloadCreateCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaign: function (folderId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postCampaign(folderId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create a new Reaction to a Campaign Video
         * @summary Create a new Reaction
         * @param {string} campaignId
         * @param {CampaignReactionPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsCampaignidReactions: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postCampaignsCampaignidReactions(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Duplicate Campaign
         * @param {string} campaignId
         * @param {RequestPayloadDuplicateCreateCampaignSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsDuplicate: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postCampaignsDuplicate(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Updates/create the Campaign thumbnails by asset
         * @summary Load Campaign Thumbnails
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsLoadThumbnails: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postCampaignsLoadThumbnails(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create a new Campaign based on a Template
         * @summary Create a new Campaign based on a Template
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsUseTemplate: function (campaignId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postCampaignsUseTemplate(campaignId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Being used for update changes in subscriptions (database).
         * @summary Webhook to get an event when an subscription change.
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChargifyWebhooksSubscriptionsToken: function (token, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postChargifyWebhooksSubscriptionsToken(token, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Clear key cache
         * @summary Clear key cache
         * @param {string} key
         * @param {string} segment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClearKeyCache: function (key, segment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postClearKeyCache(key, segment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create new Webhook
         * @summary Create new Webhook
         * @param {string} workspaceId
         * @param {CreateWebhookRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCreateWebhook: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postCreateWebhook(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create Dynamics Campaign in folder
         * @summary Create Dynamics Campaign
         * @param {string} workspaceId
         * @param {RequestParamsCreateDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamics: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamics(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Duplicate Dynamic Campaign by the dynamicsId
         * @summary Duplicate Dynamic Campaign
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsDuplicate: function (dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsDuplicate(dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Listed in API Gateway only.
         * @summary Bulk add and process prospects to a dynamics campaign.
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadBulkProspectsDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsProspectsBulkModify: function (workspaceId, dynamicsId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsProspectsBulkModify(workspaceId, dynamicsId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create Dynamics Campaign in folder for the DV by steps UI
         * @summary Create Dynamics Campaign for the DV by steps UI
         * @param {string} workspaceId
         * @param {Model67} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsV2: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsV2(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Add dynamic video to Dynamics Campaign in folder
         * @summary Add dynamic video to Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestParamsDynamicsVideoAddSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideoAdd: function (workspaceId, dynamicId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideoAdd(workspaceId, dynamicId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generate videos for Dynamics Campaign prospect list
         * @summary Generate videos for Dynamics Campaign prospect list
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideoBulk: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideoBulk(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create new campaigns for Dynamics Video prospect list
         * @summary Create new campaigns for Dynamics Video prospect list
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosCreateCampaign: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosCreateCampaign(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get screenshot by web site url
         * @summary Get screenshot by web site url
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosCreateScreenshot: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosCreateScreenshot(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get screenshot by web site url v2
         * @summary Get screenshot by web site url v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosCreateScreenshotV2: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosCreateScreenshotV2(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generate audio cloned from prospect
         * @summary Generate audio cloned from prospect
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateAudioRouteV2: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosGenerateAudioRouteV2(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generate campaign by dynamics videos v2
         * @summary Generate campaign by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateCampaignV2: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosGenerateCampaignV2(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generate lipsync by dynamics videos v2
         * @summary Generate lipsync by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateLipsyncV2: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosGenerateLipsyncV2(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generate resources for dynamics campaign
         * @summary Generate resources for dynamics campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadGenerateDynamicsResourceSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateResourcesV2: function (workspaceId, dynamicId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosGenerateResourcesV2(workspaceId, dynamicId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get transcription by dynamics videos v2
         * @summary Get transcription by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateTranscriptionV2: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosGenerateTranscriptionV2(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generate trim video from prospect
         * @summary Generate trim video from prospect
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateTrimVideoRouteV2: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosGenerateTrimVideoRouteV2(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generate video by dynamics videos v2
         * @summary Generate video by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateVideoV2: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosGenerateVideoV2(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generate voice cloned from dynamics
         * @summary Generate voice cloned from dynamics
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateVoiceV2: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosGenerateVoiceV2(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Guardian by Dynamics Videos
         * @summary Guardian by Dynamics Videos
         * @param {DynamicsVideosGuardianPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGuardian: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosGuardian(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * This route is used to migrate the prospectList property from the Dynamics collection to the Prospects collection.
         * @summary Migration of prospectList property from Dynamics collection to Prospects collection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosProspectsMigration: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosProspectsMigration(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Queues recovery by Dynamics Videos
         * @summary Queues recovery by Dynamics Videos
         * @param {string} dynamicId
         * @param {DynamicsVideosRecoveryPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosQueuesRecovery: function (dynamicId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postDynamicsVideosQueuesRecovery(dynamicId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * This receive an open object that containts the data we have to track
         * @summary Sendspark event to track user activity
         * @param {EventPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEvents: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postEvents(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create a folder inside a workspace
         * @summary Folder Create Route
         * @param {string} workspaceId
         * @param {FolderCreateRequestPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFoldersCreate: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postFoldersCreate(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Move multiple folders to another folder
         * @summary Move multiple folders to another folder
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {RequestFolderMoveMultiplePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFoldersMoveMultiple: function (workspaceId, folderId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postFoldersMoveMultiple(workspaceId, folderId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Load Thumbnails legacy from API v1
         * @summary Load Thumbnails legacy from API v1
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLoadThumbnailsLegacy: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postLoadThumbnailsLegacy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Register new logger event
         * @summary Register new logger event
         * @param {LoggerRequestSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogger: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postLogger(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * User Login Route that returns a valid JTW
         * @summary Login Route
         * @param {LoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogin: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postLogin(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Logout Desktop App for user
         * @summary Logout Device
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogoutDevice: function (deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postLogoutDevice(deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Being used for websockets to push events to the frontend.
         * @summary Webhook to get an event when an the asset is ready.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMuxWebhookVideoready: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postMuxWebhookVideoready(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Request a new Video Campaign for the workspace passed as parameter
         * @summary Request Video Campaign
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestCampaign: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postRequestCampaign(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace additional usage transactions purchase preview
         * @summary Get workspace additional usage transactions purchase preview
         * @param {string} workspaceId
         * @param {boolean} [generateFirstVideos]
         * @param {TransactionsPreviewPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransactionsPreview: function (workspaceId, generateFirstVideos, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postTransactionsPreview(workspaceId, generateFirstVideos, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace additional usage transactions purchase
         * @summary Make workspace additional usage transactions purchase
         * @param {string} workspaceId
         * @param {TransactionsPurchasePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransactionsPurchase: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postTransactionsPurchase(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create new Upload Url
         * @summary Create new Upload Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadUrl: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postUploadUrl(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Clean Upload Urls expired
         * @summary Clean Upload Urls expired
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadUrlCleanExpired: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postUploadUrlCleanExpired(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Route for users to store their private site credentials route.
         * @summary Create user private site credentials Route.
         * @param {string} userId
         * @param {CreateUserSiteConnectionsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserSiteConnections: function (userId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postUserSiteConnections(userId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Add meeting links for the user passed as parameter
         * @summary Create meeting links for user
         * @param {string} userId
         * @param {UsersMeetingLinksPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUsersMeetingLinks: function (userId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postUsersMeetingLinks(userId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Brand Persona test
         * @summary Brand Persona test
         * @param {Model53} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiBrandpersonagenerator: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postV1AiBrandpersonagenerator(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Creates a customized email template using AI by processing a previously generated video script template
         * @summary Generates an email template based on a video script template
         * @param {Model54} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiEmailtemplategenerator: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postV1AiEmailtemplategenerator(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Takes an AI-generated email template and creates a matching landing page template maintaining consistent messaging and branding
         * @summary Generates a landing page template based on an existing email template
         * @param {Model55} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiLandingpagetemplategenerator: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postV1AiLandingpagetemplategenerator(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Webhook called when transcription process is complete
         * @summary Webhook called when transcription process is complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiTranscriptionWebhookUpdate: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postV1AiTranscriptionWebhookUpdate(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1GoogleLogin: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postV1GoogleLogin(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Generate videos for Dynamics Campaign prospect list
         * @summary Generate videos for Dynamics Campaign prospect list
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1WorkspacesWorkspaceidDynamicsDynamicidBulk: function (workspaceId, dynamicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postV1WorkspacesWorkspaceidDynamicsDynamicidBulk(workspaceId, dynamicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * API Gateway only.
         * @summary Add prospect to Dynamics Campaign and process video.
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadAddProspectsDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1WorkspacesWorkspaceidDynamicsDynamicsidProspect: function (workspaceId, dynamicsId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postV1WorkspacesWorkspaceidDynamicsDynamicsidProspect(workspaceId, dynamicsId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new workspace integration
         * @param {string} workspaceId
         * @param {WorkspaceIntegrationsCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceIntegrations: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postWorkspaceIntegrations(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create or switch workspace subscription
         * @summary Create or switch workspace subscription
         * @param {string} workspaceId
         * @param {WorkspaceSubscriptionCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceSubscription: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postWorkspaceSubscription(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Apply discount on subscription
         * @summary Apply discount on subscription
         * @param {string} workspaceId
         * @param {WorkspaceSubscriptionApplyDiscountRequestSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceSubscriptionApplyDiscount: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postWorkspaceSubscriptionApplyDiscount(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Apply discount on onboarding process
         * @summary Apply discount on onboarding process
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceSubscriptionApplyOnboardingDiscount: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postWorkspaceSubscriptionApplyOnboardingDiscount(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Create a new workspace template
         * @summary Create a new workspace template
         * @param {string} workspaceId
         * @param {WorkspaceTemplatesCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceTemplates: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postWorkspaceTemplates(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser
         * @summary Create a new workspace
         * @param {CreateWorkspaceResponseSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaces: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postWorkspaces(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get workspace by id
         * @summary Create custom domain to workspace
         * @param {string} workspaceId
         * @param {WorkspaceCustomDomainCreatePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspacesWorkspaceidCustomdomain: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postWorkspacesWorkspaceidCustomdomain(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * We need pass the emails to invite to this route
         * @summary Workspace invite route
         * @param {string} workspaceId
         * @param {WorkspaceInvitePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspacesWorkspaceidInvite: function (workspaceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).postWorkspacesWorkspaceidInvite(workspaceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Queues recovery by prospectId
         * @summary Queues to check if prospect is healthy
         * @param {string} prospectId Prospect ID
         * @param {string} dynamicId
         * @param {Model73} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prospectsHealthyQueues: function (prospectId, dynamicId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).prospectsHealthyQueues(prospectId, dynamicId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Completes the activation for appsumo packages.
         * @param {AppSumoActivationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAppsumoActivation: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).putAppsumoActivation(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Update asset mime type
         * @summary Update mime type for an asset
         * @param {string} assetId
         * @param {UpdateAssetPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAssetsIdMime: function (assetId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).putAssetsIdMime(assetId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putV1GoogleLogin: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).putV1GoogleLogin(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign By Request Id Route
         * @param {string} requestId
         * @param {VideoRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVideoRequestById: function (requestId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).putVideoRequestById(requestId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Get an user refresh token for the Automated Workflows provider. Returns a valid user session token for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokenUserAutomatedWorkflow: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).refreshTokenUserAutomatedWorkflow(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Register an user to the Automated Workflows provider. Returns a valid user object for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUserAutomatedWorkflow: function (workspaceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).registerUserAutomatedWorkflow(workspaceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Get total videos by workspace
         * @summary Get total videos by workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTotalVideosByWorkspace: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).reportTotalVideosByWorkspace(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Validate access to reports
         * @summary Validate access to reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportValidateAccess: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).reportValidateAccess(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Patch Campaign Summary Views
         * @summary Patch Campaign Summary Views
         * @param {string} campaignId
         * @param {Model83} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaignSummaryViews: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).updateCampaignSummaryViews(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a campaign video Id by campaign Id Route
         * @param {string} campaignId
         * @param {PayloadCampaignVideo} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaignVideoId: function (campaignId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).updateCampaignVideoId(campaignId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * PATCH current user route
         * @summary Modify current user logged in route
         * @param {UserModifyPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentUser: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).updateCurrentUser(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary WorkOs Webhook Listener route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workosEventsListener: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, exports.DefaultApiAxiosParamCreator)(configuration).workosEventsListener(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
var DefaultApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Activate enterprise features for workspace
         * @summary Activate enterprise features for workspace
         * @param {string} workspaceId
         * @param {WorkspaceActivateEnterpriseFeaturesPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateWorkspaceEnterpriseFeatures: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).activateWorkspaceEnterpriseFeatures(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add password to campaign.access
         * @param {string} campaignId
         * @param {PayloadCampaignPassword} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCampaignPassword: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).addCampaignPassword(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Requires a valid automated workflow user to be created first. Protected route.
         * @summary Performs a connection between an automated workflows user and our Sendspark app in the automated workflow provider.
         * @param {string} xAwToken A custom header for authentication purposes
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConnectionUserAutomatedWorkflow: function (xAwToken, workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).addConnectionUserAutomatedWorkflow(xAwToken, workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * The amount of transactions (count) must be a mutiple of 100
         * @summary Add extra transaction to a user in albato
         * @param {string} workspaceId
         * @param {AddTransactionToBillingPlanSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransactionToBillingPlan: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).addTransactionToBillingPlan(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Requires authentication. Protected route.
         * @summary Assign billing plans to the user for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {AutomatedWorkflowsPlanAssignmentBodyPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignAutomatedWorkflowBillingPlans: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).assignAutomatedWorkflowBillingPlans(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Auth callback route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authCallback: function (options) {
            return (0, exports.DefaultApiFp)(configuration).authCallback(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Auth login resolve route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginResolve: function (options) {
            return (0, exports.DefaultApiFp)(configuration).authLoginResolve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Auth signup resolve route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSignupResolve: function (options) {
            return (0, exports.DefaultApiFp)(configuration).authSignupResolve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Do not support video update
         * @summary Use this route to update an campaign meta text data
         * @param {string} campaignId
         * @param {CampaignMetaPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignMetaUpdate: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).campaignMetaUpdate(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generates email, landing page and video scripts for users based on base templates.
         * @summary AI Scripts templates generator.
         * @param {CreateAiScriptsTemplatesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiScriptsTemplates: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).createAiScriptsTemplates(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generates a video script to be used in a teleprompter generated by AI
         * @summary AI Video script templates generator
         * @param {CreateAiVideoScriptsTemplatesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiVideoScriptsTemplate: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).createAiVideoScriptsTemplate(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Route for users to Create API Key for workspace.
         * @summary Create Public API key for workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeys: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).createApiKeys(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a Gif for a campaign based on video
         * @summary Create a Gif for a campaign based on video
         * @param {string} assetId
         * @param {any} file
         * @param {number} [start]
         * @param {number} [end]
         * @param {string} [width]
         * @param {string} [height]
         * @param {string} [fps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaignIdGif: function (assetId, file, start, end, width, height, fps, options) {
            return (0, exports.DefaultApiFp)(configuration).createCampaignIdGif(assetId, file, start, end, width, height, fps, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Route for users to Create Secret for API Key.
         * @summary Create Secret for API key.
         * @param {string} workspaceId
         * @param {string} apikeyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecretFromApiKeys: function (workspaceId, apikeyId, options) {
            return (0, exports.DefaultApiFp)(configuration).createSecretFromApiKeys(workspaceId, apikeyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create Asset for video request
         * @summary Create Asset for video request
         * @param {string} requestId
         * @param {VideoRequestAssetCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoRequestAssetByRequestId: function (requestId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).createVideoRequestAssetByRequestId(requestId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create voice cloning for Dynamics Campaign in folder
         * @summary Create voice cloning for Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadCreateDynamicsVoiceCloningSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoiceCloningForDynamicsCampaign: function (workspaceId, dynamicId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).createVoiceCloningForDynamicsCampaign(workspaceId, dynamicId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deactivate enterprise features for workspace
         * @summary Deactivate enterprise features for workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateWorkspaceEnterpriseFeatures: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).deactivateWorkspaceEnterpriseFeatures(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Route for users to delete Apikey for workspace.
         * @summary Delete Apikey for workspace
         * @param {string} workspaceId
         * @param {string} apikeyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApikey: function (workspaceId, apikeyId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteApikey(workspaceId, apikeyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete assets by ID
         * @summary Delete assets Route
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetsId: function (assetId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteAssetsId(assetId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Route for users to Delete their workspace-leve auth connections route.
         * @summary Delete workspace auth connections Route
         * @param {string} workspaceId
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuthConnections: function (workspaceId, integrationId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteAuthConnections(workspaceId, integrationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a Gif for a campaign based on video
         * @summary Delete a Gif for a campaign based on video
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignIdGif: function (campaignId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteCampaignIdGif(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete password from campaign.access
         * @param {string} campaignId
         * @param {string} passwordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignPassword: function (campaignId, passwordId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteCampaignPassword(campaignId, passwordId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete the Campaign by the campaignId
         * @summary Delete Campaign By Id Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignsId: function (campaignId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteCampaignsId(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete the custom domain by the workspaceId
         * @summary Delete custom domain by workspace id route
         * @param {string} workspaceId
         * @param {string} domainName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomDomainByWorkspaceId: function (workspaceId, domainName, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteCustomDomainByWorkspaceId(workspaceId, domainName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete Dynamics Campaign and folder
         * @summary Delete Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {boolean} [force]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamics: function (workspaceId, dynamicsId, force, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteDynamics(workspaceId, dynamicsId, force, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete folder by id
         * @summary Folder Delete Route
         * @param {string} folderId
         * @param {RequestPayloadDeleteFolderSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFoldersFolderid: function (folderId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteFoldersFolderid(folderId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete animated and static thumbnails generated by the share faster feature
         * @summary Delete custom thumbnails for an assetId
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGifByAssetId: function (assetId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteGifByAssetId(assetId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete the Campaigns by the campaignId. Requires folderId to validate user ownership
         * @summary Delete Multiple Campaigns by Id Route
         * @param {string} folderId
         * @param {RequestPayloadDeleteCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMultipleCampaignsById: function (folderId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteMultipleCampaignsById(folderId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete prospect from dynamic video
         * @summary Delete prospect from dynamic video
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {boolean} [deleteAll]
         * @param {DynamicDeleteProspectPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProspectDynamics: function (workspaceId, dynamicsId, deleteAll, body, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteProspectDynamics(workspaceId, dynamicsId, deleteAll, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete Reaction by ID
         * @summary Delete Reaction Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReactionsId: function (id, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteReactionsId(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Route for users to delete Secret Token for API key.
         * @summary Delete Secret Token for API key.
         * @param {string} workspaceId
         * @param {string} apikeyId
         * @param {string} secretId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecretFromApikey: function (workspaceId, apikeyId, secretId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteSecretFromApikey(workspaceId, apikeyId, secretId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Deletes an user for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAutomatedWorkflow: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteUserAutomatedWorkflow(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Route for users to Delete their private site connections route.
         * @summary Delete user private site connections Route
         * @param {string} userId
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserSiteConnections: function (userId, integrationId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteUserSiteConnections(userId, integrationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1GoogleLogin: function (options) {
            return (0, exports.DefaultApiFp)(configuration).deleteV1GoogleLogin(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete Webhook by ID
         * @summary Delete Webhook by ID
         * @param {string} workspaceId
         * @param {string} webhookId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebhookById: function (workspaceId, webhookId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteWebhookById(workspaceId, webhookId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Workspace Integration by integration id
         * @param {string} workspaceId
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspaceIntegrations: function (workspaceId, integrationId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteWorkspaceIntegrations(workspaceId, integrationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete workspace template
         * @summary Delete workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspaceTemplate: function (workspaceId, templateId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteWorkspaceTemplate(workspaceId, templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete workspace by id
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspacesWorkspaceid: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteWorkspacesWorkspaceid(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Remove an invited member from the workspace.
         * @summary Remove an invited member from the workspace.
         * @param {string} workspaceId
         * @param {string} invitedUserId
         * @param {RequestWorkspaceMembersDeletePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspacesWorkspaceidMembersInviteduserid: function (workspaceId, invitedUserId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).deleteWorkspacesWorkspaceidMembersInviteduserid(workspaceId, invitedUserId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Duplicate workspace template
         * @summary Duplicate workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateWorkspaceTemplate: function (workspaceId, templateId, options) {
            return (0, exports.DefaultApiFp)(configuration).duplicateWorkspaceTemplate(workspaceId, templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Campaign identifier needs to be the share id of the campaign.
         * @summary Route to generate JWT token based on the password input to access a protected campaign
         * @param {string} shareId
         * @param {PayloadCampaignPassword} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuthTokenForCampaignAccess: function (shareId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).generateAuthTokenForCampaignAccess(shareId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Route for users to get all API keys for a workspace.
         * @summary Get all API keys for a workspace.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeys: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getApiKeys(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets Auth URL.
         * @summary Get Auth URL Route
         * @param {'sign-in' | 'sign-up'} screenHint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthURL: function (screenHint, options) {
            return (0, exports.DefaultApiFp)(configuration).getAuthURL(screenHint, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Requires authentication. Protected route.
         * @summary Get billing plans for the Automated Workflows provider. Returns a list of available plans assignable to users.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutomatedWorkflowBillingPlans: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getAutomatedWorkflowBillingPlans(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Used for development purposes
         * @summary Get billing provider route
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingUuid: function (uuid, options) {
            return (0, exports.DefaultApiFp)(configuration).getBillingUuid(uuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get brand persona for a specific workspace
         * @summary Get brand persona for a specific workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandPersona: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getBrandPersona(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get campaign.access
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignAccess: function (campaignId, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignAccess(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check if its possible create a campaign
         * @summary Campaign checkpoint
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignCheckpoint: function (folderId, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignCheckpoint(folderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a Gif for a campaign
         * @summary Get a Gif for a campaign
         * @param {string} campaignId
         * @param {number} [start]
         * @param {number} [end]
         * @param {string} [width]
         * @param {string} [height]
         * @param {string} [fps]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignIdGif: function (campaignId, start, end, width, height, fps, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignIdGif(campaignId, start, end, width, height, fps, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Used for previews on Dynamic Edit page
         * @summary Get campaign preview for dynamic campaign.
         * @param {string} campaignId
         * @param {string} dynamicId
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignPreviewForDv: function (campaignId, dynamicId, workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignPreviewForDv(campaignId, dynamicId, workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Campaign stats
         * @summary Get Campaign stats
         * @param {string} campaignId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignStats: function (campaignId, limit, offset, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignStats(campaignId, limit, offset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Campaign stats in CSV file
         * @summary Get Campaign stats in CSV file
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignStatsCsv: function (campaignId, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignStatsCsv(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the Campaign thumbnail by the campaignId
         * @summary Campaign thumbnail by campaign id
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignThumbnail: function (campaignId, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignThumbnail(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the Campaign thumbnail urls by the campaignId
         * @summary Campaign thumbnail urls by campaign id
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignThumbnailsUrls: function (campaignId, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignThumbnailsUrls(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all of the Reactions for a campaign
         * @summary Campaign Reactions Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsCampaignidReactions: function (campaignId, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignsCampaignidReactions(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} campaignId
         * @param {boolean} [useProtectedThumbnail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsId: function (campaignId, useProtectedThumbnail, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignsId(campaignId, useProtectedThumbnail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the Campaign public information by the campaignId
         * @summary Campaign Get By Id Route
         * @param {string} id
         * @param {boolean} [sendsparkAppRendering]
         * @param {string} [host]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsIdPublic: function (id, sendsparkAppRendering, host, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignsIdPublic(id, sendsparkAppRendering, host, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a oembed json
         * @summary Generate Oembed Service
         * @param {string} url
         * @param {string} [queryParam]
         * @param {number} [maxheight]
         * @param {string} [companyname]
         * @param {string} [firstname]
         * @param {string} [jobtitle]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsOembed: function (url, queryParam, maxheight, companyname, firstname, jobtitle, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignsOembed(url, queryParam, maxheight, companyname, firstname, jobtitle, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all campaign templates by a folder id
         * @summary Campaigns Templates Route
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsTemplates: function (offset, limit, options) {
            return (0, exports.DefaultApiFp)(configuration).getCampaignsTemplates(offset, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get captions availables
         * @summary Get captions availables
         * @param {string} [assetId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaptionsAvailables: function (assetId, options) {
            return (0, exports.DefaultApiFp)(configuration).getCaptionsAvailables(assetId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Requires a valid automated workflow user to be created first. Protected route.
         * @summary Get all connections from an user in the automated workflow provider.
         * @param {string} xAwToken A custom header for authentication purposes
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionUserAutomatedWorkflow: function (xAwToken, workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getConnectionUserAutomatedWorkflow(xAwToken, workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get available CRM dynamic variables
         * @summary Get available CRM dynamic variables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrmDynamicVariables: function (options) {
            return (0, exports.DefaultApiFp)(configuration).getCrmDynamicVariables(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get crm shortcuts list, only current selected by user
         * @summary Get crm shortcuts list, only current selected by user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrmShortcutsSelectedUserId: function (userId, options) {
            return (0, exports.DefaultApiFp)(configuration).getCrmShortcutsSelectedUserId(userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the Campaign thumbnail information by the campaignId
         * @summary Campaign Thumbnail Info Get Route
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDvv2V1CampaignsCampaignidThumbnailinfo: function (campaignId, options) {
            return (0, exports.DefaultApiFp)(configuration).getDvv2V1CampaignsCampaignidThumbnailinfo(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Dynamic Campaign stats
         * @summary Get Dynamic Campaign stats
         * @param {string} dynamicId
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicCampaignStats: function (dynamicId, limit, offset, options) {
            return (0, exports.DefaultApiFp)(configuration).getDynamicCampaignStats(dynamicId, limit, offset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Dynamic Campaign stats in CSV file
         * @summary Get Dynamic Campaign stats in CSV file
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicCampaignStatsCsv: function (dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).getDynamicCampaignStatsCsv(dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Dynamic Campaign stats summary
         * @summary Get Dynamic Campaign stats summary
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicCampaignStatsSummary: function (dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).getDynamicCampaignStatsSummary(dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the list of Dynamic Campaigns by workspace
         * @summary Get the list of Dynamic Campaigns by workspace
         * @param {string} workspaceId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsList: function (workspaceId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            return (0, exports.DefaultApiFp)(configuration).getDynamicsList(workspaceId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get dynamics settings
         * @summary Get dynamics settings
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsSettings: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getDynamicsSettings(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the list of videos from Dynamic Campaigns by campaignId
         * @summary Get the list of videos from Dynamic Campaigns by campaignId
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsVideosList: function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            return (0, exports.DefaultApiFp)(configuration).getDynamicsVideosList(workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the list of prospects from Dynamic Campaigns by campaignId
         * @summary Get the list of prospects from Dynamic Campaigns by campaignId
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsVideosListV3: function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            return (0, exports.DefaultApiFp)(configuration).getDynamicsVideosListV3(workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the list of prospects from Dynamic Campaigns in CSV file by campaignId
         * @summary Get the list of prospects from Dynamic Campaigns in CSV file by campaignId
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [filters]
         * @param {string} [search]
         * @param {boolean} [dropdownRendering]
         * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
         * @param {'asc' | 'desc'} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicsVideosListV3CSV: function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
            return (0, exports.DefaultApiFp)(configuration).getDynamicsVideosListV3CSV(workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get available embed calendars integrations
         * @summary Get available embed calendars integrations
         * @param {string} workspaceId
         * @param {string} [provider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedCalendars: function (workspaceId, provider, options) {
            return (0, exports.DefaultApiFp)(configuration).getEmbedCalendars(workspaceId, provider, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of campaigns by folder id
         * @summary Folders Route
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {'createdAt' | 'createdAtAscendant' | 'alphabetical'} [orderby]
         * @param {string} [filter]
         * @param {string} [creators]
         * @param {boolean} [ignoreEmptyVideo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderCampaignList: function (workspaceId, folderId, offset, limit, orderby, filter, creators, ignoreEmptyVideo, options) {
            return (0, exports.DefaultApiFp)(configuration).getFolderCampaignList(workspaceId, folderId, offset, limit, orderby, filter, creators, ignoreEmptyVideo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the creators from a folder
         * @summary Creators Folders Route
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderCreators: function (workspaceId, folderId, options) {
            return (0, exports.DefaultApiFp)(configuration).getFolderCreators(workspaceId, folderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all of the campaigns by a folder id
         * @summary Folders Route
         * @param {string} folderId
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersFolderidCampaigns: function (folderId, offset, limit, options) {
            return (0, exports.DefaultApiFp)(configuration).getFoldersFolderidCampaigns(folderId, offset, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all of the folders belongs to a user - deprecated dasboard v1
         * @summary Legacy Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersWorkspaceid: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getFoldersWorkspaceid(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a health message
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: function (options) {
            return (0, exports.DefaultApiFp)(configuration).getHealth(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns Hubspot Sendspark APP OAuth URL.
         * @summary Returns Hubspot Sendspark APP OAuth URL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHubspotOauthUrl: function (options) {
            return (0, exports.DefaultApiFp)(configuration).getHubspotOauthUrl(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * GET current workspace integrations
         * @summary Get your current workspace integrations
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsWorkspaceid: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getIntegrationsWorkspaceid(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get key value from caches
         * @summary Get key value from caches
         * @param {string} key
         * @param {string} segment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeyFromCache: function (key, segment, options) {
            return (0, exports.DefaultApiFp)(configuration).getKeyFromCache(key, segment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This route delete the cookie for the users session
         * @summary Logout Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogout: function (options) {
            return (0, exports.DefaultApiFp)(configuration).getLogout(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Onboarding checklist
         * @summary Get Onboarding checklist
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingChecklist: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getOnboardingChecklist(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get prospect data from prospect email
         * @summary Get prospect data from prospect email
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {string} contactEmail
         * @param {string} [include] Comma-separated list of additional fields to include in the response (emailEmbedHTML, fields)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProspectDynamicsVideos: function (workspaceId, dynamicId, contactEmail, include, options) {
            return (0, exports.DefaultApiFp)(configuration).getProspectDynamicsVideos(workspaceId, dynamicId, contactEmail, include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get public template info
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicTemplate: function (workspaceId, templateId, options) {
            return (0, exports.DefaultApiFp)(configuration).getPublicTemplate(workspaceId, templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all of the Reactions
         * @summary Reactions Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReactionsId: function (id, options) {
            return (0, exports.DefaultApiFp)(configuration).getReactionsId(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get public share preview
         * @param {string} workspaceId
         * @param {'template' | 'dynamic-video' | 'campaign' | 'workspace'} previewType
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharePreview: function (workspaceId, previewType, id, options) {
            return (0, exports.DefaultApiFp)(configuration).getSharePreview(workspaceId, previewType, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get available subscription churn reason codes route
         * @summary Get available subscription churn reason codes route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionCancellationReasons: function (options) {
            return (0, exports.DefaultApiFp)(configuration).getSubscriptionCancellationReasons(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Do not use this endpoint to get normal subscription previews, just for trial previews
         * @summary Get subscription for trial previews only
         * @param {string} workspaceId
         * @param {SubscriptionPreviewTrialPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionsPreviewTrial: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).getSubscriptionsPreviewTrial(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get subscription previews route
         * @summary Get subscription previews route
         * @param {string} workspaceId
         * @param {SubscriptionPreviewsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionsPreviews: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).getSubscriptionsPreviews(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get available subscriptions types list route
         * @summary Get available subscriptions types list route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionsTypesList: function (options) {
            return (0, exports.DefaultApiFp)(configuration).getSubscriptionsTypesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace usage transactions balance
         * @summary Get workspace usage transactions balance
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsBalance: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getTransactionsBalance(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get share url from dynamic video prospect email
         * @summary Get share url from dynamic video prospect email
         * @param {string} xApiKey
         * @param {string} prospectEmail
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrlProspectDynamics: function (xApiKey, prospectEmail, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).getUrlProspectDynamics(xApiKey, prospectEmail, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Get an user to the Automated Workflows provider. Returns a valid user object for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAutomatedWorkflow: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getUserAutomatedWorkflow(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get site connections list, only current selected by user
         * @summary Get site connections list available by user Route.
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSiteConnectionsList: function (userId, options) {
            return (0, exports.DefaultApiFp)(configuration).getUserSiteConnectionsList(userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * GET current user route
         * @summary Get your current user route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (options) {
            return (0, exports.DefaultApiFp)(configuration).getUsers(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Webhook called when transcription process is complete
         * @summary Webhook called when transcription process is complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1AiTranscriptionWebhookUpdate: function (options) {
            return (0, exports.DefaultApiFp)(configuration).getV1AiTranscriptionWebhookUpdate(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1GoogleLogin: function (options) {
            return (0, exports.DefaultApiFp)(configuration).getV1GoogleLogin(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the Campaign by the requestId
         * @summary Get Campaign By request id Route
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoRequestByRequestId: function (id, options) {
            return (0, exports.DefaultApiFp)(configuration).getVideoRequestByRequestId(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Webhook by ID
         * @summary Get Webhook by ID
         * @param {string} workspaceId
         * @param {string} webhookId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookById: function (workspaceId, webhookId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWebhookById(workspaceId, webhookId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Webhook list by workspace ID
         * @summary Get Webhook list by workspace ID
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookListByWorkspaceId: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWebhookListByWorkspaceId(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace id by api key
         * @summary Get workspace id by api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceByApiKey: function (options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspaceByApiKey(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspce custom domain
         * @summary Get workspce custom domain
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceCustomDomain: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspaceCustomDomain(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace dynamic campaign
         * @summary Get workspace dynamic campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceDynamics: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspaceDynamics(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get creators from workspace dynamic campaign
         * @summary Get creators from workspace dynamic campaign
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceDynamicsCreators: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspaceDynamicsCreators(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace global styles route by workspace id.
         * @summary Get workspace global styles route.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceGlobalStyles: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspaceGlobalStyles(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Search for campaigns inside a workspace
         * @summary Workspace Campaign Search Route
         * @param {string} workspaceId
         * @param {string} search
         * @param {boolean} [skipRequestCampaigns]
         * @param {boolean} [skipCustomIntroCampaigns]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceSearch: function (workspaceId, search, skipRequestCampaigns, skipCustomIntroCampaigns, offset, limit, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspaceSearch(workspaceId, search, skipRequestCampaigns, skipCustomIntroCampaigns, offset, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {boolean} [legacy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceStats: function (workspaceId, legacy, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspaceStats(workspaceId, legacy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace subscription
         * @summary Get workspace subscription
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceSubscription: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspaceSubscription(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace template
         * @summary Get workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceTemplate: function (workspaceId, templateId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspaceTemplate(workspaceId, templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace templates by workspace id
         * @summary Get workspace templates by workspace id
         * @param {string} workspaceId
         * @param {string} [name]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [appLatest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceTemplates: function (workspaceId, name, offset, limit, appLatest, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspaceTemplates(workspaceId, name, offset, limit, appLatest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the list of the current users workspaces
         * @summary Get the list of the current users workspaces
         * @param {boolean} [dropdownRendering]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaces: function (dropdownRendering, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspaces(dropdownRendering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace by id
         * @summary Get workspace by id
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesId: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspacesId(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser V1
         * @summary Get the current users workspace settings. V1
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesSettings: function (userId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspacesSettings(userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the legacy current users workspace usage.
         * @param {'all' | 'videos' | 'users'} usageType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesUsage: function (usageType, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspacesUsage(usageType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the list of the assets
         * @summary Get the list of the assets
         * @param {string} workspaceId
         * @param {string} [folder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidAssets: function (workspaceId, folder, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspacesWorkspaceidAssets(workspaceId, folder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns stats of the workspace
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideos: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspacesWorkspaceidCreatedvideos(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns stats of the workspace
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidCreatedvideosv2: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspacesWorkspaceidCreatedvideosv2(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the workspace folders that the user has access
         * @summary Workspace Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidFolders: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspacesWorkspaceidFolders(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the workspace main folders that the user has access
         * @summary Workspace Main Folders Route
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidFoldersMain: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspacesWorkspaceidFoldersMain(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns stats of the workspace
         * @param {string} workspaceId
         * @param {number} usersNumber
         * @param {boolean} [legacy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesWorkspaceidTopvideosUsersnumber: function (workspaceId, usersNumber, legacy, options) {
            return (0, exports.DefaultApiFp)(configuration).getWorkspacesWorkspaceidTopvideosUsersnumber(workspaceId, usersNumber, legacy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a health message
         * @summary Health Check. Requires authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckProtected: function (options) {
            return (0, exports.DefaultApiFp)(configuration).healthCheckProtected(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saves Hubspot oauth tokens and returns 200
         * @summary Hubspot oauth callback endpoint. Saves Hubspot oauth tokens and returns 200.
         * @param {string} [code]
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hubspotOauthCallback: function (code, state, options) {
            return (0, exports.DefaultApiFp)(configuration).hubspotOauthCallback(code, state, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns an array of objects with all the templates available for generating AI Script templates.
         * @summary List AI Script Templates Options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiTemplatesOptions: function (options) {
            return (0, exports.DefaultApiFp)(configuration).listAiTemplatesOptions(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Logout user route
         * @summary Logout current user from all tabs
         * @param {UserLogoutPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutUser: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).logoutUser(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Only support name change and language code change.
         * @summary Use this route to update an asset information.
         * @param {string} assetId
         * @param {AssetPatchPatamsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAsset: function (assetId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchAsset(assetId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the brand persona details for the specified workspace
         * @summary Update brand persona for a specific workspace
         * @param {string} workspaceId
         * @param {BrandPersona} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBrandPersona: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchBrandPersona(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Send an array with a valid asset id to create a Custom Intro campaign for it, or send and empty array to remove it.
         * @summary Used for custom Intros feature
         * @param {string} campaignId
         * @param {CampaignPatchAssetsPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssets: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchCampaignAssets(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Campaign assets restore
         * @summary Campaign assets restore
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssetsRestore: function (campaignId, options) {
            return (0, exports.DefaultApiFp)(configuration).patchCampaignAssetsRestore(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Campaign assets trim
         * @summary Campaign assets trim
         * @param {string} campaignId
         * @param {RequestPayloadCampaignAssetsTrimSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssetsTrim: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchCampaignAssetsTrim(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *            Use for patch campaign assets                      If you need remove all additional assets, you need to send one asset at least (position 0 asset)
         * @summary Campaign assets add
         * @param {string} campaignId
         * @param {RequestCampaignPatchAssetsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignAssetsV2: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchCampaignAssetsV2(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Move campaigns within a folder
         * @summary Move Campaigns action
         * @param {string} folderId
         * @param {RequestPayloadDeleteCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignMove: function (folderId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchCampaignMove(folderId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a campaign settings by Id Route
         * @param {string} campaignId
         * @param {Model81} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignSettingsId: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchCampaignSettingsId(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Use this route to apply a given template to the campaign
         * @summary Apply template fields to a campaign
         * @param {string} campaignId
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignTemplateApply: function (campaignId, templateId, options) {
            return (0, exports.DefaultApiFp)(configuration).patchCampaignTemplateApply(campaignId, templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update campaign thumbnail by the campaign id
         * @summary Update campaign thumbnail by campaign id
         * @param {string} campaignId
         * @param {PatchPayloadCampaignThumbnailsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignThumbnail: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchCampaignThumbnail(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a campaign By Id Route
         * @param {string} campaignId
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaignsId: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchCampaignsId(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Insert or update prospect in Dynamics Campaign
         * @summary Insert or update prospect in Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadDynamicModifyProspectSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicModifyProspect: function (workspaceId, dynamicId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchDynamicModifyProspect(workspaceId, dynamicId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update settings in Dynamics Campaign
         * @summary Update settings in Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadDynamicModifySettingsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicModifySettings: function (workspaceId, dynamicId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchDynamicModifySettings(workspaceId, dynamicId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Modify Dynamics Campaign in folder
         * @summary Modify Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadModifyDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicsModify: function (workspaceId, dynamicsId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchDynamicsModify(workspaceId, dynamicsId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Persisting Prospect Lists
         * @summary Persisting Prospect Lists
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {Model93} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicsModifyV2: function (workspaceId, dynamicsId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchDynamicsModifyV2(workspaceId, dynamicsId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint is used to bulk update prospect background URLs based on email domains.
         * @summary Bulk update prospect background URLs based on email domains.
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadBulkUpdateProspectsUrlSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDynamicsProspectsUrlsBulkUpdate: function (workspaceId, dynamicsId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchDynamicsProspectsUrlsBulkUpdate(workspaceId, dynamicsId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Modify a folder name, more in the future.
         * @summary Folder Modify Route
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {FolderModifyRequestpayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFoldersModify: function (workspaceId, folderId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchFoldersModify(workspaceId, folderId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Move a folder within a workspace
         * @summary Move Folder action
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {FolderMoveRequestPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFoldersMove: function (workspaceId, folderId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchFoldersMove(workspaceId, folderId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Modify Webhook
         * @summary Modify Webhook
         * @param {string} workspaceId
         * @param {string} webhookId
         * @param {ModifyWebhookRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchModifyWebhook: function (workspaceId, webhookId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchModifyWebhook(workspaceId, webhookId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update user or workspace onboarding checklist
         * @summary Update user or workspace onboarding checklist
         * @param {string} workspaceId
         * @param {ResponseOnboardingUpdatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOnboardingChecklist: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchOnboardingChecklist(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Only support uploading status change.
         * @summary Use this route to update the uploadingStatus of the asset.
         * @param {string} assetId
         * @param {AssetPatchUploadStatusPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUploadStatusAsset: function (assetId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchUploadStatusAsset(assetId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update user crm shortcuts selected
         * @summary Update user crm shortcuts selected
         * @param {string} userId
         * @param {CrmShortcutsModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserCrmShortcuts: function (userId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchUserCrmShortcuts(userId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update instant integrations from user
         * @summary Update instant integrations from user
         * @param {InstantIntegrationModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserInstantIntegrations: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchUserInstantIntegrations(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Route for users to modify their private site credentials route.
         * @summary Modify user private site credentials Route
         * @param {string} userId
         * @param {string} integrationId
         * @param {ModifyUserSiteConnectionsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserSiteConnections: function (userId, integrationId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchUserSiteConnections(userId, integrationId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchV1GoogleLogin: function (options) {
            return (0, exports.DefaultApiFp)(configuration).patchV1GoogleLogin(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Modify workspace global styles route by workspace id.
         * @summary Modify workspace global styles route.
         * @param {string} workspaceId
         * @param {WorkspaceStylesModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceGlobalStyles: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchWorkspaceGlobalStyles(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a workspace integration
         * @summary Update a workspace integration
         * @param {string} workspaceId
         * @param {string} integrationId
         * @param {Values} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceIntegrations: function (workspaceId, integrationId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchWorkspaceIntegrations(workspaceId, integrationId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Cancel a workspace subscription at the end of period
         * @summary Cancel a workspace subscription at the end of period
         * @param {string} workspaceId
         * @param {SubscriptionCancelPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceSubscriptionCancel: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchWorkspaceSubscriptionCancel(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Reactivate a workspace subscription canceled or pending cancellation status
         * @summary Reactivate a workspace subscription canceled or pending cancellation status
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceSubscriptionReactivate: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).patchWorkspaceSubscriptionReactivate(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Modify workspace template
         * @summary Modify workspace template
         * @param {string} workspaceId
         * @param {string} templateId
         * @param {WorkspaceTemplatesModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceTemplates: function (workspaceId, templateId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchWorkspaceTemplates(workspaceId, templateId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add additional features to workspace by owners
         * @param {'storage' | 'workspaces' | 'videos' | 'creators'} feature
         * @param {'double'} value
         * @param {WorkspaceAdditionalFeaturesSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesAdditionalfeatures: function (feature, value, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchWorkspacesAdditionalfeatures(feature, value, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace by id
         * @summary Get workspace by id
         * @param {string} workspaceId
         * @param {RequestWorkspacesModifyPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesId: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).patchWorkspacesId(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Replace the current users last visited workspace with the id provided.
         * @summary Replace the current users last visited workspace with the id provided.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspacesIdChange: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).patchWorkspacesIdChange(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get scripts improvement
         * @summary Get scripts improvement
         * @param {AiScriptGeneratorParamsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiScriptsGenerator: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postAiScriptsGenerator(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Start process to transcript a video
         * @summary Start process to transcript a video
         * @param {string} assetId
         * @param {TranscriptPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiTranscriptionCreate: function (assetId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postAiTranscriptionCreate(assetId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate a valid JWT for our AppSumo intergration
         * @summary Returns a valid JWT for AppSumo intergration
         * @param {AppSumoLoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoAuthLogin: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postAppsumoAuthLogin(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * When a Sumo-ling buys interacts with our license, we get a notification
         * @summary AppSumo notifications
         * @param {AppSumoNotificationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppsumoWebhookNotification: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postAppsumoWebhookNotification(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create assets
         * @summary Create assets Route
         * @param {CreateAssetPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssets: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postAssets(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Forgot Password Route
         * @param {ForgotPasswordPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthForgotpassword: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postAuthForgotpassword(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Authorize Device for user
         * @summary Authorize Device
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthorizeDevice: function (deviceId, options) {
            return (0, exports.DefaultApiFp)(configuration).postAuthorizeDevice(deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create Campaign in folder
         * @summary Create Campaign
         * @param {string} folderId
         * @param {RequestPayloadCreateCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaign: function (folderId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postCampaign(folderId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new Reaction to a Campaign Video
         * @summary Create a new Reaction
         * @param {string} campaignId
         * @param {CampaignReactionPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsCampaignidReactions: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postCampaignsCampaignidReactions(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the Campaign by the campaignId
         * @summary Duplicate Campaign
         * @param {string} campaignId
         * @param {RequestPayloadDuplicateCreateCampaignSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsDuplicate: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postCampaignsDuplicate(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates/create the Campaign thumbnails by asset
         * @summary Load Campaign Thumbnails
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsLoadThumbnails: function (campaignId, options) {
            return (0, exports.DefaultApiFp)(configuration).postCampaignsLoadThumbnails(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new Campaign based on a Template
         * @summary Create a new Campaign based on a Template
         * @param {string} campaignId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCampaignsUseTemplate: function (campaignId, options) {
            return (0, exports.DefaultApiFp)(configuration).postCampaignsUseTemplate(campaignId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Being used for update changes in subscriptions (database).
         * @summary Webhook to get an event when an subscription change.
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChargifyWebhooksSubscriptionsToken: function (token, options) {
            return (0, exports.DefaultApiFp)(configuration).postChargifyWebhooksSubscriptionsToken(token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Clear key cache
         * @summary Clear key cache
         * @param {string} key
         * @param {string} segment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClearKeyCache: function (key, segment, options) {
            return (0, exports.DefaultApiFp)(configuration).postClearKeyCache(key, segment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new Webhook
         * @summary Create new Webhook
         * @param {string} workspaceId
         * @param {CreateWebhookRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCreateWebhook: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postCreateWebhook(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create Dynamics Campaign in folder
         * @summary Create Dynamics Campaign
         * @param {string} workspaceId
         * @param {RequestParamsCreateDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamics: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamics(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Duplicate Dynamic Campaign by the dynamicsId
         * @summary Duplicate Dynamic Campaign
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsDuplicate: function (dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsDuplicate(dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Listed in API Gateway only.
         * @summary Bulk add and process prospects to a dynamics campaign.
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadBulkProspectsDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsProspectsBulkModify: function (workspaceId, dynamicsId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsProspectsBulkModify(workspaceId, dynamicsId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create Dynamics Campaign in folder for the DV by steps UI
         * @summary Create Dynamics Campaign for the DV by steps UI
         * @param {string} workspaceId
         * @param {Model67} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsV2: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsV2(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add dynamic video to Dynamics Campaign in folder
         * @summary Add dynamic video to Dynamics Campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestParamsDynamicsVideoAddSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideoAdd: function (workspaceId, dynamicId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideoAdd(workspaceId, dynamicId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate videos for Dynamics Campaign prospect list
         * @summary Generate videos for Dynamics Campaign prospect list
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideoBulk: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideoBulk(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new campaigns for Dynamics Video prospect list
         * @summary Create new campaigns for Dynamics Video prospect list
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosCreateCampaign: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosCreateCampaign(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get screenshot by web site url
         * @summary Get screenshot by web site url
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosCreateScreenshot: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosCreateScreenshot(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get screenshot by web site url v2
         * @summary Get screenshot by web site url v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosCreateScreenshotV2: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosCreateScreenshotV2(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate audio cloned from prospect
         * @summary Generate audio cloned from prospect
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateAudioRouteV2: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosGenerateAudioRouteV2(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate campaign by dynamics videos v2
         * @summary Generate campaign by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateCampaignV2: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosGenerateCampaignV2(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate lipsync by dynamics videos v2
         * @summary Generate lipsync by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateLipsyncV2: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosGenerateLipsyncV2(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate resources for dynamics campaign
         * @summary Generate resources for dynamics campaign
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {RequestPayloadGenerateDynamicsResourceSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateResourcesV2: function (workspaceId, dynamicId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosGenerateResourcesV2(workspaceId, dynamicId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get transcription by dynamics videos v2
         * @summary Get transcription by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateTranscriptionV2: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosGenerateTranscriptionV2(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate trim video from prospect
         * @summary Generate trim video from prospect
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateTrimVideoRouteV2: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosGenerateTrimVideoRouteV2(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate video by dynamics videos v2
         * @summary Generate video by dynamics videos v2
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateVideoV2: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosGenerateVideoV2(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate voice cloned from dynamics
         * @summary Generate voice cloned from dynamics
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGenerateVoiceV2: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosGenerateVoiceV2(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Guardian by Dynamics Videos
         * @summary Guardian by Dynamics Videos
         * @param {DynamicsVideosGuardianPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosGuardian: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosGuardian(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This route is used to migrate the prospectList property from the Dynamics collection to the Prospects collection.
         * @summary Migration of prospectList property from Dynamics collection to Prospects collection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosProspectsMigration: function (options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosProspectsMigration(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Queues recovery by Dynamics Videos
         * @summary Queues recovery by Dynamics Videos
         * @param {string} dynamicId
         * @param {DynamicsVideosRecoveryPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDynamicsVideosQueuesRecovery: function (dynamicId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postDynamicsVideosQueuesRecovery(dynamicId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This receive an open object that containts the data we have to track
         * @summary Sendspark event to track user activity
         * @param {EventPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEvents: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postEvents(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a folder inside a workspace
         * @summary Folder Create Route
         * @param {string} workspaceId
         * @param {FolderCreateRequestPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFoldersCreate: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postFoldersCreate(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Move multiple folders to another folder
         * @summary Move multiple folders to another folder
         * @param {string} workspaceId
         * @param {string} folderId
         * @param {RequestFolderMoveMultiplePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFoldersMoveMultiple: function (workspaceId, folderId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postFoldersMoveMultiple(workspaceId, folderId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Load Thumbnails legacy from API v1
         * @summary Load Thumbnails legacy from API v1
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLoadThumbnailsLegacy: function (id, options) {
            return (0, exports.DefaultApiFp)(configuration).postLoadThumbnailsLegacy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Register new logger event
         * @summary Register new logger event
         * @param {LoggerRequestSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogger: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postLogger(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * User Login Route that returns a valid JTW
         * @summary Login Route
         * @param {LoginPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogin: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postLogin(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Logout Desktop App for user
         * @summary Logout Device
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogoutDevice: function (deviceId, options) {
            return (0, exports.DefaultApiFp)(configuration).postLogoutDevice(deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Being used for websockets to push events to the frontend.
         * @summary Webhook to get an event when an the asset is ready.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMuxWebhookVideoready: function (options) {
            return (0, exports.DefaultApiFp)(configuration).postMuxWebhookVideoready(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Request a new Video Campaign for the workspace passed as parameter
         * @summary Request Video Campaign
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestCampaign: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).postRequestCampaign(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace additional usage transactions purchase preview
         * @summary Get workspace additional usage transactions purchase preview
         * @param {string} workspaceId
         * @param {boolean} [generateFirstVideos]
         * @param {TransactionsPreviewPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransactionsPreview: function (workspaceId, generateFirstVideos, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postTransactionsPreview(workspaceId, generateFirstVideos, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace additional usage transactions purchase
         * @summary Make workspace additional usage transactions purchase
         * @param {string} workspaceId
         * @param {TransactionsPurchasePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransactionsPurchase: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postTransactionsPurchase(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new Upload Url
         * @summary Create new Upload Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadUrl: function (options) {
            return (0, exports.DefaultApiFp)(configuration).postUploadUrl(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Clean Upload Urls expired
         * @summary Clean Upload Urls expired
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadUrlCleanExpired: function (options) {
            return (0, exports.DefaultApiFp)(configuration).postUploadUrlCleanExpired(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Route for users to store their private site credentials route.
         * @summary Create user private site credentials Route.
         * @param {string} userId
         * @param {CreateUserSiteConnectionsPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserSiteConnections: function (userId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postUserSiteConnections(userId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add meeting links for the user passed as parameter
         * @summary Create meeting links for user
         * @param {string} userId
         * @param {UsersMeetingLinksPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUsersMeetingLinks: function (userId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postUsersMeetingLinks(userId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Brand Persona test
         * @summary Brand Persona test
         * @param {Model53} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiBrandpersonagenerator: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postV1AiBrandpersonagenerator(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a customized email template using AI by processing a previously generated video script template
         * @summary Generates an email template based on a video script template
         * @param {Model54} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiEmailtemplategenerator: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postV1AiEmailtemplategenerator(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Takes an AI-generated email template and creates a matching landing page template maintaining consistent messaging and branding
         * @summary Generates a landing page template based on an existing email template
         * @param {Model55} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiLandingpagetemplategenerator: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postV1AiLandingpagetemplategenerator(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Webhook called when transcription process is complete
         * @summary Webhook called when transcription process is complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1AiTranscriptionWebhookUpdate: function (options) {
            return (0, exports.DefaultApiFp)(configuration).postV1AiTranscriptionWebhookUpdate(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1GoogleLogin: function (options) {
            return (0, exports.DefaultApiFp)(configuration).postV1GoogleLogin(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate videos for Dynamics Campaign prospect list
         * @summary Generate videos for Dynamics Campaign prospect list
         * @param {string} workspaceId
         * @param {string} dynamicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1WorkspacesWorkspaceidDynamicsDynamicidBulk: function (workspaceId, dynamicId, options) {
            return (0, exports.DefaultApiFp)(configuration).postV1WorkspacesWorkspaceidDynamicsDynamicidBulk(workspaceId, dynamicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * API Gateway only.
         * @summary Add prospect to Dynamics Campaign and process video.
         * @param {string} workspaceId
         * @param {string} dynamicsId
         * @param {RequestPayloadAddProspectsDynamicsCampaignsSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postV1WorkspacesWorkspaceidDynamicsDynamicsidProspect: function (workspaceId, dynamicsId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postV1WorkspacesWorkspaceidDynamicsDynamicsidProspect(workspaceId, dynamicsId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new workspace integration
         * @param {string} workspaceId
         * @param {WorkspaceIntegrationsCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceIntegrations: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postWorkspaceIntegrations(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create or switch workspace subscription
         * @summary Create or switch workspace subscription
         * @param {string} workspaceId
         * @param {WorkspaceSubscriptionCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceSubscription: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postWorkspaceSubscription(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Apply discount on subscription
         * @summary Apply discount on subscription
         * @param {string} workspaceId
         * @param {WorkspaceSubscriptionApplyDiscountRequestSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceSubscriptionApplyDiscount: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postWorkspaceSubscriptionApplyDiscount(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Apply discount on onboarding process
         * @summary Apply discount on onboarding process
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceSubscriptionApplyOnboardingDiscount: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).postWorkspaceSubscriptionApplyOnboardingDiscount(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new workspace template
         * @summary Create a new workspace template
         * @param {string} workspaceId
         * @param {WorkspaceTemplatesCreatePayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaceTemplates: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postWorkspaceTemplates(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Optionally we can pass the userId, it will default to currentUser
         * @summary Create a new workspace
         * @param {CreateWorkspaceResponseSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspaces: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).postWorkspaces(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get workspace by id
         * @summary Create custom domain to workspace
         * @param {string} workspaceId
         * @param {WorkspaceCustomDomainCreatePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspacesWorkspaceidCustomdomain: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postWorkspacesWorkspaceidCustomdomain(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * We need pass the emails to invite to this route
         * @summary Workspace invite route
         * @param {string} workspaceId
         * @param {WorkspaceInvitePayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWorkspacesWorkspaceidInvite: function (workspaceId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).postWorkspacesWorkspaceidInvite(workspaceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Queues recovery by prospectId
         * @summary Queues to check if prospect is healthy
         * @param {string} prospectId Prospect ID
         * @param {string} dynamicId
         * @param {Model73} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prospectsHealthyQueues: function (prospectId, dynamicId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).prospectsHealthyQueues(prospectId, dynamicId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Completes the activation for appsumo packages.
         * @param {AppSumoActivationPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAppsumoActivation: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).putAppsumoActivation(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update asset mime type
         * @summary Update mime type for an asset
         * @param {string} assetId
         * @param {UpdateAssetPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAssetsIdMime: function (assetId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).putAssetsIdMime(assetId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Google login route
         * @summary Google Login Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putV1GoogleLogin: function (options) {
            return (0, exports.DefaultApiFp)(configuration).putV1GoogleLogin(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a campaign By Request Id Route
         * @param {string} requestId
         * @param {VideoRequestPayloadSchema} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVideoRequestById: function (requestId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).putVideoRequestById(requestId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Get an user refresh token for the Automated Workflows provider. Returns a valid user session token for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokenUserAutomatedWorkflow: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).refreshTokenUserAutomatedWorkflow(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Requires a valid Sendspark user to be created first. Protected route.
         * @summary Register an user to the Automated Workflows provider. Returns a valid user object for the Automated Workflows provider.
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUserAutomatedWorkflow: function (workspaceId, options) {
            return (0, exports.DefaultApiFp)(configuration).registerUserAutomatedWorkflow(workspaceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get total videos by workspace
         * @summary Get total videos by workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTotalVideosByWorkspace: function (options) {
            return (0, exports.DefaultApiFp)(configuration).reportTotalVideosByWorkspace(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Validate access to reports
         * @summary Validate access to reports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportValidateAccess: function (options) {
            return (0, exports.DefaultApiFp)(configuration).reportValidateAccess(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Patch Campaign Summary Views
         * @summary Patch Campaign Summary Views
         * @param {string} campaignId
         * @param {Model83} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaignSummaryViews: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).updateCampaignSummaryViews(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a campaign video Id by campaign Id Route
         * @param {string} campaignId
         * @param {PayloadCampaignVideo} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaignVideoId: function (campaignId, body, options) {
            return (0, exports.DefaultApiFp)(configuration).updateCampaignVideoId(campaignId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * PATCH current user route
         * @summary Modify current user logged in route
         * @param {UserModifyPayload} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentUser: function (body, options) {
            return (0, exports.DefaultApiFp)(configuration).updateCurrentUser(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary WorkOs Webhook Listener route.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workosEventsListener: function (options) {
            return (0, exports.DefaultApiFp)(configuration).workosEventsListener(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Activate enterprise features for workspace
     * @summary Activate enterprise features for workspace
     * @param {string} workspaceId
     * @param {WorkspaceActivateEnterpriseFeaturesPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.activateWorkspaceEnterpriseFeatures = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).activateWorkspaceEnterpriseFeatures(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add password to campaign.access
     * @param {string} campaignId
     * @param {PayloadCampaignPassword} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.addCampaignPassword = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).addCampaignPassword(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Requires a valid automated workflow user to be created first. Protected route.
     * @summary Performs a connection between an automated workflows user and our Sendspark app in the automated workflow provider.
     * @param {string} xAwToken A custom header for authentication purposes
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.addConnectionUserAutomatedWorkflow = function (xAwToken, workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).addConnectionUserAutomatedWorkflow(xAwToken, workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * The amount of transactions (count) must be a mutiple of 100
     * @summary Add extra transaction to a user in albato
     * @param {string} workspaceId
     * @param {AddTransactionToBillingPlanSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.addTransactionToBillingPlan = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).addTransactionToBillingPlan(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Requires authentication. Protected route.
     * @summary Assign billing plans to the user for the Automated Workflows provider.
     * @param {string} workspaceId
     * @param {AutomatedWorkflowsPlanAssignmentBodyPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.assignAutomatedWorkflowBillingPlans = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).assignAutomatedWorkflowBillingPlans(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Auth callback route.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.authCallback = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).authCallback(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Auth login resolve route.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.authLoginResolve = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).authLoginResolve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Auth signup resolve route.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.authSignupResolve = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).authSignupResolve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Do not support video update
     * @summary Use this route to update an campaign meta text data
     * @param {string} campaignId
     * @param {CampaignMetaPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.campaignMetaUpdate = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).campaignMetaUpdate(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generates email, landing page and video scripts for users based on base templates.
     * @summary AI Scripts templates generator.
     * @param {CreateAiScriptsTemplatesSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createAiScriptsTemplates = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createAiScriptsTemplates(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generates a video script to be used in a teleprompter generated by AI
     * @summary AI Video script templates generator
     * @param {CreateAiVideoScriptsTemplatesSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createAiVideoScriptsTemplate = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createAiVideoScriptsTemplate(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Route for users to Create API Key for workspace.
     * @summary Create Public API key for workspace.
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createApiKeys = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createApiKeys(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a Gif for a campaign based on video
     * @summary Create a Gif for a campaign based on video
     * @param {string} assetId
     * @param {any} file
     * @param {number} [start]
     * @param {number} [end]
     * @param {string} [width]
     * @param {string} [height]
     * @param {string} [fps]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createCampaignIdGif = function (assetId, file, start, end, width, height, fps, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createCampaignIdGif(assetId, file, start, end, width, height, fps, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Route for users to Create Secret for API Key.
     * @summary Create Secret for API key.
     * @param {string} workspaceId
     * @param {string} apikeyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createSecretFromApiKeys = function (workspaceId, apikeyId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createSecretFromApiKeys(workspaceId, apikeyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create Asset for video request
     * @summary Create Asset for video request
     * @param {string} requestId
     * @param {VideoRequestAssetCreatePayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createVideoRequestAssetByRequestId = function (requestId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createVideoRequestAssetByRequestId(requestId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create voice cloning for Dynamics Campaign in folder
     * @summary Create voice cloning for Dynamics Campaign
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {RequestPayloadCreateDynamicsVoiceCloningSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createVoiceCloningForDynamicsCampaign = function (workspaceId, dynamicId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createVoiceCloningForDynamicsCampaign(workspaceId, dynamicId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deactivate enterprise features for workspace
     * @summary Deactivate enterprise features for workspace
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deactivateWorkspaceEnterpriseFeatures = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deactivateWorkspaceEnterpriseFeatures(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Route for users to delete Apikey for workspace.
     * @summary Delete Apikey for workspace
     * @param {string} workspaceId
     * @param {string} apikeyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteApikey = function (workspaceId, apikeyId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteApikey(workspaceId, apikeyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete assets by ID
     * @summary Delete assets Route
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteAssetsId = function (assetId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteAssetsId(assetId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Route for users to Delete their workspace-leve auth connections route.
     * @summary Delete workspace auth connections Route
     * @param {string} workspaceId
     * @param {string} integrationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteAuthConnections = function (workspaceId, integrationId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteAuthConnections(workspaceId, integrationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a Gif for a campaign based on video
     * @summary Delete a Gif for a campaign based on video
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteCampaignIdGif = function (campaignId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteCampaignIdGif(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete password from campaign.access
     * @param {string} campaignId
     * @param {string} passwordId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteCampaignPassword = function (campaignId, passwordId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteCampaignPassword(campaignId, passwordId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete the Campaign by the campaignId
     * @summary Delete Campaign By Id Route
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteCampaignsId = function (campaignId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteCampaignsId(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete the custom domain by the workspaceId
     * @summary Delete custom domain by workspace id route
     * @param {string} workspaceId
     * @param {string} domainName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteCustomDomainByWorkspaceId = function (workspaceId, domainName, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteCustomDomainByWorkspaceId(workspaceId, domainName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete Dynamics Campaign and folder
     * @summary Delete Dynamics Campaign
     * @param {string} workspaceId
     * @param {string} dynamicsId
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteDynamics = function (workspaceId, dynamicsId, force, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteDynamics(workspaceId, dynamicsId, force, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete folder by id
     * @summary Folder Delete Route
     * @param {string} folderId
     * @param {RequestPayloadDeleteFolderSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteFoldersFolderid = function (folderId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteFoldersFolderid(folderId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete animated and static thumbnails generated by the share faster feature
     * @summary Delete custom thumbnails for an assetId
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteGifByAssetId = function (assetId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteGifByAssetId(assetId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete the Campaigns by the campaignId. Requires folderId to validate user ownership
     * @summary Delete Multiple Campaigns by Id Route
     * @param {string} folderId
     * @param {RequestPayloadDeleteCampaignsSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteMultipleCampaignsById = function (folderId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteMultipleCampaignsById(folderId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete prospect from dynamic video
     * @summary Delete prospect from dynamic video
     * @param {string} workspaceId
     * @param {string} dynamicsId
     * @param {boolean} [deleteAll]
     * @param {DynamicDeleteProspectPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteProspectDynamics = function (workspaceId, dynamicsId, deleteAll, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteProspectDynamics(workspaceId, dynamicsId, deleteAll, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete Reaction by ID
     * @summary Delete Reaction Route
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteReactionsId = function (id, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteReactionsId(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Route for users to delete Secret Token for API key.
     * @summary Delete Secret Token for API key.
     * @param {string} workspaceId
     * @param {string} apikeyId
     * @param {string} secretId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteSecretFromApikey = function (workspaceId, apikeyId, secretId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteSecretFromApikey(workspaceId, apikeyId, secretId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Requires a valid Sendspark user to be created first. Protected route.
     * @summary Deletes an user for the Automated Workflows provider.
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteUserAutomatedWorkflow = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteUserAutomatedWorkflow(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Route for users to Delete their private site connections route.
     * @summary Delete user private site connections Route
     * @param {string} userId
     * @param {string} integrationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteUserSiteConnections = function (userId, integrationId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteUserSiteConnections(userId, integrationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Google login route
     * @summary Google Login Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteV1GoogleLogin = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteV1GoogleLogin(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete Webhook by ID
     * @summary Delete Webhook by ID
     * @param {string} workspaceId
     * @param {string} webhookId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteWebhookById = function (workspaceId, webhookId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteWebhookById(workspaceId, webhookId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Workspace Integration by integration id
     * @param {string} workspaceId
     * @param {string} integrationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteWorkspaceIntegrations = function (workspaceId, integrationId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteWorkspaceIntegrations(workspaceId, integrationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete workspace template
     * @summary Delete workspace template
     * @param {string} workspaceId
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteWorkspaceTemplate = function (workspaceId, templateId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteWorkspaceTemplate(workspaceId, templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete workspace by id
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteWorkspacesWorkspaceid = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteWorkspacesWorkspaceid(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Remove an invited member from the workspace.
     * @summary Remove an invited member from the workspace.
     * @param {string} workspaceId
     * @param {string} invitedUserId
     * @param {RequestWorkspaceMembersDeletePayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteWorkspacesWorkspaceidMembersInviteduserid = function (workspaceId, invitedUserId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteWorkspacesWorkspaceidMembersInviteduserid(workspaceId, invitedUserId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Duplicate workspace template
     * @summary Duplicate workspace template
     * @param {string} workspaceId
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.duplicateWorkspaceTemplate = function (workspaceId, templateId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).duplicateWorkspaceTemplate(workspaceId, templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Campaign identifier needs to be the share id of the campaign.
     * @summary Route to generate JWT token based on the password input to access a protected campaign
     * @param {string} shareId
     * @param {PayloadCampaignPassword} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.generateAuthTokenForCampaignAccess = function (shareId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).generateAuthTokenForCampaignAccess(shareId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Route for users to get all API keys for a workspace.
     * @summary Get all API keys for a workspace.
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getApiKeys = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getApiKeys(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets Auth URL.
     * @summary Get Auth URL Route
     * @param {'sign-in' | 'sign-up'} screenHint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getAuthURL = function (screenHint, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAuthURL(screenHint, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Requires authentication. Protected route.
     * @summary Get billing plans for the Automated Workflows provider. Returns a list of available plans assignable to users.
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getAutomatedWorkflowBillingPlans = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAutomatedWorkflowBillingPlans(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Used for development purposes
     * @summary Get billing provider route
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getBillingUuid = function (uuid, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getBillingUuid(uuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get brand persona for a specific workspace
     * @summary Get brand persona for a specific workspace
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getBrandPersona = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getBrandPersona(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get campaign.access
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignAccess = function (campaignId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignAccess(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check if its possible create a campaign
     * @summary Campaign checkpoint
     * @param {string} folderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignCheckpoint = function (folderId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignCheckpoint(folderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a Gif for a campaign
     * @summary Get a Gif for a campaign
     * @param {string} campaignId
     * @param {number} [start]
     * @param {number} [end]
     * @param {string} [width]
     * @param {string} [height]
     * @param {string} [fps]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignIdGif = function (campaignId, start, end, width, height, fps, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignIdGif(campaignId, start, end, width, height, fps, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Used for previews on Dynamic Edit page
     * @summary Get campaign preview for dynamic campaign.
     * @param {string} campaignId
     * @param {string} dynamicId
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignPreviewForDv = function (campaignId, dynamicId, workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignPreviewForDv(campaignId, dynamicId, workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Campaign stats
     * @summary Get Campaign stats
     * @param {string} campaignId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignStats = function (campaignId, limit, offset, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignStats(campaignId, limit, offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Campaign stats in CSV file
     * @summary Get Campaign stats in CSV file
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignStatsCsv = function (campaignId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignStatsCsv(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the Campaign thumbnail by the campaignId
     * @summary Campaign thumbnail by campaign id
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignThumbnail = function (campaignId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignThumbnail(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the Campaign thumbnail urls by the campaignId
     * @summary Campaign thumbnail urls by campaign id
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignThumbnailsUrls = function (campaignId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignThumbnailsUrls(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all of the Reactions for a campaign
     * @summary Campaign Reactions Route
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignsCampaignidReactions = function (campaignId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignsCampaignidReactions(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the Campaign by the campaignId
     * @summary Campaign Get By Id Route
     * @param {string} campaignId
     * @param {boolean} [useProtectedThumbnail]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignsId = function (campaignId, useProtectedThumbnail, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignsId(campaignId, useProtectedThumbnail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the Campaign public information by the campaignId
     * @summary Campaign Get By Id Route
     * @param {string} id
     * @param {boolean} [sendsparkAppRendering]
     * @param {string} [host]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignsIdPublic = function (id, sendsparkAppRendering, host, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignsIdPublic(id, sendsparkAppRendering, host, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a oembed json
     * @summary Generate Oembed Service
     * @param {string} url
     * @param {string} [queryParam]
     * @param {number} [maxheight]
     * @param {string} [companyname]
     * @param {string} [firstname]
     * @param {string} [jobtitle]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignsOembed = function (url, queryParam, maxheight, companyname, firstname, jobtitle, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignsOembed(url, queryParam, maxheight, companyname, firstname, jobtitle, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all campaign templates by a folder id
     * @summary Campaigns Templates Route
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCampaignsTemplates = function (offset, limit, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCampaignsTemplates(offset, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get captions availables
     * @summary Get captions availables
     * @param {string} [assetId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCaptionsAvailables = function (assetId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCaptionsAvailables(assetId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Requires a valid automated workflow user to be created first. Protected route.
     * @summary Get all connections from an user in the automated workflow provider.
     * @param {string} xAwToken A custom header for authentication purposes
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getConnectionUserAutomatedWorkflow = function (xAwToken, workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getConnectionUserAutomatedWorkflow(xAwToken, workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get available CRM dynamic variables
     * @summary Get available CRM dynamic variables
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCrmDynamicVariables = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCrmDynamicVariables(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get crm shortcuts list, only current selected by user
     * @summary Get crm shortcuts list, only current selected by user
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCrmShortcutsSelectedUserId = function (userId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCrmShortcutsSelectedUserId(userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the Campaign thumbnail information by the campaignId
     * @summary Campaign Thumbnail Info Get Route
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDvv2V1CampaignsCampaignidThumbnailinfo = function (campaignId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDvv2V1CampaignsCampaignidThumbnailinfo(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Dynamic Campaign stats
     * @summary Get Dynamic Campaign stats
     * @param {string} dynamicId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDynamicCampaignStats = function (dynamicId, limit, offset, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDynamicCampaignStats(dynamicId, limit, offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Dynamic Campaign stats in CSV file
     * @summary Get Dynamic Campaign stats in CSV file
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDynamicCampaignStatsCsv = function (dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDynamicCampaignStatsCsv(dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Dynamic Campaign stats summary
     * @summary Get Dynamic Campaign stats summary
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDynamicCampaignStatsSummary = function (dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDynamicCampaignStatsSummary(dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the list of Dynamic Campaigns by workspace
     * @summary Get the list of Dynamic Campaigns by workspace
     * @param {string} workspaceId
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {string} [filters]
     * @param {string} [search]
     * @param {boolean} [dropdownRendering]
     * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
     * @param {'asc' | 'desc'} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDynamicsList = function (workspaceId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDynamicsList(workspaceId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get dynamics settings
     * @summary Get dynamics settings
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDynamicsSettings = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDynamicsSettings(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the list of videos from Dynamic Campaigns by campaignId
     * @summary Get the list of videos from Dynamic Campaigns by campaignId
     * @param {string} workspaceId
     * @param {string} dynamicsId
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {string} [filters]
     * @param {string} [search]
     * @param {boolean} [dropdownRendering]
     * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
     * @param {'asc' | 'desc'} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDynamicsVideosList = function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDynamicsVideosList(workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the list of prospects from Dynamic Campaigns by campaignId
     * @summary Get the list of prospects from Dynamic Campaigns by campaignId
     * @param {string} workspaceId
     * @param {string} dynamicsId
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {string} [filters]
     * @param {string} [search]
     * @param {boolean} [dropdownRendering]
     * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
     * @param {'asc' | 'desc'} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDynamicsVideosListV3 = function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDynamicsVideosListV3(workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the list of prospects from Dynamic Campaigns in CSV file by campaignId
     * @summary Get the list of prospects from Dynamic Campaigns in CSV file by campaignId
     * @param {string} workspaceId
     * @param {string} dynamicsId
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {string} [filters]
     * @param {string} [search]
     * @param {boolean} [dropdownRendering]
     * @param {'DEFAULT' | 'DETAILED' | 'MINIMAL'} [projectionType]
     * @param {'asc' | 'desc'} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getDynamicsVideosListV3CSV = function (workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDynamicsVideosListV3CSV(workspaceId, dynamicsId, offset, limit, filters, search, dropdownRendering, projectionType, sortOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get available embed calendars integrations
     * @summary Get available embed calendars integrations
     * @param {string} workspaceId
     * @param {string} [provider]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getEmbedCalendars = function (workspaceId, provider, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getEmbedCalendars(workspaceId, provider, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of campaigns by folder id
     * @summary Folders Route
     * @param {string} workspaceId
     * @param {string} folderId
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {'createdAt' | 'createdAtAscendant' | 'alphabetical'} [orderby]
     * @param {string} [filter]
     * @param {string} [creators]
     * @param {boolean} [ignoreEmptyVideo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getFolderCampaignList = function (workspaceId, folderId, offset, limit, orderby, filter, creators, ignoreEmptyVideo, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getFolderCampaignList(workspaceId, folderId, offset, limit, orderby, filter, creators, ignoreEmptyVideo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the creators from a folder
     * @summary Creators Folders Route
     * @param {string} workspaceId
     * @param {string} folderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getFolderCreators = function (workspaceId, folderId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getFolderCreators(workspaceId, folderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all of the campaigns by a folder id
     * @summary Folders Route
     * @param {string} folderId
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getFoldersFolderidCampaigns = function (folderId, offset, limit, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getFoldersFolderidCampaigns(folderId, offset, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all of the folders belongs to a user - deprecated dasboard v1
     * @summary Legacy Folders Route
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getFoldersWorkspaceid = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getFoldersWorkspaceid(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a health message
     * @summary Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getHealth = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getHealth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns Hubspot Sendspark APP OAuth URL.
     * @summary Returns Hubspot Sendspark APP OAuth URL.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getHubspotOauthUrl = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getHubspotOauthUrl(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * GET current workspace integrations
     * @summary Get your current workspace integrations
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getIntegrationsWorkspaceid = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getIntegrationsWorkspaceid(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get key value from caches
     * @summary Get key value from caches
     * @param {string} key
     * @param {string} segment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getKeyFromCache = function (key, segment, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getKeyFromCache(key, segment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This route delete the cookie for the users session
     * @summary Logout Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getLogout = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getLogout(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Onboarding checklist
     * @summary Get Onboarding checklist
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getOnboardingChecklist = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getOnboardingChecklist(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get prospect data from prospect email
     * @summary Get prospect data from prospect email
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {string} contactEmail
     * @param {string} [include] Comma-separated list of additional fields to include in the response (emailEmbedHTML, fields)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getProspectDynamicsVideos = function (workspaceId, dynamicId, contactEmail, include, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getProspectDynamicsVideos(workspaceId, dynamicId, contactEmail, include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get public template info
     * @param {string} workspaceId
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getPublicTemplate = function (workspaceId, templateId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getPublicTemplate(workspaceId, templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all of the Reactions
     * @summary Reactions Route
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getReactionsId = function (id, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getReactionsId(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get public share preview
     * @param {string} workspaceId
     * @param {'template' | 'dynamic-video' | 'campaign' | 'workspace'} previewType
     * @param {string} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getSharePreview = function (workspaceId, previewType, id, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSharePreview(workspaceId, previewType, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get available subscription churn reason codes route
     * @summary Get available subscription churn reason codes route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getSubscriptionCancellationReasons = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSubscriptionCancellationReasons(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Do not use this endpoint to get normal subscription previews, just for trial previews
     * @summary Get subscription for trial previews only
     * @param {string} workspaceId
     * @param {SubscriptionPreviewTrialPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getSubscriptionsPreviewTrial = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSubscriptionsPreviewTrial(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get subscription previews route
     * @summary Get subscription previews route
     * @param {string} workspaceId
     * @param {SubscriptionPreviewsPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getSubscriptionsPreviews = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSubscriptionsPreviews(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get available subscriptions types list route
     * @summary Get available subscriptions types list route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getSubscriptionsTypesList = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSubscriptionsTypesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace usage transactions balance
     * @summary Get workspace usage transactions balance
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getTransactionsBalance = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getTransactionsBalance(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get share url from dynamic video prospect email
     * @summary Get share url from dynamic video prospect email
     * @param {string} xApiKey
     * @param {string} prospectEmail
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getUrlProspectDynamics = function (xApiKey, prospectEmail, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getUrlProspectDynamics(xApiKey, prospectEmail, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Requires a valid Sendspark user to be created first. Protected route.
     * @summary Get an user to the Automated Workflows provider. Returns a valid user object for the Automated Workflows provider.
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getUserAutomatedWorkflow = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getUserAutomatedWorkflow(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get site connections list, only current selected by user
     * @summary Get site connections list available by user Route.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getUserSiteConnectionsList = function (userId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getUserSiteConnectionsList(userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * GET current user route
     * @summary Get your current user route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getUsers = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getUsers(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Webhook called when transcription process is complete
     * @summary Webhook called when transcription process is complete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getV1AiTranscriptionWebhookUpdate = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getV1AiTranscriptionWebhookUpdate(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Google login route
     * @summary Google Login Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getV1GoogleLogin = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getV1GoogleLogin(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the Campaign by the requestId
     * @summary Get Campaign By request id Route
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getVideoRequestByRequestId = function (id, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getVideoRequestByRequestId(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Webhook by ID
     * @summary Get Webhook by ID
     * @param {string} workspaceId
     * @param {string} webhookId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWebhookById = function (workspaceId, webhookId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebhookById(workspaceId, webhookId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Webhook list by workspace ID
     * @summary Get Webhook list by workspace ID
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWebhookListByWorkspaceId = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebhookListByWorkspaceId(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace id by api key
     * @summary Get workspace id by api key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaceByApiKey = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspaceByApiKey(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspce custom domain
     * @summary Get workspce custom domain
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaceCustomDomain = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspaceCustomDomain(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace dynamic campaign
     * @summary Get workspace dynamic campaign
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaceDynamics = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspaceDynamics(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get creators from workspace dynamic campaign
     * @summary Get creators from workspace dynamic campaign
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaceDynamicsCreators = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspaceDynamicsCreators(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace global styles route by workspace id.
     * @summary Get workspace global styles route.
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaceGlobalStyles = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspaceGlobalStyles(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Search for campaigns inside a workspace
     * @summary Workspace Campaign Search Route
     * @param {string} workspaceId
     * @param {string} search
     * @param {boolean} [skipRequestCampaigns]
     * @param {boolean} [skipCustomIntroCampaigns]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaceSearch = function (workspaceId, search, skipRequestCampaigns, skipCustomIntroCampaigns, offset, limit, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspaceSearch(workspaceId, search, skipRequestCampaigns, skipCustomIntroCampaigns, offset, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns stats of the workspace
     * @param {string} workspaceId
     * @param {boolean} [legacy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaceStats = function (workspaceId, legacy, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspaceStats(workspaceId, legacy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace subscription
     * @summary Get workspace subscription
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaceSubscription = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspaceSubscription(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace template
     * @summary Get workspace template
     * @param {string} workspaceId
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaceTemplate = function (workspaceId, templateId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspaceTemplate(workspaceId, templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace templates by workspace id
     * @summary Get workspace templates by workspace id
     * @param {string} workspaceId
     * @param {string} [name]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {string} [appLatest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaceTemplates = function (workspaceId, name, offset, limit, appLatest, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspaceTemplates(workspaceId, name, offset, limit, appLatest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the list of the current users workspaces
     * @summary Get the list of the current users workspaces
     * @param {boolean} [dropdownRendering]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspaces = function (dropdownRendering, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspaces(dropdownRendering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace by id
     * @summary Get workspace by id
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesId = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspacesId(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Optionally we can pass the userId, it will default to currentUser V1
     * @summary Get the current users workspace settings. V1
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesSettings = function (userId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspacesSettings(userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the legacy current users workspace usage.
     * @param {'all' | 'videos' | 'users'} usageType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesUsage = function (usageType, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspacesUsage(usageType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the list of the assets
     * @summary Get the list of the assets
     * @param {string} workspaceId
     * @param {string} [folder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesWorkspaceidAssets = function (workspaceId, folder, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspacesWorkspaceidAssets(workspaceId, folder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns stats of the workspace
     * @summary Returns stats of the workspace
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesWorkspaceidCreatedvideos = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspacesWorkspaceidCreatedvideos(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns stats of the workspace
     * @summary Returns stats of the workspace
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesWorkspaceidCreatedvideosv2 = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspacesWorkspaceidCreatedvideosv2(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the workspace folders that the user has access
     * @summary Workspace Folders Route
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesWorkspaceidFolders = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspacesWorkspaceidFolders(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the workspace main folders that the user has access
     * @summary Workspace Main Folders Route
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesWorkspaceidFoldersMain = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspacesWorkspaceidFoldersMain(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns stats of the workspace
     * @param {string} workspaceId
     * @param {number} usersNumber
     * @param {boolean} [legacy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getWorkspacesWorkspaceidTopvideosUsersnumber = function (workspaceId, usersNumber, legacy, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspacesWorkspaceidTopvideosUsersnumber(workspaceId, usersNumber, legacy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a health message
     * @summary Health Check. Requires authentication.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.healthCheckProtected = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).healthCheckProtected(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saves Hubspot oauth tokens and returns 200
     * @summary Hubspot oauth callback endpoint. Saves Hubspot oauth tokens and returns 200.
     * @param {string} [code]
     * @param {string} [state]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.hubspotOauthCallback = function (code, state, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).hubspotOauthCallback(code, state, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns an array of objects with all the templates available for generating AI Script templates.
     * @summary List AI Script Templates Options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.listAiTemplatesOptions = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listAiTemplatesOptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Logout user route
     * @summary Logout current user from all tabs
     * @param {UserLogoutPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.logoutUser = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).logoutUser(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Only support name change and language code change.
     * @summary Use this route to update an asset information.
     * @param {string} assetId
     * @param {AssetPatchPatamsSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchAsset = function (assetId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchAsset(assetId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the brand persona details for the specified workspace
     * @summary Update brand persona for a specific workspace
     * @param {string} workspaceId
     * @param {BrandPersona} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchBrandPersona = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchBrandPersona(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Send an array with a valid asset id to create a Custom Intro campaign for it, or send and empty array to remove it.
     * @summary Used for custom Intros feature
     * @param {string} campaignId
     * @param {CampaignPatchAssetsPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchCampaignAssets = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchCampaignAssets(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Campaign assets restore
     * @summary Campaign assets restore
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchCampaignAssetsRestore = function (campaignId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchCampaignAssetsRestore(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Campaign assets trim
     * @summary Campaign assets trim
     * @param {string} campaignId
     * @param {RequestPayloadCampaignAssetsTrimSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchCampaignAssetsTrim = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchCampaignAssetsTrim(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *            Use for patch campaign assets                      If you need remove all additional assets, you need to send one asset at least (position 0 asset)
     * @summary Campaign assets add
     * @param {string} campaignId
     * @param {RequestCampaignPatchAssetsPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchCampaignAssetsV2 = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchCampaignAssetsV2(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Move campaigns within a folder
     * @summary Move Campaigns action
     * @param {string} folderId
     * @param {RequestPayloadDeleteCampaignsSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchCampaignMove = function (folderId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchCampaignMove(folderId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a campaign settings by Id Route
     * @param {string} campaignId
     * @param {Model81} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchCampaignSettingsId = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchCampaignSettingsId(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Use this route to apply a given template to the campaign
     * @summary Apply template fields to a campaign
     * @param {string} campaignId
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchCampaignTemplateApply = function (campaignId, templateId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchCampaignTemplateApply(campaignId, templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update campaign thumbnail by the campaign id
     * @summary Update campaign thumbnail by campaign id
     * @param {string} campaignId
     * @param {PatchPayloadCampaignThumbnailsSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchCampaignThumbnail = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchCampaignThumbnail(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a campaign By Id Route
     * @param {string} campaignId
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchCampaignsId = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchCampaignsId(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Insert or update prospect in Dynamics Campaign
     * @summary Insert or update prospect in Dynamics Campaign
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {RequestPayloadDynamicModifyProspectSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchDynamicModifyProspect = function (workspaceId, dynamicId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchDynamicModifyProspect(workspaceId, dynamicId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update settings in Dynamics Campaign
     * @summary Update settings in Dynamics Campaign
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {RequestPayloadDynamicModifySettingsSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchDynamicModifySettings = function (workspaceId, dynamicId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchDynamicModifySettings(workspaceId, dynamicId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Modify Dynamics Campaign in folder
     * @summary Modify Dynamics Campaign
     * @param {string} workspaceId
     * @param {string} dynamicsId
     * @param {RequestPayloadModifyDynamicsCampaignsSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchDynamicsModify = function (workspaceId, dynamicsId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchDynamicsModify(workspaceId, dynamicsId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Persisting Prospect Lists
     * @summary Persisting Prospect Lists
     * @param {string} workspaceId
     * @param {string} dynamicsId
     * @param {Model93} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchDynamicsModifyV2 = function (workspaceId, dynamicsId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchDynamicsModifyV2(workspaceId, dynamicsId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint is used to bulk update prospect background URLs based on email domains.
     * @summary Bulk update prospect background URLs based on email domains.
     * @param {string} workspaceId
     * @param {string} dynamicsId
     * @param {RequestPayloadBulkUpdateProspectsUrlSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchDynamicsProspectsUrlsBulkUpdate = function (workspaceId, dynamicsId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchDynamicsProspectsUrlsBulkUpdate(workspaceId, dynamicsId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Modify a folder name, more in the future.
     * @summary Folder Modify Route
     * @param {string} workspaceId
     * @param {string} folderId
     * @param {FolderModifyRequestpayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchFoldersModify = function (workspaceId, folderId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchFoldersModify(workspaceId, folderId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Move a folder within a workspace
     * @summary Move Folder action
     * @param {string} workspaceId
     * @param {string} folderId
     * @param {FolderMoveRequestPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchFoldersMove = function (workspaceId, folderId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchFoldersMove(workspaceId, folderId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Modify Webhook
     * @summary Modify Webhook
     * @param {string} workspaceId
     * @param {string} webhookId
     * @param {ModifyWebhookRequestPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchModifyWebhook = function (workspaceId, webhookId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchModifyWebhook(workspaceId, webhookId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update user or workspace onboarding checklist
     * @summary Update user or workspace onboarding checklist
     * @param {string} workspaceId
     * @param {ResponseOnboardingUpdatePayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchOnboardingChecklist = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchOnboardingChecklist(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Only support uploading status change.
     * @summary Use this route to update the uploadingStatus of the asset.
     * @param {string} assetId
     * @param {AssetPatchUploadStatusPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchUploadStatusAsset = function (assetId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchUploadStatusAsset(assetId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update user crm shortcuts selected
     * @summary Update user crm shortcuts selected
     * @param {string} userId
     * @param {CrmShortcutsModifyPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchUserCrmShortcuts = function (userId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchUserCrmShortcuts(userId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update instant integrations from user
     * @summary Update instant integrations from user
     * @param {InstantIntegrationModifyPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchUserInstantIntegrations = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchUserInstantIntegrations(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Route for users to modify their private site credentials route.
     * @summary Modify user private site credentials Route
     * @param {string} userId
     * @param {string} integrationId
     * @param {ModifyUserSiteConnectionsPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchUserSiteConnections = function (userId, integrationId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchUserSiteConnections(userId, integrationId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Google login route
     * @summary Google Login Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchV1GoogleLogin = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchV1GoogleLogin(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Modify workspace global styles route by workspace id.
     * @summary Modify workspace global styles route.
     * @param {string} workspaceId
     * @param {WorkspaceStylesModifyPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchWorkspaceGlobalStyles = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchWorkspaceGlobalStyles(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a workspace integration
     * @summary Update a workspace integration
     * @param {string} workspaceId
     * @param {string} integrationId
     * @param {Values} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchWorkspaceIntegrations = function (workspaceId, integrationId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchWorkspaceIntegrations(workspaceId, integrationId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Cancel a workspace subscription at the end of period
     * @summary Cancel a workspace subscription at the end of period
     * @param {string} workspaceId
     * @param {SubscriptionCancelPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchWorkspaceSubscriptionCancel = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchWorkspaceSubscriptionCancel(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Reactivate a workspace subscription canceled or pending cancellation status
     * @summary Reactivate a workspace subscription canceled or pending cancellation status
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchWorkspaceSubscriptionReactivate = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchWorkspaceSubscriptionReactivate(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Modify workspace template
     * @summary Modify workspace template
     * @param {string} workspaceId
     * @param {string} templateId
     * @param {WorkspaceTemplatesModifyPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchWorkspaceTemplates = function (workspaceId, templateId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchWorkspaceTemplates(workspaceId, templateId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add additional features to workspace by owners
     * @param {'storage' | 'workspaces' | 'videos' | 'creators'} feature
     * @param {'double'} value
     * @param {WorkspaceAdditionalFeaturesSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchWorkspacesAdditionalfeatures = function (feature, value, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchWorkspacesAdditionalfeatures(feature, value, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace by id
     * @summary Get workspace by id
     * @param {string} workspaceId
     * @param {RequestWorkspacesModifyPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchWorkspacesId = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchWorkspacesId(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Replace the current users last visited workspace with the id provided.
     * @summary Replace the current users last visited workspace with the id provided.
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.patchWorkspacesIdChange = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchWorkspacesIdChange(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get scripts improvement
     * @summary Get scripts improvement
     * @param {AiScriptGeneratorParamsSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postAiScriptsGenerator = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postAiScriptsGenerator(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Start process to transcript a video
     * @summary Start process to transcript a video
     * @param {string} assetId
     * @param {TranscriptPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postAiTranscriptionCreate = function (assetId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postAiTranscriptionCreate(assetId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate a valid JWT for our AppSumo intergration
     * @summary Returns a valid JWT for AppSumo intergration
     * @param {AppSumoLoginPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postAppsumoAuthLogin = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postAppsumoAuthLogin(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * When a Sumo-ling buys interacts with our license, we get a notification
     * @summary AppSumo notifications
     * @param {AppSumoNotificationPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postAppsumoWebhookNotification = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postAppsumoWebhookNotification(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create assets
     * @summary Create assets Route
     * @param {CreateAssetPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postAssets = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postAssets(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Forgot Password Route
     * @param {ForgotPasswordPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postAuthForgotpassword = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postAuthForgotpassword(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Authorize Device for user
     * @summary Authorize Device
     * @param {string} deviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postAuthorizeDevice = function (deviceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postAuthorizeDevice(deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create Campaign in folder
     * @summary Create Campaign
     * @param {string} folderId
     * @param {RequestPayloadCreateCampaignsSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postCampaign = function (folderId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postCampaign(folderId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new Reaction to a Campaign Video
     * @summary Create a new Reaction
     * @param {string} campaignId
     * @param {CampaignReactionPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postCampaignsCampaignidReactions = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postCampaignsCampaignidReactions(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the Campaign by the campaignId
     * @summary Duplicate Campaign
     * @param {string} campaignId
     * @param {RequestPayloadDuplicateCreateCampaignSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postCampaignsDuplicate = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postCampaignsDuplicate(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates/create the Campaign thumbnails by asset
     * @summary Load Campaign Thumbnails
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postCampaignsLoadThumbnails = function (campaignId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postCampaignsLoadThumbnails(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new Campaign based on a Template
     * @summary Create a new Campaign based on a Template
     * @param {string} campaignId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postCampaignsUseTemplate = function (campaignId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postCampaignsUseTemplate(campaignId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Being used for update changes in subscriptions (database).
     * @summary Webhook to get an event when an subscription change.
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postChargifyWebhooksSubscriptionsToken = function (token, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postChargifyWebhooksSubscriptionsToken(token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Clear key cache
     * @summary Clear key cache
     * @param {string} key
     * @param {string} segment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postClearKeyCache = function (key, segment, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postClearKeyCache(key, segment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new Webhook
     * @summary Create new Webhook
     * @param {string} workspaceId
     * @param {CreateWebhookRequestPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postCreateWebhook = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postCreateWebhook(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create Dynamics Campaign in folder
     * @summary Create Dynamics Campaign
     * @param {string} workspaceId
     * @param {RequestParamsCreateDynamicsCampaignsSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamics = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamics(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Duplicate Dynamic Campaign by the dynamicsId
     * @summary Duplicate Dynamic Campaign
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsDuplicate = function (dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsDuplicate(dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Listed in API Gateway only.
     * @summary Bulk add and process prospects to a dynamics campaign.
     * @param {string} workspaceId
     * @param {string} dynamicsId
     * @param {RequestPayloadBulkProspectsDynamicsCampaignsSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsProspectsBulkModify = function (workspaceId, dynamicsId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsProspectsBulkModify(workspaceId, dynamicsId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create Dynamics Campaign in folder for the DV by steps UI
     * @summary Create Dynamics Campaign for the DV by steps UI
     * @param {string} workspaceId
     * @param {Model67} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsV2 = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsV2(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add dynamic video to Dynamics Campaign in folder
     * @summary Add dynamic video to Dynamics Campaign
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {RequestParamsDynamicsVideoAddSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideoAdd = function (workspaceId, dynamicId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideoAdd(workspaceId, dynamicId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate videos for Dynamics Campaign prospect list
     * @summary Generate videos for Dynamics Campaign prospect list
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideoBulk = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideoBulk(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new campaigns for Dynamics Video prospect list
     * @summary Create new campaigns for Dynamics Video prospect list
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosCreateCampaign = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosCreateCampaign(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get screenshot by web site url
     * @summary Get screenshot by web site url
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosCreateScreenshot = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosCreateScreenshot(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get screenshot by web site url v2
     * @summary Get screenshot by web site url v2
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosCreateScreenshotV2 = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosCreateScreenshotV2(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate audio cloned from prospect
     * @summary Generate audio cloned from prospect
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosGenerateAudioRouteV2 = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosGenerateAudioRouteV2(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate campaign by dynamics videos v2
     * @summary Generate campaign by dynamics videos v2
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosGenerateCampaignV2 = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosGenerateCampaignV2(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate lipsync by dynamics videos v2
     * @summary Generate lipsync by dynamics videos v2
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosGenerateLipsyncV2 = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosGenerateLipsyncV2(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate resources for dynamics campaign
     * @summary Generate resources for dynamics campaign
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {RequestPayloadGenerateDynamicsResourceSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosGenerateResourcesV2 = function (workspaceId, dynamicId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosGenerateResourcesV2(workspaceId, dynamicId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get transcription by dynamics videos v2
     * @summary Get transcription by dynamics videos v2
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosGenerateTranscriptionV2 = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosGenerateTranscriptionV2(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate trim video from prospect
     * @summary Generate trim video from prospect
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosGenerateTrimVideoRouteV2 = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosGenerateTrimVideoRouteV2(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate video by dynamics videos v2
     * @summary Generate video by dynamics videos v2
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosGenerateVideoV2 = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosGenerateVideoV2(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate voice cloned from dynamics
     * @summary Generate voice cloned from dynamics
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosGenerateVoiceV2 = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosGenerateVoiceV2(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Guardian by Dynamics Videos
     * @summary Guardian by Dynamics Videos
     * @param {DynamicsVideosGuardianPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosGuardian = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosGuardian(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This route is used to migrate the prospectList property from the Dynamics collection to the Prospects collection.
     * @summary Migration of prospectList property from Dynamics collection to Prospects collection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosProspectsMigration = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosProspectsMigration(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Queues recovery by Dynamics Videos
     * @summary Queues recovery by Dynamics Videos
     * @param {string} dynamicId
     * @param {DynamicsVideosRecoveryPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postDynamicsVideosQueuesRecovery = function (dynamicId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postDynamicsVideosQueuesRecovery(dynamicId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This receive an open object that containts the data we have to track
     * @summary Sendspark event to track user activity
     * @param {EventPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postEvents = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postEvents(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a folder inside a workspace
     * @summary Folder Create Route
     * @param {string} workspaceId
     * @param {FolderCreateRequestPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postFoldersCreate = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postFoldersCreate(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Move multiple folders to another folder
     * @summary Move multiple folders to another folder
     * @param {string} workspaceId
     * @param {string} folderId
     * @param {RequestFolderMoveMultiplePayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postFoldersMoveMultiple = function (workspaceId, folderId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postFoldersMoveMultiple(workspaceId, folderId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Load Thumbnails legacy from API v1
     * @summary Load Thumbnails legacy from API v1
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postLoadThumbnailsLegacy = function (id, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postLoadThumbnailsLegacy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Register new logger event
     * @summary Register new logger event
     * @param {LoggerRequestSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postLogger = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postLogger(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * User Login Route that returns a valid JTW
     * @summary Login Route
     * @param {LoginPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postLogin = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postLogin(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Logout Desktop App for user
     * @summary Logout Device
     * @param {string} deviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postLogoutDevice = function (deviceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postLogoutDevice(deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Being used for websockets to push events to the frontend.
     * @summary Webhook to get an event when an the asset is ready.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postMuxWebhookVideoready = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postMuxWebhookVideoready(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Request a new Video Campaign for the workspace passed as parameter
     * @summary Request Video Campaign
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postRequestCampaign = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postRequestCampaign(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace additional usage transactions purchase preview
     * @summary Get workspace additional usage transactions purchase preview
     * @param {string} workspaceId
     * @param {boolean} [generateFirstVideos]
     * @param {TransactionsPreviewPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postTransactionsPreview = function (workspaceId, generateFirstVideos, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postTransactionsPreview(workspaceId, generateFirstVideos, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace additional usage transactions purchase
     * @summary Make workspace additional usage transactions purchase
     * @param {string} workspaceId
     * @param {TransactionsPurchasePayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postTransactionsPurchase = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postTransactionsPurchase(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new Upload Url
     * @summary Create new Upload Url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postUploadUrl = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postUploadUrl(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Clean Upload Urls expired
     * @summary Clean Upload Urls expired
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postUploadUrlCleanExpired = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postUploadUrlCleanExpired(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Route for users to store their private site credentials route.
     * @summary Create user private site credentials Route.
     * @param {string} userId
     * @param {CreateUserSiteConnectionsPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postUserSiteConnections = function (userId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postUserSiteConnections(userId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add meeting links for the user passed as parameter
     * @summary Create meeting links for user
     * @param {string} userId
     * @param {UsersMeetingLinksPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postUsersMeetingLinks = function (userId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postUsersMeetingLinks(userId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Brand Persona test
     * @summary Brand Persona test
     * @param {Model53} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postV1AiBrandpersonagenerator = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postV1AiBrandpersonagenerator(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a customized email template using AI by processing a previously generated video script template
     * @summary Generates an email template based on a video script template
     * @param {Model54} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postV1AiEmailtemplategenerator = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postV1AiEmailtemplategenerator(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Takes an AI-generated email template and creates a matching landing page template maintaining consistent messaging and branding
     * @summary Generates a landing page template based on an existing email template
     * @param {Model55} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postV1AiLandingpagetemplategenerator = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postV1AiLandingpagetemplategenerator(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Webhook called when transcription process is complete
     * @summary Webhook called when transcription process is complete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postV1AiTranscriptionWebhookUpdate = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postV1AiTranscriptionWebhookUpdate(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Google login route
     * @summary Google Login Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postV1GoogleLogin = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postV1GoogleLogin(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate videos for Dynamics Campaign prospect list
     * @summary Generate videos for Dynamics Campaign prospect list
     * @param {string} workspaceId
     * @param {string} dynamicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postV1WorkspacesWorkspaceidDynamicsDynamicidBulk = function (workspaceId, dynamicId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postV1WorkspacesWorkspaceidDynamicsDynamicidBulk(workspaceId, dynamicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * API Gateway only.
     * @summary Add prospect to Dynamics Campaign and process video.
     * @param {string} workspaceId
     * @param {string} dynamicsId
     * @param {RequestPayloadAddProspectsDynamicsCampaignsSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postV1WorkspacesWorkspaceidDynamicsDynamicsidProspect = function (workspaceId, dynamicsId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postV1WorkspacesWorkspaceidDynamicsDynamicsidProspect(workspaceId, dynamicsId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new workspace integration
     * @param {string} workspaceId
     * @param {WorkspaceIntegrationsCreatePayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postWorkspaceIntegrations = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postWorkspaceIntegrations(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create or switch workspace subscription
     * @summary Create or switch workspace subscription
     * @param {string} workspaceId
     * @param {WorkspaceSubscriptionCreatePayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postWorkspaceSubscription = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postWorkspaceSubscription(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Apply discount on subscription
     * @summary Apply discount on subscription
     * @param {string} workspaceId
     * @param {WorkspaceSubscriptionApplyDiscountRequestSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postWorkspaceSubscriptionApplyDiscount = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postWorkspaceSubscriptionApplyDiscount(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Apply discount on onboarding process
     * @summary Apply discount on onboarding process
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postWorkspaceSubscriptionApplyOnboardingDiscount = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postWorkspaceSubscriptionApplyOnboardingDiscount(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new workspace template
     * @summary Create a new workspace template
     * @param {string} workspaceId
     * @param {WorkspaceTemplatesCreatePayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postWorkspaceTemplates = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postWorkspaceTemplates(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Optionally we can pass the userId, it will default to currentUser
     * @summary Create a new workspace
     * @param {CreateWorkspaceResponseSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postWorkspaces = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postWorkspaces(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get workspace by id
     * @summary Create custom domain to workspace
     * @param {string} workspaceId
     * @param {WorkspaceCustomDomainCreatePayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postWorkspacesWorkspaceidCustomdomain = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postWorkspacesWorkspaceidCustomdomain(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * We need pass the emails to invite to this route
     * @summary Workspace invite route
     * @param {string} workspaceId
     * @param {WorkspaceInvitePayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.postWorkspacesWorkspaceidInvite = function (workspaceId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postWorkspacesWorkspaceidInvite(workspaceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Queues recovery by prospectId
     * @summary Queues to check if prospect is healthy
     * @param {string} prospectId Prospect ID
     * @param {string} dynamicId
     * @param {Model73} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.prospectsHealthyQueues = function (prospectId, dynamicId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).prospectsHealthyQueues(prospectId, dynamicId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Completes the activation for appsumo packages.
     * @param {AppSumoActivationPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.putAppsumoActivation = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).putAppsumoActivation(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update asset mime type
     * @summary Update mime type for an asset
     * @param {string} assetId
     * @param {UpdateAssetPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.putAssetsIdMime = function (assetId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).putAssetsIdMime(assetId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Google login route
     * @summary Google Login Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.putV1GoogleLogin = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).putV1GoogleLogin(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a campaign By Request Id Route
     * @param {string} requestId
     * @param {VideoRequestPayloadSchema} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.putVideoRequestById = function (requestId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).putVideoRequestById(requestId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Requires a valid Sendspark user to be created first. Protected route.
     * @summary Get an user refresh token for the Automated Workflows provider. Returns a valid user session token for the Automated Workflows provider.
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.refreshTokenUserAutomatedWorkflow = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).refreshTokenUserAutomatedWorkflow(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Requires a valid Sendspark user to be created first. Protected route.
     * @summary Register an user to the Automated Workflows provider. Returns a valid user object for the Automated Workflows provider.
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.registerUserAutomatedWorkflow = function (workspaceId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).registerUserAutomatedWorkflow(workspaceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get total videos by workspace
     * @summary Get total videos by workspace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.reportTotalVideosByWorkspace = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).reportTotalVideosByWorkspace(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Validate access to reports
     * @summary Validate access to reports
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.reportValidateAccess = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).reportValidateAccess(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Patch Campaign Summary Views
     * @summary Patch Campaign Summary Views
     * @param {string} campaignId
     * @param {Model83} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateCampaignSummaryViews = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateCampaignSummaryViews(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a campaign video Id by campaign Id Route
     * @param {string} campaignId
     * @param {PayloadCampaignVideo} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateCampaignVideoId = function (campaignId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateCampaignVideoId(campaignId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * PATCH current user route
     * @summary Modify current user logged in route
     * @param {UserModifyPayload} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateCurrentUser = function (body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateCurrentUser(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary WorkOs Webhook Listener route.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.workosEventsListener = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).workosEventsListener(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
